const svgs = {
  // Missing fail whale
  _missing: () => (
    <path d="M10.27,19.38a13.85,13.85,0,0,0,1.63-.16,3.77,3.77,0,0,1-1-1.27L10,18l-.95,0A4,4,0,0,0,10.27,19.38Zm4.93-1.14c.4-.17.77-.36,1.12-.55-.15-.17-.27-.35-.37-.48-.55.14-1.1.27-1.64.37A2,2,0,0,0,15.2,18.24Zm2.89-1.72c-.45.18-.91.33-1.36.47a3.73,3.73,0,0,0,.26.3A11.63,11.63,0,0,0,18.09,16.52ZM13,19c.47-.12.91-.25,1.34-.4a3,3,0,0,1-.8-.9c-.6.09-1.2.16-1.78.2A3.37,3.37,0,0,0,13,19ZM2.61,16.85c-.68-.21-1.27-.42-1.74-.61a14.12,14.12,0,0,0,2.24,1.5C2.88,17.38,2.72,17.06,2.61,16.85Zm5.63,1c-.69,0-1.33-.13-1.93-.22a5.06,5.06,0,0,0,1.31,1.54,13.25,13.25,0,0,0,1.52.15A4.59,4.59,0,0,1,8.24,17.9Zm-2.87-.38q-.93-.18-1.74-.39a6.29,6.29,0,0,0,1,1.32c.54.19,1.09.36,1.63.5A7.42,7.42,0,0,1,5.37,17.52Zm.49-4.3a.5.5,0,1,1,0,1,.5.5,0,0,1,0-1Zm16.83-6V7.11L22.82,7A3.62,3.62,0,0,0,24,4.63a3.27,3.27,0,0,0-2.43,2l-.38,1-.33-1a2.71,2.71,0,0,0-2.61-2,1.78,1.78,0,0,0,1,2.08h0a2.51,2.51,0,0,1,1.39,2.67c-.29,1.88-3.37,2-3.5,2H3.92a3.91,3.91,0,0,0-3,1.12A3.8,3.8,0,0,0,0,15c1.41.67,10.43,4.55,19.81-.08C22.31,12.15,22.69,7.31,22.69,7.26ZM5.86,15.72a2,2,0,1,1,2-2A2,2,0,0,1,5.86,15.72Z" />
  ),
  'arrow-left': () => (
    <>
      <g id="arrow-left">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.43367 4.79297L10.8479 6.20718L6.05499 11.0001H21.9997V13.0001H6.05499L10.8479 17.793L9.43367 19.2072L2.22656 12.0001L9.43367 4.79297Z"
        />
      </g>
    </>
  ),
  'arrow-left-small': () => (
    <>
      <g id="arrow-left-small">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.92678 6.15918L11.341 7.57339L7.91436 11H20.0002V13H7.91436L11.341 16.4266L9.92678 17.8409L4.08594 12L9.92678 6.15918Z"
        />
      </g>
    </>
  ),
  'arrow-right': () => (
    <>
      <g id="arrow-right">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5661 4.79297L13.1518 6.20718L17.9447 11.0001H2V13.0001H17.9447L13.1518 17.793L14.5661 19.2072L21.7732 12.0001L14.5661 4.79297Z"
        />
      </g>
    </>
  ),
  'arrow-right-small': () => (
    <>
      <g id="arrow-right-small">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1593 6.15918L12.7451 7.57339L16.1717 11H4.08594V13H16.1717L12.7451 16.4266L14.1593 17.8409L20.0002 12L14.1593 6.15918Z"
        />
      </g>
    </>
  ),
  'arrow-up': () => (
    <>
      <g id="arrow-up">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.67969 9.32039L6.0939 10.7346L10.8868 5.94171L10.8868 21.8864L12.8868 21.8864L12.8868 5.94171L17.6797 10.7346L19.0939 9.32039L11.8868 2.11328L4.67969 9.32039Z"
        />
      </g>
    </>
  ),
  'arrow-up-small': () => (
    <>
      <g id="arrow-up-small">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.11621 9.88381L7.53042 11.298L10.9571 7.8714V19.9572H12.9571V7.8714L16.3837 11.298L17.7979 9.88381L11.9571 4.04297L6.11621 9.88381Z"
        />
      </g>
    </>
  ),
  'arrow-down': () => (
    <>
      <g id="arrow-down">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.90625 14.6793L6.32046 13.2651L11.1134 18.058V2.11328H13.1134V18.058L17.9062 13.2651L19.3205 14.6793L12.1134 21.8864L4.90625 14.6793Z"
        />
      </g>
    </>
  ),
  'arrow-down-small': () => (
    <>
      <g id="arrow-down-small">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.20215 14.1163L7.61636 12.7021L11.043 16.1288V4.04297H13.043V16.1288L16.4696 12.7021L17.8838 14.1163L12.043 19.9572L6.20215 14.1163Z"
        />
      </g>
    </>
  ),
  'chev-left': () => (
    <>
      <g id="chev-left">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.7091 3L16.1233 4.41421L8.82843 11.7091L16.1233 19.0039L14.7091 20.4181L6 11.7091L14.7091 3Z"
        />
      </g>
    </>
  ),
  'chev-left-double': () => (
    <>
      <g id="chev-left-double">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.7091 3L12.1233 4.41421L4.82843 11.7091L12.1233 19.0039L10.7091 20.4181L2 11.7091L10.7091 3Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.7091 3L20.1233 4.41421L12.8284 11.7091L20.1233 19.0039L18.7091 20.4181L10 11.7091L18.7091 3Z"
          />
        </g>
      </g>
    </>
  ),
  'chev-left-small': () => (
    <>
      <g id="chev-left-small">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.7071 5L16.1213 6.41421L10.8284 11.7071L16.1213 17L14.7071 18.4142L8 11.7071L14.7071 5Z"
        />
      </g>
    </>
  ),
  'chev-right': () => (
    <>
      <g id="chev-right">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.41421 3.58203L8 4.99624L15.2948 12.2911L8 19.5859L9.41421 21.0002L18.1233 12.2911L9.41421 3.58203Z"
        />
      </g>
    </>
  ),
  'chev-right-double': () => (
    <>
      <g id="chev-right-double">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.41421 3.58203L4 4.99624L11.2948 12.2911L4 19.5859L5.41421 21.0002L14.1233 12.2911L5.41421 3.58203Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.4142 3.58203L12 4.99624L19.2948 12.2911L12 19.5859L13.4142 21.0002L22.1233 12.2911L13.4142 3.58203Z"
          />
        </g>
      </g>
    </>
  ),
  'chev-right-small': () => (
    <>
      <g id="chev-right-small">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.29312 4.99414L7.87891 6.40835L13.1718 11.7012L7.87891 16.9941L9.29312 18.4084L16.0002 11.7012L9.29312 4.99414Z"
        />
      </g>
    </>
  ),
  'chev-up': () => (
    <>
      <g id="chev-up">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 15.7091L4.41421 17.1233L11.7091 9.82843L19.0039 17.1233L20.4181 15.7091L11.7091 7L3 15.7091Z"
        />
      </g>
    </>
  ),
  'chev-up-small': () => (
    <>
      <g id="chev-up-small">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.7677 14.9395L17.3535 16.3537L12.0606 11.0608L6.76773 16.3537L5.35352 14.9395L12.0606 8.23242L18.7677 14.9395Z"
        />
      </g>
    </>
  ),
  'chev-down': () => (
    <>
      <g id="chev-down">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 8.41421L4.41421 7L11.7091 14.2948L19.0039 7L20.4181 8.41421L11.7091 17.1233L3 8.41421Z"
        />
      </g>
    </>
  ),
  'chev-down-small': () => (
    <>
      <g id="chev-down-small">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.4142 9.41421L17 8L11.7071 13.2929L6.41421 8L5 9.41421L11.7071 16.1213L18.4142 9.41421Z"
        />
      </g>
    </>
  ),
  plus: () => (
    <>
      <g id="plus">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 11V4H13V11H20V13H13V20H11V13H4V11H11Z"
        />
      </g>
    </>
  ),
  'plus-small': () => (
    <>
      <g id="plus-small">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z"
        />
      </g>
    </>
  ),
  'plus-circle': () => (
    <>
      <g id="plus-circle">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 11V8H13V11H16V13H13V16H11V13H8V11H11Z"
          />
        </g>
      </g>
    </>
  ),
  'plus-circle-active': () => (
    <>
      <g id="plus-circle-active">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM11 11H8V13H11V16H13V13H16V11H13V8H11V11Z"
        />
      </g>
    </>
  ),
  'plus-circle-small': () => (
    <>
      <g id="plus-circle-small">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.0002 11V8H13.0002V11H16.0002V13H13.0002V16H11.0002V13H8.00024V11H11.0002Z"
          />
        </g>
      </g>
    </>
  ),
  minus: () => (
    <>
      <g id="minus">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 13H4V11H20V13Z"
        />
      </g>
    </>
  ),
  'minus-small': () => (
    <>
      <g id="minus-small">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 13H5V11H19V13Z"
        />
      </g>
    </>
  ),
  'minus-circle': () => (
    <>
      <g id="minus-circle">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
          />
          <path fillRule="evenodd" clipRule="evenodd" d="M16 13H8V11H16V13Z" />
        </g>
      </g>
    </>
  ),
  'minus-circle-small': () => (
    <>
      <g id="minus-circle-small">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.0002 13H8.00024V11H16.0002V13Z"
          />
        </g>
      </g>
    </>
  ),
  circle: () => (
    <>
      <g id="circle">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
        />
      </g>
    </>
  ),
  'circle-filled': () => (
    <>
      <g id="circle-filled">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
        />
      </g>
    </>
  ),
  'circle-filled-small': () => (
    <>
      <g id="circle-filled-small">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z"
        />
      </g>
    </>
  ),
  tick: () => (
    <>
      <g id="tick">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 5L21.4142 6.41421L8.70711 19.1213L2 12.4142L3.41421 11L8.70711 16.2929L20 5Z"
        />
      </g>
    </>
  ),
  'tick-small': () => (
    <>
      <g id="tick-small">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.7072 8.04068L9.66674 18.0811L4.29297 12.7073L5.70718 11.2931L9.66674 15.2527L18.293 6.62646L19.7072 8.04068Z"
        />
      </g>
    </>
  ),
  'tick-circle': () => (
    <>
      <g id="tick-circle">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.9477 8.5053L16.3619 9.91951L10.3215 15.9599L6.94768 12.5862L8.36189 11.172L10.3215 13.1315L14.9477 8.5053Z"
          />
        </g>
      </g>
    </>
  ),
  'tick-circle-active': () => (
    <>
      <g id="tick-circle-active">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM16.3615 9.91946L14.9473 8.50525L10.321 13.1315L8.36148 11.1719L6.94727 12.5861L10.321 15.9599L16.3615 9.91946Z"
        />
      </g>
    </>
  ),
  'tick-circle-small': () => (
    <>
      <g id="tick-circle-small">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.5416 8.81459L15.9558 10.2288L10.508 15.6767L7.43048 12.5992L8.84469 11.185L10.508 12.8482L14.5416 8.81459Z"
          />
        </g>
      </g>
    </>
  ),
  cross: () => (
    <>
      <g id="cross">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3713 11.9571L19.9142 5.41421L18.5 4L11.9571 10.5429L5.41421 4L4 5.41421L10.5429 11.9571L4 18.5L5.41421 19.9142L11.9571 13.3713L18.5 19.9142L19.9142 18.5L13.3713 11.9571Z"
        />
      </g>
    </>
  ),
  'cross-small': () => (
    <>
      <g id="cross-small">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5859 12.0001L5.79297 7.20718L7.20718 5.79297L12.0001 10.5859L16.793 5.79297L18.2072 7.20718L13.4143 12.0001L18.2072 16.793L16.793 18.2072L12.0001 13.4143L7.20718 18.2072L5.79297 16.793L10.5859 12.0001Z"
        />
      </g>
    </>
  ),
  'cross-circle': () => (
    <>
      <g id="cross-circle">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 13.4142L14.5429 15.9571L15.9571 14.5429L13.4142 12L15.9571 9.45711L14.5429 8.04289L12 10.5858L9.45711 8.04289L8.04289 9.45711L10.5858 12L8.04289 14.5429L9.45711 15.9571L12 13.4142Z"
          />
        </g>
      </g>
    </>
  ),
  'cross-circle-small': () => (
    <>
      <g id="cross-circle-small">
        <g id="path">
          <path d="M14.293 15.7072L12.0001 13.4143L9.70718 15.7072L8.29297 14.293L10.5859 12.0001L8.29297 9.70718L9.70718 8.29297L12.0001 10.5859L14.293 8.29297L15.7072 9.70718L13.4143 12.0001L15.7072 14.293L14.293 15.7072Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12Z"
          />
        </g>
      </g>
    </>
  ),
  help: () => (
    <>
      <g id="help">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.1505 8.90942L12.141 8.90975H12.1235C11.6784 8.90975 11.4046 9.02533 11.2351 9.13557C11.0566 9.25167 10.9453 9.39417 10.8791 9.50051C10.7965 9.63328 10.7601 9.7519 10.7234 10.0826L8.73559 9.86208C8.78299 9.43485 8.86071 8.95878 9.18095 8.44403C9.54265 7.86263 10.4089 6.90975 12.1235 6.90975C12.1235 6.92061 12.0749 6.91078 12.0976 6.91008C12.1396 6.90913 12.1809 6.9089 12.2462 6.91112C12.3285 6.91391 12.4399 6.9209 12.5713 6.93737C12.8295 6.9697 13.1904 7.04164 13.5676 7.20738C13.9479 7.37451 14.3673 7.64745 14.6993 8.09014C15.0371 8.54052 15.2407 9.10898 15.2695 9.78941L15.2704 9.81059V9.83179C15.2704 10.5662 15.0631 11.1507 14.6918 11.6163C14.3637 12.0279 13.9446 12.2903 13.673 12.4603C13.6645 12.4656 13.6562 12.4708 13.648 12.4759C13.3287 12.6761 13.1875 12.7724 13.092 12.887C13.0365 12.9535 12.9633 13.0636 12.9633 13.3549V13.8487H10.9633V13.3549C10.9633 12.6312 11.1786 12.0589 11.5557 11.6065C11.8726 11.2262 12.2766 10.9742 12.5377 10.8113C12.5544 10.801 12.5704 10.791 12.5858 10.7813C12.8923 10.5892 13.0339 10.4876 13.1281 10.3695C13.1881 10.2942 13.2669 10.1652 13.2703 9.85305C13.2541 9.5498 13.1704 9.38486 13.0993 9.29007C13.0208 9.18541 12.9088 9.10249 12.7629 9.03839C12.614 8.97293 12.454 8.93829 12.3228 8.92186C12.2596 8.91395 12.2092 8.91101 12.1784 8.90997C12.1643 8.90949 12.1548 8.90942 12.1505 8.90942Z"
          />
          <path d="M13.2496 15.8494C13.2496 16.5396 12.6902 17.099 12.0001 17.099C11.3099 17.099 10.7505 16.5396 10.7505 15.8494C10.7505 15.1593 11.3099 14.5999 12.0001 14.5999C12.6902 14.5999 13.2496 15.1593 13.2496 15.8494Z" />
        </g>
      </g>
    </>
  ),
  info: () => (
    <>
      <g id="info">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5ZM12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3Z"
          />
          <path d="M13.2496 8.37054C13.2496 7.68042 12.6902 7.12096 12.0001 7.12096C11.3099 7.12096 10.7505 7.68042 10.7505 8.37054C10.7505 9.06066 11.3099 9.62012 12.0001 9.62012C12.6902 9.62012 13.2496 9.06066 13.2496 8.37054Z" />
          <path d="M11 17H13V11H11V17Z" />
        </g>
      </g>
    </>
  ),
  warning: () => (
    <>
      <g id="warning">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
          />
          <path d="M13.2496 15.6295C13.2496 16.3196 12.6902 16.879 12.0001 16.879C11.3099 16.879 10.7505 16.3196 10.7505 15.6295C10.7505 14.9393 11.3099 14.3799 12.0001 14.3799C12.6902 14.3799 13.2496 14.9393 13.2496 15.6295Z" />
          <path d="M11 7H13V13H11V7Z" />
        </g>
      </g>
    </>
  ),
  'globe-circle': () => (
    <>
      <g id="globe-circle">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 21C9.20776 20.9028 9.41156 20.7958 9.61098 20.6795C5.79995 19.6329 3 16.1434 3 12C3 7.85658 5.79996 4.36712 9.61099 3.32051C9.41157 3.20417 9.20776 3.0972 9.00001 3L9.7052 3.29519C10.4378 3.10258 11.2069 3 12 3C12.7931 3 13.5622 3.10258 14.2948 3.29519L15 3C14.7922 3.0972 14.5884 3.20417 14.389 3.32051C18.2 4.36712 21 7.85658 21 12C21 16.1434 18.2 19.6329 14.389 20.6795C14.5884 20.7958 14.7922 20.9028 15 21L14.2948 20.7048C13.5622 20.8974 12.7931 21 12 21C11.2069 21 10.4378 20.8974 9.70519 20.7048L9 21ZM8.03582 13H5.07089C5.44591 15.6218 7.27378 17.775 9.7128 18.6178C8.75561 16.9415 8.17987 15.0068 8.03582 13ZM9.86702 13H14.133C13.9879 14.6498 13.4858 16.2339 12.6686 17.5964C12.463 17.9393 12.2395 18.2645 12 18.5707C11.7605 18.2645 11.537 17.9393 11.3314 17.5964C10.5142 16.2339 10.0121 14.6498 9.86702 13ZM14.133 11H9.86702C10.0121 9.35023 10.5142 7.76609 11.3314 6.40359C11.537 6.06073 11.7605 5.73546 12 5.42934C12.2395 5.73546 12.463 6.06073 12.6686 6.40359C13.4858 7.76609 13.9879 9.35023 14.133 11ZM15.9642 13C15.8201 15.0068 15.2444 16.9415 14.2872 18.6178C16.7262 17.775 18.5541 15.6218 18.9291 13H15.9642ZM18.9291 11C18.5541 8.37817 16.7262 6.22501 14.2872 5.38219C15.2444 7.05848 15.8201 8.99318 15.9642 11H18.9291ZM8.03582 11H5.07089C5.44591 8.37817 7.27378 6.22501 9.7128 5.38219C8.75561 7.05848 8.17987 8.99318 8.03582 11Z"
        />
      </g>
    </>
  ),
  refresh: () => (
    <>
      <g id="refresh">
        <path
          id="path"
          d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.933 19 15.683 18.2165 16.9497 16.9497L18.364 18.364C16.7353 19.9926 14.4853 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C14.3046 3 16.4069 3.86621 17.999 5.29081V3H19.999V9H13.999V7H16.899C15.6364 5.76281 13.9073 5 12 5Z"
        />
      </g>
    </>
  ),
  sync: () => (
    <>
      <g id="sync">
        <g id="path">
          <path d="M5 12C5 8.13401 8.13401 5 12 5C13.9073 5 15.6364 5.76281 16.899 7H13.999V9H19.999V3H17.999V5.29081C16.4069 3.86621 14.3046 3 12 3C7.02944 3 3 7.02944 3 12H5Z" />
          <path d="M6 18.7083V20.999H4V14.999H10V16.999H7.10002C8.36264 18.2368 10.0922 19 12 19C15.866 19 19 15.866 19 12L21 11.999C21 16.9696 16.9706 21 12 21C9.69494 21 7.59227 20.1334 6 18.7083Z" />
        </g>
      </g>
    </>
  ),
  offline: () => (
    <>
      <g id="offline">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.97281 2.55859L4.55859 3.97281L5.98468 5.39889C4.70795 5.9922 3.51282 6.76584 2.43858 7.70356C2.18798 7.92231 1.94397 8.14998 1.70703 8.38638L1 9.09341L12.314 20.4064L16.6531 16.0673L18.4336 17.8478L19.8478 16.4336L5.97281 2.55859ZM15.2389 14.6531L7.50616 6.92037C6.18499 7.44541 4.95051 8.18654 3.85661 9.12148L12.3139 17.578L15.2389 14.6531Z"
          />
          <path d="M20.7704 9.12153L18.0631 11.8288L19.4773 13.243L23.627 9.09341L22.9199 8.38638C22.683 8.14998 22.439 7.92231 22.1884 7.70356C19.4615 5.32321 15.9556 4.00015 12.3135 4.00015C11.6572 4.00015 11.0054 4.04311 10.3617 4.12746L12.2347 6.00039L12.3135 6.00015C15.425 6.00015 18.4217 7.11413 20.7704 9.12153Z" />
        </g>
      </g>
    </>
  ),
  show: () => (
    <>
      <g id="show">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.12732 11.6789C4.76772 10.0619 5.86464 8.66287 7.28785 7.65447C8.80699 6.5781 10.6228 6 12.4846 6C14.3464 6 16.1623 6.5781 17.6814 7.65447C19.1046 8.66287 20.2015 10.0619 20.8419 11.6789C20.2019 13.2963 19.105 14.6958 17.6817 15.7046C16.1625 16.7812 14.3466 17.3595 12.4846 17.3595C10.6226 17.3595 8.80645 16.7812 7.28733 15.7046C5.86411 14.6959 4.76738 13.2964 4.12732 11.6789ZM22.969 11.6787L22.8521 12.0117C22.0979 14.1595 20.6953 16.0201 18.8381 17.3363C16.981 18.6526 14.7609 19.3595 12.4846 19.3595C10.2083 19.3595 7.98804 18.6526 6.13086 17.3363C4.27367 16.0201 2.87131 14.1595 2.11719 12.0117L2 11.6787L2.11719 11.3457C2.87177 9.19838 4.27446 7.33843 6.13159 6.02258C7.98872 4.70674 10.2086 4 12.4846 4C14.7607 4 16.9805 4.70674 18.8376 6.02258C20.6948 7.33843 22.0975 9.19838 22.8521 11.3457L22.969 11.6787Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.4851 13.6797C13.5897 13.6797 14.4851 12.7843 14.4851 11.6797C14.4851 10.5752 13.5897 9.67975 12.4851 9.67975C11.3805 9.67975 10.4851 10.5752 10.4851 11.6797C10.4851 12.7843 11.3805 13.6797 12.4851 13.6797ZM12.4851 15.6797C14.6942 15.6797 16.4851 13.8889 16.4851 11.6797C16.4851 9.47061 14.6942 7.67975 12.4851 7.67975C10.276 7.67975 8.48511 9.47061 8.48511 11.6797C8.48511 13.8889 10.276 15.6797 12.4851 15.6797Z"
          />
        </g>
      </g>
    </>
  ),
  'show-active': () => (
    <>
      <g id="show-active">
        <g id="path">
          <path d="M10 11.75C10 10.2312 11.2312 9 12.75 9C14.2688 9 15.5 10.2312 15.5 11.75C15.5 13.2688 14.2688 14.5 12.75 14.5C11.2312 14.5 10 13.2688 10 11.75Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.1344 6.02561C7.99368 4.70779 10.2165 4 12.4954 4C14.7743 4 16.9968 4.7078 18.8561 6.02561C20.7153 7.34339 22.1196 9.20613 22.8745 11.3565L22.9907 11.6877L22.8745 12.0189C22.1196 14.1692 20.7153 16.032 18.8561 17.3498C16.9969 18.6676 14.7743 19.3754 12.4954 19.3754C10.2165 19.3754 7.99367 18.6676 6.1344 17.3498C4.27512 16.0319 2.87112 14.1692 2.11628 12.0189L2 11.6877L2.11628 11.3565C2.87112 9.20619 4.27512 7.34343 6.1344 6.02561ZM12.75 7C10.1266 7 8 9.12665 8 11.75C8 14.3734 10.1266 16.5 12.75 16.5C15.3734 16.5 17.5 14.3734 17.5 11.75C17.5 9.12665 15.3734 7 12.75 7Z"
          />
        </g>
      </g>
    </>
  ),
  lock: () => (
    <>
      <g id="lock">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 7V10H4V21H20V10H9V7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7H17C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7ZM6 19V12H18V19H6Z"
        />
      </g>
    </>
  ),
  'lock-active': () => (
    <>
      <g id="lock-active">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 10V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10H20V21H4V10H7ZM15 8V10H9V8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8Z"
        />
      </g>
    </>
  ),
  sort: () => (
    <>
      <g id="sort">
        <g id="path">
          <path d="M3 17H21V19H3V17Z" />
          <path d="M3 11H16V13H3V11Z" />
          <path d="M3 5H11V7H3V5Z" />
        </g>
      </g>
    </>
  ),
  filter: () => (
    <>
      <g id="filter">
        <g id="path">
          <path d="M9 17H21V19H9V17Z" />
          <path d="M3 11H15V13H3V11Z" />
          <path d="M9 5H21V7H9V5Z" />
          <path d="M6.5 6C6.5 6.9665 5.7165 7.75 4.75 7.75C3.7835 7.75 3 6.9665 3 6C3 5.0335 3.7835 4.25 4.75 4.25C5.7165 4.25 6.5 5.0335 6.5 6Z" />
          <path d="M6.5 18C6.5 18.9665 5.7165 19.75 4.75 19.75C3.7835 19.75 3 18.9665 3 18C3 17.0335 3.7835 16.25 4.75 16.25C5.7165 16.25 6.5 17.0335 6.5 18Z" />
          <path d="M21 12C21 12.9665 20.2165 13.75 19.25 13.75C18.2835 13.75 17.5 12.9665 17.5 12C17.5 11.0335 18.2835 10.25 19.25 10.25C20.2165 10.25 21 11.0335 21 12Z" />
        </g>
      </g>
    </>
  ),
  reorder: () => (
    <>
      <g id="reorder">
        <g id="path">
          <path d="M12 3.00098L8 7.00098H16L12 3.00098Z" />
          <path d="M12 21L8 17H16L12 21Z" />
          <path d="M3 11H21V13H3V11Z" />
        </g>
      </g>
    </>
  ),
  flag: () => (
    <>
      <g id="flag">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 14.0014V16H6.00024V20.0015H4.00024L4 4H20V5.99976L15.9993 10.0005L20 14.0014ZM13.1709 10.0005L17.1702 14H6.00024L6 6H17.1714L13.1709 10.0005Z"
        />
      </g>
    </>
  ),
  'edit-android': () => (
    <>
      <g id="edit-android">
        <path
          id="path"
          d="M3.89514 17.653L18.5541 2.99414L21 5.4401L6.34067 20.099L3 20.9941L3.89514 17.653Z"
        />
      </g>
    </>
  ),
  'edit-ios': () => (
    <>
      <g id="edit-ios">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 3.99426H14.908L12.908 5.99426H6V16.5306L5.99902 16.5342V17.9943H18V11.0846L20 9.08463V19.9943H4V3.99426Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.56934 12.8685L18.8928 3.54492L20.4485 5.10059L11.1248 14.4242L9 14.9934L9.56934 12.8685Z"
          />
        </g>
      </g>
    </>
  ),
  'share-android': () => (
    <>
      <g id="share-android">
        <path
          id="path"
          d="M20.259 5.5C20.259 6.88071 19.1397 8 17.759 8C17.2029 8 16.6892 7.81843 16.274 7.51134L8.9845 11.72C8.99474 11.8119 9 11.9054 9 12C9 12.0945 8.99475 12.1878 8.98454 12.2796L16.2743 16.4884C16.6895 16.1815 17.2031 16 17.759 16C19.1397 16 20.259 17.1193 20.259 18.5C20.259 19.8807 19.1397 21 17.759 21C16.3783 21 15.259 19.8807 15.259 18.5C15.259 18.4056 15.2643 18.3123 15.2745 18.2206L7.98457 14.0117C7.56942 14.3186 7.0559 14.5 6.5 14.5C5.11929 14.5 4 13.3807 4 12C4 10.6193 5.11929 9.5 6.5 9.5C7.05577 9.5 7.56918 9.68135 7.98428 9.98811L15.2744 5.77904C15.2643 5.68743 15.259 5.59432 15.259 5.5C15.259 4.11929 16.3783 3 17.759 3C19.1397 3 20.259 4.11929 20.259 5.5Z"
        />
      </g>
    </>
  ),
  'share-ios': () => (
    <>
      <g id="share-ios">
        <g id="path">
          <path d="M11.9991 1.58594L16.2062 5.79304L14.792 7.20726L12.999 5.41429V13H10.999V5.41444L9.20621 7.20726L7.79199 5.79304L11.9991 1.58594Z" />
          <path d="M4 8.00098H8V10.001H6V19.001H18V10.001H16V8.00098H20V21.001H4V8.00098Z" />
        </g>
      </g>
    </>
  ),
  'more-android': () => (
    <>
      <g id="more-android">
        <g id="path">
          <path d="M11.75 10.25C12.7165 10.25 13.5 11.0335 13.5 12C13.5 12.9665 12.7165 13.75 11.75 13.75C10.7835 13.75 10 12.9665 10 12C10 11.0335 10.7835 10.25 11.75 10.25Z" />
          <path d="M11.75 2C12.7165 2 13.5 2.7835 13.5 3.75C13.5 4.7165 12.7165 5.5 11.75 5.5C10.7835 5.5 10 4.7165 10 3.75C10 2.7835 10.7835 2 11.75 2Z" />
          <path d="M11.75 18.5C12.7165 18.5 13.5 19.2835 13.5 20.25C13.5 21.2165 12.7165 22 11.75 22C10.7835 22 10 21.2165 10 20.25C10 19.2835 10.7835 18.5 11.75 18.5Z" />
        </g>
      </g>
    </>
  ),
  'more-ios': () => (
    <>
      <g id="more-ios">
        <g id="path">
          <path d="M13.75 11.75C13.75 12.7165 12.9665 13.5 12 13.5C11.0335 13.5 10.25 12.7165 10.25 11.75C10.25 10.7835 11.0335 10 12 10C12.9665 10 13.75 10.7835 13.75 11.75Z" />
          <path d="M22 11.75C22 12.7165 21.2165 13.5 20.25 13.5C19.2835 13.5 18.5 12.7165 18.5 11.75C18.5 10.7835 19.2835 10 20.25 10C21.2165 10 22 10.7835 22 11.75Z" />
          <path d="M5.5 11.75C5.5 12.7165 4.7165 13.5 3.75 13.5C2.7835 13.5 2 12.7165 2 11.75C2 10.7835 2.7835 10 3.75 10C4.7165 10 5.5 10.7835 5.5 11.75Z" />
        </g>
      </g>
    </>
  ),
  space: () => (
    <>
      <g id="space">
        <path id="path" d="M4 10V16H20V10H18V14H6L6 10H4Z" />
      </g>
    </>
  ),
  delete: () => (
    <>
      <g id="delete">
        <g id="path">
          <path d="M12.7267 12L11 13.7267L12.2733 15L14 13.2733L15.7267 15L17 13.7267L15.2733 12L17 10.2733L15.7267 9L14 10.7267L12.2733 9L11 10.2733L12.7267 12Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 5H8.53158L2.69824 12L8.53158 19H21V5ZM5.30166 12L9.46833 7H19V17H9.46833L5.30166 12Z"
          />
        </g>
      </g>
    </>
  ),
  device: () => (
    <>
      <g id="device">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 2.5V21.5H20V2.5H4ZM18 4.5H6V19.5H18V4.5ZM12.0051 17.6998C14.0127 17.6998 15.6401 16.0433 15.6401 13.9998C15.6401 11.9564 14.0127 10.2998 12.0051 10.2998C9.99756 10.2998 8.37012 11.9564 8.37012 13.9998C8.37012 16.0433 9.99756 17.6998 12.0051 17.6998ZM12.0008 15.7461C12.9503 15.7461 13.7201 14.9626 13.7201 13.9961C13.7201 13.0296 12.9503 12.2461 12.0008 12.2461C11.0513 12.2461 10.2816 13.0296 10.2816 13.9961C10.2816 14.9626 11.0513 15.7461 12.0008 15.7461ZM13.2031 7.41211C13.2031 8.10246 12.6435 8.66211 11.9531 8.66211C11.2628 8.66211 10.7031 8.10246 10.7031 7.41211C10.7031 6.72175 11.2628 6.16211 11.9531 6.16211C12.6435 6.16211 13.2031 6.72175 13.2031 7.41211Z"
        />
      </g>
    </>
  ),
  'device-mobile': () => (
    <>
      <g id="device-mobile">
        <g id="path">
          <path d="M17 4V20H8V4H17ZM19 2H6V22H19V2Z" />
          <path d="M12.25 18.5C12.9404 18.5 13.5 17.9404 13.5 17.25C13.5 16.5596 12.9404 16 12.25 16C11.5596 16 11 16.5596 11 17.25C11 17.9404 11.5596 18.5 12.25 18.5Z" />
        </g>
      </g>
    </>
  ),
  'device-tablet': () => (
    <>
      <g id="device-tablet">
        <g id="path">
          <path d="M19 4V20H5V4H19ZM21 2H3V22H21V2Z" />
          <path d="M12 18.5C12.6904 18.5 13.25 17.9404 13.25 17.25C13.25 16.5596 12.6904 16 12 16C11.3096 16 10.75 16.5596 10.75 17.25C10.75 17.9404 11.3096 18.5 12 18.5Z" />
        </g>
      </g>
    </>
  ),
  'device-desktop': () => (
    <>
      <g id="device-desktop">
        <g id="path">
          <path d="M19 6V14H5V6H19ZM21 4H3V16H21V4Z" />
          <path d="M23 18H1L2 20H22L23 18Z" />
        </g>
      </g>
    </>
  ),
  'device-tv': () => (
    <>
      <g id="device-tv">
        <g id="path">
          <path d="M21 5V15H3V5H21ZM23 3H1V17H23V3Z" />
          <path d="M17 19H7V21H17V19Z" />
        </g>
      </g>
    </>
  ),
  'device-watch': () => (
    <>
      <g id="device-watch">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 1H9V3.51212C9.63682 3.28703 10.3065 3.13159 11 3.05493C11.3283 3.01863 11.662 3 12 3C12.338 3 12.6717 3.01863 13 3.05493C13.6935 3.13159 14.3632 3.28703 15 3.51212V1ZM16.8666 6.29311C16.175 5.70276 15.3747 5.23593 14.5 4.92676C13.718 4.65038 12.8766 4.5 12 4.5C11.1234 4.5 10.282 4.65038 9.50001 4.92676C8.62529 5.23593 7.82505 5.70276 7.13343 6.29311C5.52182 7.66873 4.5 9.71504 4.5 12C4.5 14.285 5.52182 16.3313 7.13343 17.7069C7.82505 18.2972 8.62529 18.7641 9.50001 19.0732C10.282 19.3496 11.1234 19.5 12 19.5C12.8766 19.5 13.718 19.3496 14.5 19.0732C15.3747 18.7641 16.175 18.2972 16.8666 17.7069C18.4782 16.3313 19.5 14.285 19.5 12C19.5 9.71504 18.4782 7.66873 16.8666 6.29311ZM13 20.9451C13.6935 20.8684 14.3632 20.713 15 20.4879V23H9V20.4879C9.63682 20.713 10.3065 20.8684 11 20.9451C11.3283 20.9814 11.662 21 12 21C12.338 21 12.6717 20.9814 13 20.9451ZM12 17.5C15.0376 17.5 17.5 15.0376 17.5 12C17.5 8.96243 15.0376 6.5 12 6.5C8.96243 6.5 6.5 8.96243 6.5 12C6.5 15.0376 8.96243 17.5 12 17.5Z"
        />
      </g>
    </>
  ),
  'device-auto': () => (
    <>
      <g id="device-auto">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 11.2131V16H19V11.5072L17.1276 6H6.77244L5 11.2131ZM20.6 10H23V12H21V20H18V18H6V20H3V12H1V10H3.3L5 5C5.2 4.4 5.8 4 6.4 4H17.5C18.2 4 18.7 4.4 18.9 5L20.6 10Z"
          />
          <path d="M17.5 12.5001C17.5 13.3286 16.8284 14.0001 16 14.0001C15.1716 14.0001 14.5 13.3286 14.5 12.5001C14.5 11.6717 15.1716 11.0001 16 11.0001C16.8284 11.0001 17.5 11.6717 17.5 12.5001Z" />
          <path d="M9.5 12.5001C9.5 13.3286 8.82843 14.0001 8 14.0001C7.17157 14.0001 6.5 13.3286 6.5 12.5001C6.5 11.6717 7.17157 11.0001 8 11.0001C8.82843 11.0001 9.5 11.6717 9.5 12.5001Z" />
        </g>
      </g>
    </>
  ),
  cast: () => (
    <>
      <g id="cast">
        <path
          id="path"
          d="M2 10.2222V12C3.07445 12 4.13838 12.2069 5.13105 12.609C6.12371 13.011 7.02567 13.6003 7.78542 14.3431C8.54517 15.086 9.14784 15.9679 9.55901 16.9385C9.97019 17.9091 10.1818 18.9494 10.1818 20H12C12 14.5956 7.51818 10.2222 2 10.2222ZM2 13.7778V15.5556C2.59692 15.5556 3.18799 15.6705 3.73947 15.8939C4.29095 16.1172 4.79204 16.4446 5.21412 16.8573C5.63621 17.27 5.97102 17.76 6.19945 18.2992C6.42788 18.8384 6.54545 19.4163 6.54545 20H8.36364C8.36364 18.3498 7.69318 16.7671 6.49977 15.6002C5.30636 14.4333 3.68774 13.7778 2 13.7778V13.7778ZM2 17.3333V20H4.72727C4.72727 19.2928 4.43994 18.6145 3.92847 18.1144C3.41701 17.6143 2.72332 17.3333 2 17.3333V17.3333ZM20.1818 4H3.81818C2.80909 4 2 4.79111 2 5.77778V8.44444H3.81818V5.77778H20.1818V18.2222H13.8182V20H20.1818C20.664 20 21.1265 19.8127 21.4675 19.4793C21.8084 19.1459 22 18.6937 22 18.2222V5.77778C22 5.30628 21.8084 4.8541 21.4675 4.5207C21.1265 4.1873 20.664 4 20.1818 4Z"
        />
      </g>
    </>
  ),
  'cast-active': () => (
    <>
      <g id="cast-active">
        <path
          id="path"
          d="M20.1818 4H3.81818C2.80909 4 2 4.79111 2 5.77778V8.44444H3.81818V5.77778H20.1818V18.2222H13.8182V20H20.1818C20.664 20 21.1265 19.8127 21.4675 19.4793C21.8084 19.1459 22 18.6937 22 18.2222V5.77778C22 5.30628 21.8084 4.8541 21.4675 4.5207C21.1265 4.1873 20.664 4 20.1818 4ZM2 10.2222V12C3.07445 12 4.13838 12.2069 5.13105 12.609C6.12371 13.011 7.02567 13.6003 7.78542 14.3431C8.54517 15.086 9.14784 15.9679 9.55901 16.9385C9.97019 17.9091 10.1818 18.9494 10.1818 20H12C12 14.5956 7.51818 10.2222 2 10.2222ZM18.3636 7.55556H5.63636V9.00444C9.23636 10.1422 12.0818 12.9244 13.2455 16.4444H18.3636V7.55556ZM2 13.7778V15.5556C2.59692 15.5556 3.18799 15.6705 3.73947 15.8939C4.29095 16.1172 4.79204 16.4446 5.21412 16.8573C5.63621 17.27 5.97102 17.76 6.19945 18.2992C6.42788 18.8384 6.54545 19.4163 6.54545 20H8.36364C8.36364 18.3498 7.69318 16.7671 6.49977 15.6002C5.30636 14.4333 3.68774 13.7778 2 13.7778ZM2 17.3333V20H4.72727C4.72727 19.2928 4.43994 18.6145 3.92847 18.1144C3.41701 17.6143 2.72332 17.3333 2 17.3333Z"
        />
      </g>
    </>
  ),
  faceid: () => (
    <>
      <g id="faceid">
        <path
          id="path"
          d="M3.11056 8.90345C3.85093 8.90345 4.22111 8.5266 4.22111 7.77289V5.5918C4.22111 5.13157 4.3345 4.7914 4.56128 4.57129C4.79473 4.34451 5.13157 4.23112 5.57179 4.23112H7.8029C8.55661 4.23112 8.93347 3.8576 8.93347 3.11056C8.93347 2.37019 8.55661 2 7.8029 2H5.3917C4.28448 2 3.44072 2.28681 2.86043 2.86043C2.28681 3.43405 2 4.2678 2 5.36168V7.77289C2 8.5266 2.37019 8.90345 3.11056 8.90345ZM20.8794 8.90345C21.6265 8.90345 22 8.5266 22 7.77289V5.36168C22 4.2678 21.7099 3.43405 21.1296 2.86043C20.5559 2.28681 19.7155 2 18.6083 2H16.1871C15.4401 2 15.0665 2.37019 15.0665 3.11056C15.0665 3.8576 15.4401 4.23112 16.1871 4.23112H18.4182C18.8518 4.23112 19.1853 4.34451 19.4187 4.57129C19.6522 4.7914 19.7689 5.13157 19.7689 5.5918V7.77289C19.7689 8.5266 20.1391 8.90345 20.8794 8.90345ZM5.3917 22H7.8029C8.55661 22 8.93347 21.6298 8.93347 20.8894C8.93347 20.1424 8.55661 19.7689 7.8029 19.7689H5.57179C5.13157 19.7689 4.79473 19.6555 4.56128 19.4287C4.3345 19.2086 4.22111 18.8684 4.22111 18.4082V16.2171C4.22111 15.4701 3.85093 15.0965 3.11056 15.0965C2.37019 15.0965 2 15.4701 2 16.2171V18.6383C2 19.7322 2.28681 20.566 2.86043 21.1396C3.44072 21.7132 4.28448 22 5.3917 22ZM16.1871 22H18.6083C19.7155 22 20.5559 21.7132 21.1296 21.1396C21.7099 20.566 22 19.7322 22 18.6383V16.2171C22 15.4701 21.6265 15.0965 20.8794 15.0965C20.1391 15.0965 19.7689 15.4701 19.7689 16.2171V18.4082C19.7689 18.8684 19.6522 19.2086 19.4187 19.4287C19.1853 19.6555 18.8518 19.7689 18.4182 19.7689H16.1871C15.4401 19.7689 15.0665 20.1424 15.0665 20.8894C15.0665 21.6298 15.4401 22 16.1871 22ZM8.28314 11.3347C8.5366 11.3347 8.74337 11.2546 8.90345 11.0945C9.0702 10.9278 9.15358 10.7144 9.15358 10.4542V9.10355C9.15358 8.85009 9.0702 8.64332 8.90345 8.48324C8.74337 8.31649 8.5366 8.23312 8.28314 8.23312C8.02968 8.23312 7.81958 8.31649 7.65283 8.48324C7.49275 8.64332 7.41271 8.85009 7.41271 9.10355V10.4542C7.41271 10.7144 7.49275 10.9278 7.65283 11.0945C7.81958 11.2546 8.02968 11.3347 8.28314 11.3347ZM11.2046 13.6758C11.2179 13.6758 11.2313 13.6758 11.2446 13.6758C11.2646 13.6758 11.2813 13.6758 11.2946 13.6758C11.8149 13.6758 12.2151 13.5391 12.4952 13.2656C12.7754 12.9855 12.9155 12.582 12.9155 12.055V8.93347C12.9155 8.72003 12.8488 8.54994 12.7154 8.42321C12.5886 8.28981 12.4152 8.22311 12.1951 8.22311C11.9817 8.22311 11.8082 8.28981 11.6748 8.42321C11.5414 8.54994 11.4747 8.72003 11.4747 8.93347V12.085C11.4747 12.1317 11.4614 12.1651 11.4347 12.1851C11.4147 12.2051 11.3847 12.2151 11.3447 12.2151H11.0545C10.8544 12.2151 10.6843 12.2851 10.5443 12.4252C10.4109 12.5586 10.3442 12.7254 10.3442 12.9255C10.3442 13.1589 10.4209 13.3423 10.5743 13.4757C10.7277 13.6091 10.9378 13.6758 11.2046 13.6758ZM15.6968 11.3347C15.9436 11.3347 16.1471 11.2546 16.3072 11.0945C16.4739 10.9278 16.5573 10.7144 16.5573 10.4542V9.10355C16.5573 8.85009 16.4739 8.64332 16.3072 8.48324C16.1471 8.31649 15.9436 8.23312 15.6968 8.23312C15.4367 8.23312 15.2233 8.31649 15.0565 8.48324C14.8964 8.64332 14.8164 8.85009 14.8164 9.10355V10.4542C14.8164 10.7144 14.8964 10.9278 15.0565 11.0945C15.2233 11.2546 15.4367 11.3347 15.6968 11.3347ZM11.945 16.9275C12.5519 16.9275 13.1456 16.8041 13.7259 16.5573C14.3128 16.3105 14.8297 15.967 15.2766 15.5268C15.3433 15.4601 15.39 15.3834 15.4167 15.2966C15.4501 15.2099 15.4667 15.1099 15.4667 14.9965C15.4667 14.7897 15.3967 14.6196 15.2566 14.4862C15.1166 14.3462 14.9465 14.2761 14.7464 14.2761C14.5529 14.2761 14.3662 14.3762 14.1861 14.5763C13.9193 14.8498 13.5858 15.0732 13.1856 15.2466C12.7921 15.4134 12.3785 15.4967 11.945 15.4967C11.5381 15.4967 11.1346 15.4134 10.7344 15.2466C10.3408 15.0799 10.004 14.8531 9.72386 14.5663C9.63048 14.4796 9.54044 14.4095 9.45373 14.3562C9.37369 14.3028 9.2703 14.2761 9.14357 14.2761C8.9368 14.2761 8.76338 14.3462 8.62331 14.4862C8.48324 14.6196 8.41321 14.7897 8.41321 14.9965C8.41321 15.0899 8.42988 15.1799 8.46323 15.2666C8.49658 15.3467 8.54994 15.43 8.62331 15.5168C9.01684 15.9703 9.51042 16.3205 10.1041 16.5673C10.7044 16.8074 11.318 16.9275 11.945 16.9275Z"
        />
      </g>
    </>
  ),
  airplay: () => (
    <>
      <g id="airplay">
        <path
          id="path"
          d="M11.9233 2.00041C9.43824 2.01914 7.04886 2.97592 5.22002 4.68462C1.1517 8.47146 0.915039 14.907 4.64336 19.0382C4.81336 19.2447 5.01669 19.4165 5.22002 19.6238C5.27135 19.6603 5.33383 19.6769 5.39619 19.6707C5.45854 19.6645 5.51665 19.6359 5.56002 19.59L6.00169 19.0738C6.05055 19.0231 6.07792 18.9551 6.07792 18.8842C6.07792 18.8133 6.05055 18.7453 6.00169 18.6947C2.4417 15.3555 2.20253 9.67563 5.52502 6.06142C8.84751 2.44721 14.4075 2.20689 17.9666 5.58077C21.5258 8.95381 21.7625 14.5973 18.44 18.2123C18.2708 18.3841 18.1358 18.5567 17.9666 18.6947C17.918 18.7452 17.8908 18.8131 17.8908 18.8838C17.8908 18.9545 17.918 19.0223 17.9666 19.0729L18.4083 19.59C18.4581 19.6361 18.5214 19.6643 18.5885 19.6705C18.6556 19.6766 18.7229 19.6602 18.78 19.6238C22.8483 15.8023 23.085 9.40061 19.3566 5.27021C18.4114 4.22796 17.2616 3.39849 15.9813 2.83529C14.7009 2.2721 13.3186 1.98769 11.9233 2.00041V2.00041ZM12.2458 4.97741C10.3509 4.91233 8.50768 5.61179 7.11918 6.92288C4.23753 9.64179 4.06919 14.2198 6.74669 17.1452C6.84835 17.2493 6.94918 17.3864 7.08502 17.4896C7.13472 17.5392 7.2016 17.567 7.27127 17.567C7.34093 17.567 7.40781 17.5392 7.45752 17.4896L7.89918 16.9734C7.94754 16.9229 7.9746 16.8552 7.9746 16.7847C7.9746 16.7143 7.94754 16.6466 7.89918 16.596C7.30301 16.0249 6.82728 15.3368 6.50082 14.5734C6.17437 13.8101 6.00399 12.9873 6.00002 12.1551C6.00002 8.81587 8.67668 6.09612 11.965 6.09612C15.2533 6.09612 17.9316 8.84888 17.9316 12.1881C17.9304 13.0127 17.7645 13.8285 17.4439 14.5861C17.1234 15.3437 16.6548 16.0275 16.0667 16.596C16.0178 16.6465 15.9905 16.7144 15.9905 16.7852C15.9905 16.8559 16.0178 16.9238 16.0667 16.9743L16.5075 17.4905C16.6092 17.5929 16.7783 17.6276 16.88 17.5243C18.2601 16.2072 19.0706 14.3888 19.1343 12.4666C19.198 10.5444 18.5098 8.67482 17.22 7.26644C16.5814 6.56932 15.8127 6.00798 14.9587 5.61503C14.1046 5.22208 13.1822 5.00534 12.245 4.97741H12.2458ZM12.0242 7.78348C10.8785 7.76706 9.77317 8.21222 8.95001 9.02151C7.22085 10.708 7.18752 13.4616 8.84834 15.2175L8.94918 15.3216C8.99888 15.3712 9.06576 15.399 9.13543 15.399C9.20509 15.399 9.27197 15.3712 9.32168 15.3216L9.76334 14.8046C9.8122 14.754 9.83957 14.6859 9.83957 14.615C9.83957 14.5441 9.8122 14.4761 9.76334 14.4255C9.17595 13.8205 8.84718 13.0047 8.84834 12.1551C8.84724 11.7389 8.92715 11.3266 9.08347 10.942C9.23979 10.5573 9.46945 10.2077 9.75923 9.91348C10.049 9.61921 10.3932 9.38601 10.772 9.22727C11.1509 9.06853 11.5569 8.98739 11.9667 8.9885C12.3765 8.98739 12.7825 9.06853 13.1613 9.22727C13.5401 9.38601 13.8843 9.61921 14.1741 9.91348C14.4639 10.2077 14.6935 10.5573 14.8499 10.942C15.0062 11.3266 15.0861 11.7389 15.085 12.1551C15.085 13.0157 14.7467 13.806 14.1358 14.4255C14.087 14.4761 14.0596 14.5441 14.0596 14.615C14.0596 14.6859 14.087 14.754 14.1358 14.8046L14.5775 15.3208C14.6273 15.3701 14.6941 15.3978 14.7637 15.3978C14.8333 15.3978 14.9002 15.3701 14.95 15.3208C15.7697 14.5114 16.2406 13.4055 16.2598 12.2447C16.279 11.0838 15.8449 9.96246 15.0525 9.12559C14.6608 8.70907 14.1914 8.37588 13.6716 8.14546C13.1518 7.91504 12.5921 7.79199 12.025 7.78348H12.0242ZM12.0292 14.3366C11.9063 14.3345 11.7871 14.3785 11.6942 14.4602L11.6608 14.4949L5.69502 21.3112C5.62674 21.3948 5.59228 21.5016 5.59862 21.61C5.60497 21.7184 5.65164 21.8203 5.72919 21.8951C5.79259 21.958 5.87645 21.9954 5.96502 22H17.9316C18.0392 21.9987 18.1419 21.9548 18.2181 21.8776C18.2942 21.8005 18.3376 21.6962 18.3391 21.587C18.3421 21.4853 18.3059 21.3863 18.2383 21.3112L12.3383 14.4949C12.3011 14.4476 12.2543 14.4091 12.2011 14.3818C12.1479 14.3545 12.0895 14.3391 12.03 14.3366H12.0292Z"
        />
      </g>
    </>
  ),
  spinner: () => (
    <>
      <g id="spinner">
        <path
          id="path"
          d="M23.7319 14.5222C23.2396 16.8125 22.0876 18.9086 20.4181 20.5519C18.7486 22.1953 16.6346 23.3141 14.3368 23.7703C12.0391 24.2265 9.65804 24.0001 7.48738 23.1192C5.31671 22.2382 3.45137 20.7412 2.1214 18.8127C0.791438 16.8843 0.0550158 14.6087 0.00296276 12.2666C-0.0490903 9.92461 0.585503 7.61855 1.82848 5.63289C3.07145 3.64723 4.86844 2.0688 6.99782 1.09229C9.12719 0.115775 11.4958 -0.216122 13.8116 0.137533L13.5117 2.10096C11.5793 1.80584 9.60269 2.08281 7.82576 2.89769C6.04883 3.71258 4.54927 5.02975 3.51203 6.68675C2.47479 8.34375 1.94523 10.2681 1.98867 12.2225C2.0321 14.1769 2.64664 16.0758 3.75647 17.6851C4.86631 19.2944 6.42291 20.5436 8.23429 21.2788C10.0457 22.0139 12.0326 22.2028 13.9501 21.8221C15.8675 21.4414 17.6316 20.5078 19.0248 19.1365C20.4179 17.7651 21.3792 16.016 21.7901 14.1048L23.7319 14.5222Z"
        />
      </g>
    </>
  ),
  menu: () => (
    <>
      <g id="menu">
        <g id="path">
          <path d="M2 4H22V6H2V4Z" />
          <path d="M2 11H22V13H2V11Z" />
          <path d="M2 18H22V20H2V18Z" />
        </g>
      </g>
    </>
  ),
  logo: () => (
    <>
      <g id="logo">
        <path
          id="path"
          d="M20.4923 4.82327C20.2716 4.82362 20.0512 4.83655 19.832 4.862H19.7896L19.7619 4.82696C18.8489 3.63622 17.6739 2.67166 16.3282 2.00802C14.9824 1.34438 13.5019 0.999466 12.0014 1C10.5009 1.00054 9.02065 1.34651 7.67535 2.01111C6.33006 2.67571 5.15582 3.6411 4.24361 4.83249L4.21779 4.86753H4.17353C3.95202 4.83989 3.7291 4.82511 3.50588 4.82327H2.17611V7.26702L2.13184 7.28731C1.49451 7.58649 0.955554 8.06097 0.578024 8.65525C0.200493 9.24953 0 9.93903 0 10.6431C0 11.3472 0.200493 12.0367 0.578024 12.6309C0.955554 13.2252 1.49451 13.6997 2.13184 13.9989L2.17611 14.0192V14.0671C2.21149 16.6493 3.26207 19.1137 5.10056 20.9271C6.93905 22.7406 9.41761 23.7573 12 23.7573C14.5824 23.7573 17.0609 22.7406 18.8994 20.9271C20.7379 19.1137 21.7885 16.6493 21.8239 14.0671V14.0192L21.8682 13.9989C22.5055 13.6997 23.0444 13.2252 23.422 12.6309C23.7995 12.0367 24 11.3472 24 10.6431C24 9.93903 23.7995 9.24953 23.422 8.65525C23.0444 8.06097 22.5055 7.58649 21.8682 7.28731L21.8239 7.26702V4.82327H20.4923ZM6.81094 5.62556C7.49022 4.93961 8.29871 4.3951 9.18969 4.02349C10.0807 3.65188 11.0365 3.46054 12.0018 3.46054C12.9672 3.46054 13.923 3.65188 14.814 4.02349C15.705 4.3951 16.5135 4.93961 17.1927 5.62556L17.2665 5.69749L17.1762 5.74728C16.8027 5.95365 16.4435 6.18471 16.1009 6.43891L16.0622 6.46658L16.0197 6.44629C14.7754 5.80886 13.4007 5.4674 12.0028 5.4485C10.6048 5.4674 9.2301 5.80886 7.98579 6.44629L7.94152 6.46658L7.90464 6.43891C7.56081 6.18457 7.20036 5.95351 6.8257 5.74728L6.73532 5.69749L6.81094 5.62556ZM19.1551 13.9933C19.1551 15.8903 18.4016 17.7095 17.0603 19.0508C15.7189 20.3922 13.8997 21.1457 12.0028 21.1457C10.1058 21.1457 8.28661 20.3922 6.94528 19.0508C5.60395 17.7095 4.8504 15.8903 4.8504 13.9933V7.77791L4.94631 7.80004C6.21153 8.11173 7.379 9.48023 7.65934 9.82328C7.97288 9.49315 9.4336 8.1228 12.0028 8.1228C14.5719 8.1228 16.0327 9.49315 16.3462 9.82328C16.6173 9.48577 17.794 8.11173 19.0574 7.7945L19.1551 7.77237V13.9933Z"
        />
      </g>
    </>
  ),
  home: () => (
    <>
      <g id="home">
        <g id="path">
          <path d="M11.8867 9L9 14L14.7735 14L11.8867 9Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 2.05078L22 7.82428V20.0002H2V7.82428L12 2.05078ZM4 8.97898L12 4.36018L20 8.97898V18.0002H4V8.97898Z"
          />
        </g>
      </g>
    </>
  ),
  'home-active': () => (
    <>
      <g id="home-active">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2.05078L22 7.82428V20.0002H2V7.82428L12 2.05078ZM12.0002 9L8.53613 15L15.4643 15L12.0002 9Z"
        />
      </g>
    </>
  ),
  watch: () => (
    <>
      <g id="watch">
        <g id="path">
          <path d="M14.7629 11.75L10 14.5V9L14.7629 11.75Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 4H22L22 20H2V4ZM20 6L20 18H4L4 6L20 6Z"
          />
        </g>
      </g>
    </>
  ),
  'watch-active': () => (
    <>
      <g id="watch-active">
        <path
          id="path"
          d="M2 4V20H22V4H2ZM10 15.25V8.75L15.6289 12L10 15.25Z"
        />
      </g>
    </>
  ),
  search: () => (
    <>
      <g id="search">
        <g id="path">
          <path d="M13.5 9.5H9.5V13.5H13.5V9.5Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5C20 13.4869 19.3183 15.3145 18.1761 16.7618L21.8037 20.3894L20.3895 21.8036L16.7618 18.176C15.3145 19.3183 13.4869 20 11.5 20C6.80558 20 3 16.1944 3 11.5ZM11.5 5C7.91015 5 5 7.91015 5 11.5C5 15.0899 7.91015 18 11.5 18C15.0899 18 18 15.0899 18 11.5C18 7.91015 15.0899 5 11.5 5Z"
          />
        </g>
      </g>
    </>
  ),
  'search-active': () => (
    <>
      <g id="search-active">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5 20C13.4869 20 15.3145 19.3183 16.7618 18.176L20.3895 21.8036L21.8037 20.3894L18.1761 16.7618C19.3183 15.3145 20 13.4869 20 11.5C20 6.80558 16.1944 3 11.5 3C6.80558 3 3 6.80558 3 11.5C3 16.1944 6.80558 20 11.5 20ZM9 9H14V14H9V9Z"
        />
      </g>
    </>
  ),
  mymusic: () => (
    <>
      <g id="mymusic">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 18C13.3137 18 16 15.3137 16 12C16 8.68629 13.3137 6 10 6C6.68629 6 4 8.68629 4 12C4 15.3137 6.68629 18 10 18ZM10 20C14.4183 20 18 16.4183 18 12C18 7.58172 14.4183 4 10 4C5.58172 4 2 7.58172 2 12C2 16.4183 5.58172 20 10 20Z"
          />
          <path d="M12 12C12 13.1046 11.1046 14 10 14C8.89543 14 8 13.1046 8 12C8 10.8954 8.89543 10 10 10C11.1046 10 12 10.8954 12 12Z" />
          <path d="M20 4H22V20H20V4Z" />
        </g>
      </g>
    </>
  ),
  'mymusic-active': () => (
    <>
      <g id="mymusic-active">
        <path
          id="path"
          d="M19.9998 4V20H21.9998V4H19.9998ZM9.99983 4C8.41758 4 6.87109 4.46909 5.55549 5.34814C4.2399 6.2272 3.21471 7.47667 2.6092 8.93848C2.0037 10.4003 1.84496 12.0087 2.15364 13.5605C2.46232 15.1124 3.22427 16.5379 4.34309 17.6567C5.46191 18.7756 6.88743 19.5375 8.43928 19.8462C9.99113 20.1549 11.5995 19.9964 13.0614 19.3909C14.5232 18.7854 15.7726 17.7602 16.6517 16.4446C17.5307 15.129 17.9998 13.5823 17.9998 12C17.9998 9.87827 17.1573 7.84331 15.6571 6.34302C14.1568 4.84273 12.1216 4 9.99983 4ZM9.99983 14.5C9.50538 14.5 9.02228 14.3533 8.61116 14.0786C8.20004 13.8039 7.87948 13.4134 7.69026 12.9565C7.50104 12.4997 7.45171 11.9972 7.54817 11.5122C7.64463 11.0273 7.88262 10.5818 8.23225 10.2322C8.58188 9.88255 9.02757 9.64431 9.51253 9.54785C9.99748 9.45139 10.5 9.50097 10.9569 9.69019C11.4137 9.8794 11.8042 10.2 12.0789 10.6111C12.3536 11.0222 12.4998 11.5055 12.4998 12C12.4998 12.663 12.2367 13.2987 11.7679 13.7676C11.2991 14.2364 10.6629 14.5 9.99983 14.5Z"
        />
      </g>
    </>
  ),
  radio: () => (
    <>
      <g id="radio">
        <g id="path">
          <path d="M14.5 12.354C14.5 13.4586 13.6046 14.354 12.5 14.354C11.3954 14.354 10.5 13.4586 10.5 12.354C10.5 11.2494 11.3954 10.354 12.5 10.354C13.6046 10.354 14.5 11.2494 14.5 12.354Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.6656 8.5188L9.19486 7.04806C7.42652 8.15199 6.25001 10.1154 6.25001 12.3536C6.25001 14.5916 7.42629 16.5549 9.19434 17.6589L10.665 16.1882C9.23648 15.5033 8.25001 14.0437 8.25001 12.3536C8.25001 10.6634 9.23674 9.20354 10.6656 8.5188ZM14.335 16.1882L15.8057 17.6589C17.5737 16.5549 18.75 14.5916 18.75 12.3536C18.75 10.1154 17.5735 8.15198 15.8051 7.04805L14.3344 8.5188C15.7633 9.20354 16.75 10.6633 16.75 12.3536C16.75 14.0437 15.7635 15.5033 14.335 16.1882Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.57597 5.43041L6.14563 4.00007C3.62624 5.91807 2 8.94898 2 12.3597C2 15.7677 3.62362 18.7965 6.13954 20.7147L7.5697 19.2846C5.40891 17.7434 4 15.2161 4 12.3597C4 9.5006 5.41164 6.97118 7.57597 5.43041ZM17.4302 19.2846L18.8604 20.7148C21.3763 18.7966 23 15.7678 23 12.3597C23 8.94894 21.3737 5.91799 18.8543 4L17.4239 5.43034C19.5883 6.9711 21 9.50056 21 12.3597C21 15.2161 19.591 17.7435 17.4302 19.2846Z"
          />
        </g>
      </g>
    </>
  ),
  'radio-active': () => (
    <>
      <g id="radio-active">
        <g id="path">
          <path d="M14.5 12.354C14.5 13.4586 13.6046 14.354 12.5 14.354C11.3954 14.354 10.5 13.4586 10.5 12.354C10.5 11.2494 11.3954 10.354 12.5 10.354C13.6046 10.354 14.5 11.2494 14.5 12.354Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.6656 8.5188L9.19486 7.04806C7.42652 8.15199 6.25001 10.1154 6.25001 12.3536C6.25001 14.5916 7.42629 16.5549 9.19434 17.6589L10.665 16.1882C9.23648 15.5033 8.25001 14.0437 8.25001 12.3536C8.25001 10.6634 9.23674 9.20354 10.6656 8.5188ZM14.335 16.1882L15.8057 17.6589C17.5737 16.5549 18.75 14.5916 18.75 12.3536C18.75 10.1154 17.5735 8.15198 15.8051 7.04805L14.3344 8.5188C15.7633 9.20354 16.75 10.6633 16.75 12.3536C16.75 14.0437 15.7635 15.5033 14.335 16.1882Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.57597 5.43041L6.14563 4.00007C3.62624 5.91807 2 8.94898 2 12.3597C2 15.7677 3.62362 18.7965 6.13954 20.7147L7.5697 19.2846C5.40891 17.7434 4 15.2161 4 12.3597C4 9.5006 5.41164 6.97118 7.57597 5.43041ZM17.4302 19.2846L18.8604 20.7148C21.3763 18.7966 23 15.7678 23 12.3597C23 8.94894 21.3737 5.91799 18.8543 4L17.4239 5.43034C19.5883 6.9711 21 9.50056 21 12.3597C21 15.2161 19.591 17.7435 17.4302 19.2846Z"
          />
        </g>
      </g>
    </>
  ),
  'search-input': () => (
    <>
      <g id="search-input">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5 3C6.80558 3 3 6.80558 3 11.5C3 16.1944 6.80558 20 11.5 20C13.4869 20 15.3145 19.3183 16.7618 18.176L20.3895 21.8037L21.8037 20.3895L18.176 16.7618C19.3183 15.3145 20 13.4869 20 11.5C20 6.80558 16.1944 3 11.5 3ZM5 11.5C5 7.91015 7.91015 5 11.5 5C15.0899 5 18 7.91015 18 11.5C18 15.0899 15.0899 18 11.5 18C7.91015 18 5 15.0899 5 11.5Z"
        />
      </g>
    </>
  ),
  profile: () => (
    <>
      <g id="profile">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5002 6.21289C16.5002 8.69817 14.4855 10.7129 12.0002 10.7129C9.51496 10.7129 7.50024 8.69817 7.50024 6.21289C7.50024 3.72761 9.51496 1.71289 12.0002 1.71289C14.4855 1.71289 16.5002 3.72761 16.5002 6.21289ZM14.5002 6.21289C14.5002 7.5936 13.381 8.71289 12.0002 8.71289C10.6195 8.71289 9.50024 7.5936 9.50024 6.21289C9.50024 4.83218 10.6195 3.71289 12.0002 3.71289C13.381 3.71289 14.5002 4.83218 14.5002 6.21289Z"
          />
          <path d="M12.0003 14.7026C15.629 14.7026 18.6128 17.4637 18.9654 20.9995H20.9732C20.6145 16.3576 16.7342 12.7026 12.0003 12.7026C7.26634 12.7026 3.38605 16.3576 3.02734 20.9995H5.03516C5.38781 17.4637 8.37161 14.7026 12.0003 14.7026Z" />
        </g>
      </g>
    </>
  ),
  'profile-active': () => (
    <>
      <g id="profile-active">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 10.71C14.4853 10.71 16.5 8.69524 16.5 6.20996C16.5 3.72468 14.4853 1.70996 12 1.70996C9.51472 1.70996 7.5 3.72468 7.5 6.20996C7.5 8.69524 9.51472 10.71 12 10.71ZM12 8.70996C13.3807 8.70996 14.5 7.59067 14.5 6.20996C14.5 4.82925 13.3807 3.70996 12 3.70996C10.6193 3.70996 9.5 4.82925 9.5 6.20996C9.5 7.59067 10.6193 8.70996 12 8.70996Z"
          />
          <path d="M20.9459 21.0068H3C3.35871 16.3649 7.239 12.71 11.9729 12.71C16.7069 12.71 20.5872 16.3649 20.9459 21.0068Z" />
        </g>
      </g>
    </>
  ),
  settings: () => (
    <>
      <g id="settings">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9998 2.5C12.6827 2.5 13.3512 2.56223 13.9998 2.68137V4.25197C14.7338 4.44089 15.4272 4.73138 16.0638 5.10757L17.175 3.99641C17.7178 4.37076 18.2345 4.79944 18.7174 5.28238C19.2004 5.76532 19.629 6.28199 20.0034 6.82484L18.8923 7.93595C19.2685 8.5726 19.559 9.26591 19.748 10H21.3186C21.4378 10.6486 21.5 11.317 21.5 12C21.5 12.683 21.4378 13.3514 21.3186 14H19.748C19.559 14.7341 19.2685 15.4274 18.8923 16.0641L20.0036 17.1755C19.6292 17.7183 19.2006 18.235 18.7176 18.7179C18.2347 19.2009 17.718 19.6295 17.1752 20.0039L16.0637 18.8925C15.4271 19.2686 14.7338 19.5591 13.9998 19.748V21.3186C13.3512 21.4378 12.6827 21.5 11.9998 21.5C11.3168 21.5 10.6483 21.4378 9.99976 21.3186V19.7479C9.26585 19.559 8.5727 19.2685 7.93618 18.8924L6.82502 20.0036C6.28218 19.6292 5.76551 19.2006 5.28256 18.7176C4.79962 18.2347 4.37095 17.718 3.9966 17.1752L5.10771 16.0641C4.73149 15.4274 4.44098 14.7341 4.25203 14H2.68137C2.56223 13.3514 2.5 12.683 2.5 12C2.5 11.317 2.56223 10.6486 2.68137 10H4.25203C4.441 9.26583 4.73156 8.57244 5.10784 7.93572L3.99665 6.82453C4.37101 6.28169 4.79968 5.76502 5.28262 5.28208C5.76556 4.79913 6.28223 4.37046 6.82508 3.99611L7.93641 5.10744C8.57287 4.73139 9.26594 4.44099 9.99976 4.2521V2.68137C10.6483 2.56223 11.3168 2.5 11.9998 2.5ZM12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z"
        />
      </g>
    </>
  ),
  'settings-active': () => (
    <>
      <g id="settings-active">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9998 2.5C12.6827 2.5 13.3512 2.56223 13.9998 2.68137V4.25197C14.7338 4.44089 15.4272 4.73138 16.0638 5.10757L17.175 3.99641C17.7178 4.37076 18.2345 4.79944 18.7174 5.28238C19.2004 5.76532 19.629 6.28199 20.0034 6.82484L18.8923 7.93595C19.2685 8.5726 19.559 9.26591 19.748 10H21.3186C21.4378 10.6486 21.5 11.317 21.5 12C21.5 12.683 21.4378 13.3514 21.3186 14H19.748C19.559 14.7341 19.2685 15.4274 18.8923 16.0641L20.0036 17.1755C19.6292 17.7183 19.2006 18.235 18.7176 18.7179C18.2347 19.2009 17.718 19.6295 17.1752 20.0039L16.0637 18.8925C15.4271 19.2686 14.7338 19.5591 13.9998 19.748V21.3186C13.3512 21.4378 12.6827 21.5 11.9998 21.5C11.3168 21.5 10.6483 21.4378 9.99976 21.3186V19.7479C9.26585 19.559 8.5727 19.2685 7.93618 18.8924L6.82502 20.0036C6.28218 19.6292 5.76551 19.2006 5.28256 18.7176C4.79962 18.2347 4.37095 17.718 3.9966 17.1752L5.10771 16.0641C4.73149 15.4274 4.44098 14.7341 4.25203 14H2.68137C2.56223 13.3514 2.5 12.683 2.5 12C2.5 11.317 2.56223 10.6486 2.68137 10H4.25203C4.441 9.26583 4.73156 8.57244 5.10784 7.93572L3.99665 6.82453C4.37101 6.28169 4.79968 5.76502 5.28262 5.28208C5.76556 4.79913 6.28223 4.37046 6.82508 3.99611L7.93641 5.10744C8.57287 4.73139 9.26594 4.44099 9.99976 4.2521V2.68137C10.6483 2.56223 11.3168 2.5 11.9998 2.5ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        />
      </g>
    </>
  ),
  notification: () => (
    <>
      <g id="notification">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.99902 19.1252L4.99976 13.928V9.00021C4.99976 5.1338 8.13354 2 12 2C15.8655 2 18.9993 5.1338 18.9993 9.00021V13.928L21.9998 19.1252H14.4493C14.4821 19.2867 14.4993 19.4538 14.4993 19.625C14.4993 21.0057 13.38 22.125 11.9993 22.125C10.6186 22.125 9.49927 21.0057 9.49927 19.625C9.49927 19.4538 9.51647 19.2867 9.54923 19.1252H1.99902ZM12.0323 17.1252C12.0213 17.1251 12.0103 17.125 11.9993 17.125C11.9882 17.125 11.9772 17.1251 11.9662 17.1252H5.46319L6.99976 14.4639V9.00021C6.99976 6.23838 9.23811 4 12 4C14.7607 4 16.9993 6.23819 16.9993 9.00021V14.4639L18.5357 17.1252H12.0323Z"
        />
      </g>
    </>
  ),
  feedback: () => (
    <>
      <g id="feedback">
        <g id="path">
          <path d="M7 7H17V9H7V7Z" />
          <path d="M7 11H17V13H7V11Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.17157 16H20V4H4V18.1716L6.17157 16ZM2 23V2H22V18H7L2 23Z"
          />
        </g>
      </g>
    </>
  ),
  shop: () => (
    <>
      <g id="shop">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.16263 3.51494L8.63774 3L2 4.59258V12.6653H5.74989V21H18.2497L18.2501 12.6653H22V4.59259L16.081 3.18169L15.3717 3.00603L13.2499 5.02715C12.9184 5.34276 12.4687 5.51988 12 5.51988C11.5314 5.51988 11.0817 5.34276 10.7502 5.02715L9.16263 3.51494ZM15.9591 5.20867L20 6.17189V10.6653H16.2502L16.2498 19H7.74989V10.6653H4V6.16949L8.03367 5.20169L9.37072 6.4753C10.0844 7.15465 11.0323 7.51988 12 7.51988C12.9677 7.51988 13.9152 7.15512 14.6289 6.47571L15.9591 5.20867Z"
        />
      </g>
    </>
  ),
  playlist: () => (
    <>
      <g id="playlist">
        <path
          id="path"
          d="M5.00161 4L5.00064 15.4838C4.36308 15.4275 3.64613 15.5603 2.9623 15.9018C1.40725 16.6785 0.612334 18.2405 1.1868 19.3908C1.76127 20.541 3.48759 20.8438 5.04264 20.0672C6.30756 19.4354 7.06953 18.284 7.00064 17.2573V12.9791C7.00096 12.9793 7.00129 12.9795 7.00161 12.9797V6H19.0016V18H9.95329C9.96283 18.1441 9.96768 18.2895 9.96768 18.436C9.96768 18.9752 9.90203 19.4991 9.77829 20H21.0016V4H5.00161Z"
        />
      </g>
    </>
  ),
  track: () => (
    <>
      <g id="track">
        <path
          id="path"
          d="M11 15.06C10.1788 14.9066 9.20743 15.042 8.28747 15.5014C6.47474 16.4068 5.5481 18.2277 6.21776 19.5685C6.88742 20.9093 8.8998 21.2623 10.7125 20.357C12.1034 19.6623 12.9732 18.4287 13 17.2865V6.46312L18 9.34987V7.04047L11 2.99902L11 15.06Z"
        />
      </g>
    </>
  ),
  artist: () => (
    <>
      <g id="artist">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.71724 20.9047L2.01758 16.2055C3.61005 14.6131 4.87995 13.3426 6.14985 12.0721L6.15521 12.0667C7.42389 10.7974 8.693 9.52769 10.2842 7.9365C10.0332 6.24249 10.542 4.45647 11.8462 3.15253C12.9403 2.05795 14.3743 1.5107 15.8081 1.51074C17.2423 1.51066 18.6761 2.05799 19.77 3.15249C21.959 5.34044 21.9591 8.88845 19.77 11.0765C18.4693 12.3774 16.6885 12.8868 14.9987 12.6403V21.9998H12.9987V14.6258L10.676 16.9474C9.46299 18.1597 8.23665 19.3853 6.71724 20.9047ZM18.3555 4.56637C17.6516 3.86209 16.7332 3.51069 15.8082 3.51074C14.8835 3.51071 13.9647 3.86211 13.2608 4.56641C12.5569 5.27017 12.2093 6.20053 12.2224 7.14542L15.7772 10.7003C16.7218 10.7133 17.652 10.3661 18.3557 9.66237C19.7633 8.25546 19.763 5.9732 18.3555 4.56637ZM13.5224 11.2739L11.6488 9.4003C10.0812 10.9679 8.82555 12.2242 7.57024 13.4801L7.56427 13.4861C6.69295 14.3578 5.82156 15.2296 4.84593 16.2055L6.71711 18.0766C7.62888 17.1651 8.44918 16.3453 9.26339 15.5315C10.5789 14.2167 11.8785 12.9179 13.5224 11.2739Z"
        />
      </g>
    </>
  ),
  album: () => (
    <>
      <g id="album">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 20V4H19V5.75488C20.829 7.22095 22 9.47388 22 12.0002C22 14.5266 20.829 16.7795 19 18.2456V20H3ZM5 6H17V18H5V6Z"
        />
      </g>
    </>
  ),
  station: () => (
    <>
      <g id="station">
        <g id="path">
          <path d="M13.5 12.354C13.5 13.4586 12.6046 14.354 11.5 14.354C10.3954 14.354 9.5 13.4586 9.5 12.354C9.5 11.2494 10.3954 10.354 11.5 10.354C12.6046 10.354 13.5 11.2494 13.5 12.354Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.66561 8.5188L8.19486 7.04806C6.42652 8.15199 5.25001 10.1154 5.25001 12.3536C5.25001 14.5916 6.42629 16.5549 8.19434 17.6589L9.66503 16.1882C8.23648 15.5033 7.25001 14.0437 7.25001 12.3536C7.25001 10.6634 8.23674 9.20354 9.66561 8.5188ZM13.335 16.1882L14.8057 17.6589C16.5737 16.5549 17.75 14.5916 17.75 12.3536C17.75 10.1154 16.5735 8.15198 14.8051 7.04805L13.3344 8.5188C14.7633 9.20354 15.75 10.6633 15.75 12.3536C15.75 14.0437 14.7635 15.5033 13.335 16.1882Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.57597 5.43041L5.14563 4.00007C2.62624 5.91807 1 8.94898 1 12.3597C1 15.7677 2.62362 18.7965 5.13954 20.7147L6.5697 19.2846C4.40891 17.7434 3 15.2161 3 12.3597C3 9.5006 4.41164 6.97118 6.57597 5.43041ZM16.4302 19.2846L17.8604 20.7148C20.3763 18.7966 22 15.7678 22 12.3597C22 8.94894 20.3737 5.91799 17.8543 4L16.4239 5.43034C18.5883 6.9711 20 9.50056 20 12.3597C20 15.2161 18.591 17.7435 16.4302 19.2846Z"
          />
        </g>
      </g>
    </>
  ),
  genre: () => (
    <>
      <g id="genre">
        <path
          id="path"
          d="M18.9727 6L9.00061 6V17.2568C9.06974 18.2836 8.30773 19.4353 7.04264 20.0671C5.48759 20.8437 3.76127 20.5409 3.1868 19.3907C2.61233 18.2405 3.40725 16.6784 4.9623 15.9018C5.64612 15.5602 6.36306 15.4274 7.00061 15.4837V4H20.9727V17.499H20.9694C20.9155 18.4601 20.1767 19.4845 19.0103 20.0671C17.4552 20.8437 15.7289 20.5409 15.1545 19.3907C14.58 18.2405 15.3749 16.6784 16.93 15.9018C17.6153 15.5594 18.334 15.4268 18.9727 15.4841V6Z"
        />
      </g>
    </>
  ),
  audiobook: () => (
    <>
      <g id="audiobook">
        <g id="path">
          <path d="M14.7629 12L10 14.75V9.25L14.7629 12Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 21V3H17C18.6569 3 20 4.34315 20 6V18C20 19.6569 18.6569 21 17 21H4ZM6 5H17C17.5523 5 18 5.44772 18 6V18C18 18.5523 17.5523 19 17 19H6V5Z"
          />
        </g>
      </g>
    </>
  ),
  video: () => (
    <>
      <g id="video">
        <g id="path">
          <path d="M14.7629 11.75L10 14.5V9L14.7629 11.75Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 4H22L22 20H2V4ZM20 6L20 18H4L4 6L20 6Z"
          />
        </g>
      </g>
    </>
  ),
  podcast: () => (
    <>
      <g id="podcast">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.999 2.5C9.2376 2.5 6.99902 4.73858 6.99902 7.5V10.5C6.99902 12.9193 8.71727 14.9373 11 15.4002V19H8V21H16V19H13V15.3998C15.2818 14.9361 16.999 12.9186 16.999 10.5V7.5C16.999 4.73858 14.7604 2.5 11.999 2.5ZM8.99902 7.5C8.99902 5.84315 10.3422 4.5 11.999 4.5C13.6559 4.5 14.999 5.84315 14.999 7.5V10.5C14.999 12.1569 13.6559 13.5 11.999 13.5C10.3422 13.5 8.99902 12.1569 8.99902 10.5V7.5Z"
          />
          <path d="M5 5.25637C3.7785 6.26517 3 7.79127 3 9.49921C3 11.2071 3.7785 12.7333 5 13.742V16.1342C2.6211 14.8767 1 12.3773 1 9.49921C1 6.62117 2.6211 4.12175 5 2.86426V5.25637Z" />
          <path d="M19 13.7407C20.2209 12.7319 20.999 11.2062 20.999 9.49869C20.999 7.79121 20.2209 6.26546 19 5.25666V2.86426C21.3784 4.12192 22.999 6.62105 22.999 9.49869C22.999 12.3763 21.3784 14.8755 19 16.1331V13.7407Z" />
        </g>
      </g>
    </>
  ),
  photo: () => (
    <>
      <g id="photo">
        <g id="path">
          <path d="M15 13C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13C9 11.3431 10.3431 10 12 10C13.6569 10 15 11.3431 15 13Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 7L15 3.5H9L7 7H2V20H22V7H17ZM20 9H15.8394L13.8394 5.5H10.1606L8.16065 9H4V18H20V9Z"
          />
        </g>
      </g>
    </>
  ),
  artwork: () => (
    <>
      <g id="artwork">
        <g id="path">
          <path d="M15.5 10C16.3284 10 17 9.32843 17 8.5C17 7.67157 16.3284 7 15.5 7C14.6716 7 14 7.67157 14 8.5C14 9.32843 14.6716 10 15.5 10Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 4V20H22V4H2ZM20 6H4V17.3333L9.97446 9.36731L14.0829 14.5028L16.5742 12.0115L20 16.1986V6ZM18.8897 18H5.99995L10.0255 12.6326L13.917 17.4971L16.4257 14.9884L18.8897 18Z"
          />
        </g>
      </g>
    </>
  ),
  merch: () => (
    <>
      <g id="merch">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
          />
          <path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" />
        </g>
      </g>
    </>
  ),
  recent: () => (
    <>
      <g id="recent">
        <g id="path">
          <path d="M7.07036 7.05025C9.80403 4.31658 14.2362 4.31658 16.9699 7.05025C19.7035 9.78392 19.7035 14.2161 16.9699 16.9497C14.2362 19.6834 9.80403 19.6834 7.07036 16.9497L5.65615 18.364C9.17086 21.8787 14.8693 21.8787 18.3841 18.364C21.8988 14.8492 21.8988 9.15076 18.3841 5.63604C14.8693 2.12132 9.17086 2.12132 5.65615 5.63604C4.0265 7.26569 3.15246 9.36481 3.03403 11.498L1.41421 9.87823L0 11.2924L4.24264 15.5351L8.48528 11.2924L7.07107 9.87823L5.02047 11.9288C5.03833 10.1612 5.72162 8.39899 7.07036 7.05025Z" />
          <path d="M11.0211 7H13.0211V11H16.0211V13H11.0211V7Z" />
        </g>
      </g>
    </>
  ),
  message: () => (
    <>
      <g id="message">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22 4H2V20H22V4ZM4 7.41434V18H20V7.41424L14.4142 13.0001H9.58574L4 7.41434ZM18.5858 6H5.41409L10.4142 11.0001H13.5857L18.5858 6Z"
        />
      </g>
    </>
  ),
  'message-bubble': () => (
    <>
      <g id="message-bubble">
        <g id="path">
          <path d="M6 7H18V9H6V7Z" />
          <path d="M12 11H6V13H12V11Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 17V3H22V17H8.5L4.5 21V17H2ZM4 5H20V15H4V5Z"
          />
        </g>
      </g>
    </>
  ),
  calendar: () => (
    <>
      <g id="calendar">
        <g id="path">
          <path d="M16.499 10C16.499 10.8284 15.8275 11.5 14.999 11.5C14.1706 11.5 13.499 10.8284 13.499 10C13.499 9.17157 14.1706 8.5 14.999 8.5C15.8275 8.5 16.499 9.17157 16.499 10Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 4V2H5V4H3V20H21V4H19.001V2H17.001V4H7ZM5 18V6H19V18H5Z"
          />
        </g>
      </g>
    </>
  ),
  time: () => (
    <>
      <g id="time">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 13V11.0911V7H13V11H16V13H11Z"
          />
        </g>
      </g>
    </>
  ),
  topchart: () => (
    <>
      <g id="topchart">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.7526 9.6585L12.6419 14.3564L10.66 12.87L8.76822 15.1402L7.23178 13.8598L10.34 10.13L12.3581 11.6436L15.2474 8.3415L16.7526 9.6585Z"
          />
        </g>
      </g>
    </>
  ),
  trending: () => (
    <>
      <g id="trending">
        <g id="path">
          <path d="M12 8.99902L14.887 13.999H9.11304L12 8.99902Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12Z"
          />
        </g>
      </g>
    </>
  ),
  post: () => (
    <>
      <g id="post">
        <path
          id="path"
          d="M12.4995 19C10.8322 18.9805 9.23607 18.3211 8.04128 17.158C6.84648 15.9948 6.14431 14.4171 6.0801 12.7509C6.01588 11.0846 6.59458 9.45745 7.69631 8.20581C8.79804 6.95417 10.3386 6.17372 11.9995 6.026V4.026C10.3645 4.12133 8.79175 4.68735 7.47096 5.65588C6.15018 6.62442 5.13765 7.95421 4.55519 9.48499C3.97274 11.0158 3.84537 12.6823 4.18825 14.2838C4.53113 15.8854 5.32968 17.3537 6.48781 18.5118C7.64594 19.67 9.11404 20.4685 10.7156 20.8114C12.3171 21.1543 13.9839 21.0268 15.5147 20.4443C17.0454 19.8619 18.375 18.8494 19.3435 17.5286C20.3121 16.2078 20.8781 14.6351 20.9734 13H18.9734C18.8475 14.6313 18.1112 16.1553 16.9111 17.2675C15.7111 18.3797 14.1357 18.9983 12.4995 19V19ZM14.6365 4V6H17.5855L12.2925 11.2931L13.7066 12.707L18.9995 7.41406V10.363H20.9995V4H14.6365Z"
        />
      </g>
    </>
  ),
  'add-shortcut': () => (
    <>
      <g id="add-shortcut">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 4H6H12V6H6V18H18V13H20V18V20H18H6H4V18V6V4ZM13.637 6.00012V4.00012H20V10.3632H18V7.41418L12.707 12.7072L11.293 11.2932L16.5859 6.00012H13.637Z"
        />
      </g>
    </>
  ),
  'people-1': () => (
    <>
      <g id="people-1">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5002 6.21289C16.5002 8.69817 14.4855 10.7129 12.0002 10.7129C9.51496 10.7129 7.50024 8.69817 7.50024 6.21289C7.50024 3.72761 9.51496 1.71289 12.0002 1.71289C14.4855 1.71289 16.5002 3.72761 16.5002 6.21289ZM14.5002 6.21289C14.5002 7.5936 13.381 8.71289 12.0002 8.71289C10.6195 8.71289 9.50024 7.5936 9.50024 6.21289C9.50024 4.83218 10.6195 3.71289 12.0002 3.71289C13.381 3.71289 14.5002 4.83218 14.5002 6.21289Z"
          />
          <path d="M12.0003 14.7026C15.629 14.7026 18.6128 17.4637 18.9654 20.9995H20.9732C20.6145 16.3576 16.7342 12.7026 12.0003 12.7026C7.26634 12.7026 3.38605 16.3576 3.02734 20.9995H5.03516C5.38781 17.4637 8.37161 14.7026 12.0003 14.7026Z" />
        </g>
      </g>
    </>
  ),
  'people-2': () => (
    <>
      <g id="people-2">
        <g id="path">
          <path d="M17.2679 5.5C17.2679 6.60457 16.3725 7.5 15.2679 7.5C15.1571 7.5 15.0484 7.49099 14.9425 7.47365C15.1679 8.12779 15.2776 8.81341 15.2694 9.5C17.4779 9.49917 19.2679 7.70862 19.2679 5.5C19.2679 3.29086 17.477 1.5 15.2679 1.5C13.6277 1.5 12.2181 2.48718 11.6008 3.8998C11.9696 4.05528 12.3238 4.24804 12.6574 4.47628C12.8945 4.63846 13.1187 4.81676 13.3285 5.00948C13.5472 4.14206 14.3326 3.5 15.2679 3.5C16.3725 3.5 17.2679 4.39543 17.2679 5.5Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.2679 9.5C13.2679 11.7091 11.4771 13.5 9.26794 13.5C7.05881 13.5 5.26794 11.7091 5.26794 9.5C5.26794 7.29086 7.05881 5.5 9.26794 5.5C11.4771 5.5 13.2679 7.29086 13.2679 9.5ZM11.2679 9.5C11.2679 10.6046 10.3725 11.5 9.26794 11.5C8.16337 11.5 7.26794 10.6046 7.26794 9.5C7.26794 8.39543 8.16337 7.5 9.26794 7.5C10.3725 7.5 11.2679 8.39543 11.2679 9.5Z"
          />
          <path d="M9.2679 17C11.7661 17 13.868 18.6963 14.4848 21H16.5358C15.8813 17.5825 12.8762 15 9.2679 15C5.6596 15 2.65448 17.5825 2 21H4.05101C4.66776 18.6963 6.76973 17 9.2679 17Z" />
          <path d="M15.0597 11.0029C14.8458 11.7895 14.4745 12.5219 13.9711 13.1567C14.3865 13.0543 14.8209 13 15.2679 13C17.7661 13 19.868 14.6963 20.4848 17H22.5358C21.8813 13.5825 18.8762 11 15.2679 11C15.1983 11 15.1288 11.001 15.0597 11.0029Z" />
        </g>
      </g>
    </>
  ),
  'people-3': () => (
    <>
      <g id="people-3">
        <g id="path">
          <path d="M6.08574 7.3933C5.29828 7.1246 4.73195 6.37844 4.73195 5.5C4.73195 4.39543 5.62738 3.5 6.73195 3.5C7.44081 3.5 8.06353 3.86877 8.41873 4.42493C8.98475 4.05036 9.60736 3.77642 10.259 3.61162C9.58469 2.35473 8.25814 1.5 6.73195 1.5C4.52281 1.5 2.73195 3.29086 2.73195 5.5C2.73195 7.36322 4.00588 8.92891 5.73024 9.37354C5.73642 8.70117 5.8556 8.03153 6.08574 7.3933Z" />
          <path d="M19.2678 5.5C19.2678 6.37844 18.7015 7.1246 17.914 7.3933C18.1441 8.03153 18.2633 8.70117 18.2695 9.37354C19.9939 8.92891 21.2678 7.36322 21.2678 5.5C21.2678 3.29086 19.4769 1.5 17.2678 1.5C15.7416 1.5 14.4151 2.35473 13.7407 3.61162C14.3924 3.77642 15.015 4.05036 15.581 4.42493C15.9362 3.86877 16.5589 3.5 17.2678 3.5C18.3724 3.5 19.2678 4.39543 19.2678 5.5Z" />
          <path d="M18.0332 11.0967C17.8337 11.7861 17.5127 12.432 17.0875 13.0048C19.408 13.1053 21.3183 14.7874 21.7675 17H23.7966C23.366 13.9898 21.0203 11.5974 18.0332 11.0967Z" />
          <path d="M5.96655 11.0967C6.16608 11.7861 6.48706 12.432 6.91223 13.0048C4.59175 13.1053 2.68142 14.7874 2.23226 17H0.203125C0.633719 13.9898 2.9795 11.5974 5.96655 11.0967Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9999 13.5C14.209 13.5 15.9999 11.7091 15.9999 9.5C15.9999 7.29086 14.209 5.5 11.9999 5.5C9.79074 5.5 7.99988 7.29086 7.99988 9.5C7.99988 11.7091 9.79074 13.5 11.9999 13.5ZM11.9999 11.5C13.1044 11.5 13.9999 10.6046 13.9999 9.5C13.9999 8.39543 13.1044 7.5 11.9999 7.5C10.8953 7.5 9.99988 8.39543 9.99988 9.5C9.99988 10.6046 10.8953 11.5 11.9999 11.5Z"
          />
          <path d="M11.9998 17C14.498 17 16.6 18.6963 17.2167 21H19.2677C18.6132 17.5825 15.6081 15 11.9998 15C8.39153 15 5.38641 17.5825 4.73193 21H6.78295C7.39969 18.6963 9.50166 17 11.9998 17Z" />
        </g>
      </g>
    </>
  ),
  list: () => (
    <>
      <g id="list">
        <g id="path">
          <path d="M6 5H4V7H6V5Z" />
          <path d="M6 11H4V13H6V11Z" />
          <path d="M6 17H4V19H6V17Z" />
          <path d="M9 11H20V13H9V11Z" />
          <path d="M9 5H20V7H9V5Z" />
          <path d="M20 17H9V19H20V17Z" />
        </g>
      </g>
    </>
  ),
  grid: () => (
    <>
      <g id="grid">
        <g id="path">
          <path d="M7 5H5V7H7V5Z" />
          <path d="M7 11H5V13H7V11Z" />
          <path d="M7 17H5V19H7V17Z" />
          <path d="M11 11H13V13H11V11Z" />
          <path d="M11 5H13V7H11V5Z" />
          <path d="M13 17H11V19H13V17Z" />
          <path d="M17 11H19V13H17V11Z" />
          <path d="M17 5H19V7H17V5Z" />
          <path d="M19 17H17V19H19V17Z" />
        </g>
      </g>
    </>
  ),
  musicmatch: () => (
    <>
      <g id="musicmatch">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.0002 10.7129C12.4855 10.7129 14.5002 8.69817 14.5002 6.21289C14.5002 3.72761 12.4855 1.71289 10.0002 1.71289C7.51496 1.71289 5.50024 3.72761 5.50024 6.21289C5.50024 8.69817 7.51496 10.7129 10.0002 10.7129ZM10.0002 8.71289C11.381 8.71289 12.5002 7.5936 12.5002 6.21289C12.5002 4.83218 11.381 3.71289 10.0002 3.71289C8.61953 3.71289 7.50024 4.83218 7.50024 6.21289C7.50024 7.5936 8.61953 8.71289 10.0002 8.71289Z"
          />
          <path d="M16.9654 21C16.6128 17.4642 13.629 14.7031 10.0003 14.7031C6.37161 14.7031 3.38781 17.4642 3.03516 21H1.02734C1.38605 16.3581 5.26634 12.7031 10.0003 12.7031C14.7342 12.7031 18.6145 16.3581 18.9732 21H16.9654Z" />
          <path d="M23.8925 10.7283C23.8019 10.9979 23.6568 11.246 23.4659 11.4571L23.4652 11.4579L20.4986 14.7509L17.5298 11.4555C17.34 11.2442 17.1957 10.9959 17.106 10.7262C17.0163 10.4565 16.9832 10.1713 17.0085 9.88845C17.0339 9.60561 17.1171 9.33087 17.2534 9.08139C17.3896 8.83204 17.5757 8.61341 17.8001 8.43915C18.0245 8.26489 18.2824 8.13869 18.5577 8.06846C18.8331 7.99823 19.1199 7.98547 19.4003 8.03095C19.6808 8.07643 19.9489 8.17919 20.1879 8.33284C20.299 8.40426 20.4027 8.48597 20.4978 8.5767C20.5927 8.48557 20.6963 8.40344 20.8074 8.33161C21.0466 8.17694 21.3151 8.07334 21.5962 8.02726C21.8773 7.98117 22.1648 7.99363 22.4409 8.06382C22.7169 8.134 22.9755 8.26038 23.2005 8.43516C23.4253 8.60986 23.6118 8.82916 23.7481 9.07935C23.8845 9.32957 23.9675 9.60515 23.9924 9.88879C24.0172 10.1725 23.9832 10.4583 23.8925 10.7283Z" />
        </g>
      </g>
    </>
  ),
  link: () => (
    <>
      <g id="link">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.90369 5.09619L8.90369 7.09619H15.6819L4.40723 18.3708L5.82144 19.785L17.0961 8.51041V15.2886H19.0961V5.09619L8.90369 5.09619Z"
        />
      </g>
    </>
  ),
  'link-small': () => (
    <>
      <g id="link-small">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.67337 6L9.67337 7.63389H15.2108L6 16.8447L7.15534 18L16.3661 8.78923V14.3266H18V6L9.67337 6Z"
        />
      </g>
    </>
  ),
  embed: () => (
    <>
      <g id="embed">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.08634 18.0938L14.0863 4.59375L15.914 5.40603L9.91396 18.906L8.08634 18.0938ZM4.42608 11.9999L7.71898 8.707L6.30476 7.29278L1.59766 11.9999L6.30476 16.707L7.71898 15.2928L4.42608 11.9999ZM19.5977 11.9999L16.3048 8.707L17.719 7.29278L22.4261 11.9999L17.719 16.707L16.3048 15.2928L19.5977 11.9999Z"
        />
      </g>
    </>
  ),
  location: () => (
    <>
      <g id="location">
        <path
          id="path"
          d="M18.0805 4.9661C16.6398 3.0735 14.4364 2 12.0635 2C9.69063 2 7.48725 3.0735 6.04657 4.9661C3.98448 7.67797 3.98448 11.435 6.04657 14.1469L12.0635 22L18.0805 14.1469C20.1426 11.435 20.1426 7.67797 18.0805 4.9661ZM12.0635 5.41802C14.2387 5.41802 16.0183 7.19768 16.0183 9.37282C16.0183 11.548 14.2387 13.3276 12.0635 13.3276C9.88837 13.3276 8.10871 11.548 8.10871 9.37282C8.10871 7.19768 9.88837 5.41802 12.0635 5.41802Z"
        />
      </g>
    </>
  ),
  newsfeed: () => (
    <>
      <g id="newsfeed">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 10L3 3L21 3V10L3 10ZM5 8L19 8V5L5 5V8Z"
          />
          <path d="M3 18H11V20H3V18Z" />
          <path d="M11 13H3V15H11V13Z" />
          <path d="M13 18H21V20H13V18Z" />
          <path d="M21 13H13V15H21V13Z" />
        </g>
      </g>
    </>
  ),
  'napster-mix': () => (
    <>
      <g id="napster-mix">
        <path
          id="path"
          d="M12.0001 3C10.22 3 8.47987 3.52791 6.99983 4.51685C5.51978 5.50578 4.36632 6.91137 3.68513 8.55591C3.00394 10.2004 2.82566 12.01 3.17292 13.7559C3.52019 15.5017 4.37738 17.1053 5.63606 18.364C6.89473 19.6227 8.49838 20.4799 10.2442 20.8271C11.99 21.1744 13.7996 20.9961 15.4442 20.3149C17.0887 19.6338 18.4943 18.4802 19.4832 17.0001C20.4722 15.5201 21.0001 13.78 21.0001 12C21.0001 9.61305 20.0519 7.32394 18.3641 5.63611C16.6763 3.94828 14.387 3 12.0001 3ZM12.0001 19C10.6156 19 9.2623 18.5895 8.11115 17.8203C6.96001 17.0511 6.0626 15.9579 5.53279 14.6788C5.00297 13.3998 4.8645 11.9923 5.13459 10.6344C5.40469 9.27653 6.0714 8.02926 7.05036 7.05029C8.02933 6.07133 9.27648 5.40462 10.6343 5.13452C11.9922 4.86442 13.3997 5.00302 14.6788 5.53284C15.9579 6.06265 17.0512 6.95994 17.8204 8.11108C18.5896 9.26223 19.0001 10.6155 19.0001 12C18.998 13.8559 18.2599 15.6352 16.9476 16.9475C15.6353 18.2598 13.8559 18.9979 12.0001 19V19ZM12.0001 10C11.6045 10 11.2179 10.1174 10.889 10.3372C10.5601 10.5569 10.3038 10.8692 10.1524 11.2346C10.001 11.6001 9.96123 12.0023 10.0384 12.3903C10.1156 12.7782 10.3061 13.1346 10.5858 13.4143C10.8655 13.694 11.222 13.8845 11.6099 13.9617C11.9979 14.0388 12.4 13.9992 12.7655 13.8478C13.1309 13.6964 13.4431 13.4401 13.6629 13.1112C13.8827 12.7823 14.0001 12.3956 14.0001 12C14.0001 11.4696 13.7894 10.9609 13.4144 10.5858C13.0393 10.2107 12.5305 10 12.0001 10Z"
        />
      </g>
    </>
  ),
  'napster-coin': () => (
    <>
      <g id="napster-coin">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 11.6978C22 14.3499 20.9464 16.8935 19.0711 18.7689C17.1957 20.6442 14.6522 21.6978 12 21.6978C9.34784 21.6978 6.8043 20.6442 4.92893 18.7689C3.05357 16.8935 2 14.3499 2 11.6978V3.00774L2.13409 3.03868C3.90304 3.47447 5.53533 5.38783 5.92728 5.86746C6.36565 5.40588 8.40794 3.48994 12 3.48994C15.5921 3.48994 17.6343 5.40588 18.0727 5.86746C18.4518 5.39556 20.097 3.47447 21.8633 3.03094L22 3V11.6978ZM12 19.5C15.866 19.5 19 16.366 19 12.5C19 8.63401 15.866 5.5 12 5.5C8.13401 5.5 5 8.63401 5 12.5C5 16.366 8.13401 19.5 12 19.5Z"
          />
          <path d="M15 12.5C15 14.1569 13.6569 15.5 12 15.5C10.3431 15.5 9 14.1569 9 12.5C9 10.8431 10.3431 9.5 12 9.5C13.6569 9.5 15 10.8431 15 12.5Z" />
        </g>
      </g>
    </>
  ),
  apple: () => (
    <>
      <g id="apple">
        <g id="path">
          <path d="M12.2526 3.64506C12.9789 2.75628 14.2252 2.07375 15.2915 2C15.4702 3.21504 14.9765 4.40509 14.3239 5.24637C13.6264 6.15015 12.4226 6.84893 11.2576 6.81268C11.0451 5.64888 11.5901 4.45134 12.2526 3.64506Z" />
          <path d="M15.6837 6.68018C17.0425 6.68018 18.4814 7.4252 19.5051 8.709C16.1488 10.5603 16.6925 15.383 20.0839 16.6743C19.6176 17.7143 19.3939 18.1781 18.7926 19.0994C17.9538 20.3844 16.7725 21.9857 15.3062 21.997C14.7035 22.0034 14.3081 21.8209 13.8817 21.6242C13.3875 21.3962 12.8518 21.1491 11.9036 21.1545C10.9606 21.1591 10.4163 21.4032 9.9154 21.6279C9.47803 21.824 9.07373 22.0053 8.46598 21.9995C7.00093 21.987 5.88089 20.5419 5.04211 19.2569C2.69827 15.6655 2.45076 11.4491 3.89706 9.20652C4.92585 7.61396 6.54841 6.68268 8.07222 6.68268C8.88436 6.68268 9.5389 6.91736 10.1627 7.141C10.7304 7.34455 11.2726 7.53896 11.8849 7.53896C12.4514 7.53896 12.9172 7.36148 13.4254 7.16788C14.0349 6.93563 14.7054 6.68018 15.6837 6.68018Z" />
        </g>
      </g>
    </>
  ),
  'apple-small': () => (
    <>
      <g id="apple-small">
        <path
          id="path"
          d="M15.9179 12.3416C15.9118 11.358 16.3833 10.6166 17.3355 10.07C16.803 9.34891 15.9972 8.95229 14.9351 8.87585C13.9295 8.80085 12.8293 9.42967 12.4264 9.42967C12.0007 9.42967 11.0271 8.90181 10.261 8.90181C8.68011 8.92489 7 10.0931 7 12.4699C7 13.1723 7.13581 13.8978 7.40744 14.6449C7.77062 15.6285 9.07992 18.0385 10.4457 17.9995C11.1598 17.9837 11.6649 17.5207 12.5943 17.5207C13.4961 17.5207 13.9631 17.9995 14.7597 17.9995C16.1376 17.9808 17.3218 15.79 17.6667 14.8035C15.8187 13.98 15.9179 12.3921 15.9179 12.3416V12.3416ZM14.3141 7.94271C15.0877 7.07448 15.0175 6.28412 14.9947 6C14.311 6.0375 13.5206 6.43989 13.0704 6.93458C12.5744 7.46533 12.283 8.12155 12.3455 8.86143C13.0841 8.91479 13.7586 8.55567 14.3141 7.94271V7.94271Z"
        />
      </g>
    </>
  ),
  facebook: () => (
    <>
      <g id="facebook">
        <path
          id="path"
          d="M12 2C6.47727 2 2 6.50029 2 12.0514C2 17.0908 5.69318 21.2516 10.5055 21.9785V14.7155H8.03136V12.0733H10.5055V10.3152C10.5055 7.40445 11.9164 6.12656 14.3232 6.12656C15.4759 6.12656 16.0855 6.21245 16.3741 6.25174V8.55808H14.7323C13.7105 8.55808 13.3536 9.5317 13.3536 10.6291V12.0733H16.3482L15.9418 14.7155H13.3536V22C18.2345 21.3343 22 17.1397 22 12.0514C22 6.50029 17.5227 2 12 2Z"
        />
      </g>
    </>
  ),
  twitter: () => (
    <>
      <g id="twitter">
        <path
          id="path"
          d="M22 5.89305C21.2639 6.21429 20.474 6.43216 19.6442 6.52942C20.4915 6.02968 21.1402 5.23702 21.4476 4.2954C20.6527 4.75819 19.7754 5.09424 18.8405 5.27641C18.092 4.48989 17.0271 4 15.8461 4C13.5803 4 11.7431 5.80937 11.7431 8.03969C11.7431 8.35601 11.7794 8.66496 11.8494 8.96039C8.44001 8.79174 5.41684 7.18301 3.39347 4.7385C3.03977 5.33425 2.83856 6.02842 2.83856 6.76943C2.83856 8.1714 3.56343 9.40841 4.66324 10.1321C3.99085 10.11 3.35847 9.92782 2.80484 9.62502V9.67549C2.80484 11.6326 4.21958 13.2659 6.09546 13.6376C5.75177 13.7287 5.38935 13.7792 5.01442 13.7792C4.74948 13.7792 4.49327 13.7534 4.24206 13.7041C4.76445 15.3104 6.27919 16.4785 8.07387 16.5105C6.67037 17.5937 4.90069 18.2374 2.97856 18.2374C2.64739 18.2374 2.32118 18.2177 2 18.182C3.81592 19.3304 5.97177 20 8.28883 20C15.8362 20 19.9617 13.8432 19.9617 8.50374L19.9479 7.98063C20.754 7.41439 21.4513 6.70297 22 5.89305Z"
        />
      </g>
    </>
  ),
  google: () => (
    <>
      <g id="google">
        <path
          id="path"
          d="M12.002 10.239V14.06H17.447C16.735 16.375 14.8 18.032 12.002 18.032C8.67 18.032 5.969 15.331 5.969 12C5.969 8.669 8.67 5.968 12.002 5.968C13.5 5.968 14.868 6.517 15.923 7.421L18.737 4.607C16.96 2.988 14.596 2 12.002 2C6.478 2 2 6.477 2 12C2 17.523 6.478 22 12.002 22C20.398 22 22.251 14.15 21.428 10.252L12.002 10.239Z"
        />
      </g>
    </>
  ),
  android: () => (
    <>
      <g id="android">
        <path
          id="path"
          d="M17.61 10.1358L19.48 6.94579C19.59 6.61579 19.48 6.28579 19.26 6.06579C18.93 5.95579 18.6 5.95579 18.38 6.28579L16.51 9.47579C13.65 8.26579 10.46 8.26579 7.6 9.47579L5.62 6.39579C5.51 6.06579 5.07 5.95579 4.74 6.17579C4.52 6.28579 4.41 6.72579 4.52 6.94579L6.39 10.1358C3.31 11.8958 1.33 15.0858 1 18.7158H23C22.67 15.0858 20.69 11.8958 17.61 10.1358ZM7.05 15.9658C6.28 15.9658 5.73 15.4158 5.73 14.6458C5.73 13.8758 6.28 13.4358 6.94 13.4358C7.6 13.4358 8.15 13.9858 8.15 14.6458C8.15 15.3058 7.71 15.9658 7.05 15.9658ZM16.95 15.9658C16.29 15.9658 15.74 15.4158 15.74 14.7558C15.74 14.0958 16.29 13.5458 16.95 13.5458C17.61 13.5458 18.16 14.0958 18.16 14.7558C18.16 15.4158 17.72 15.9658 16.95 15.9658Z"
        />
      </g>
    </>
  ),
  windows: () => (
    <>
      <g id="windows">
        <path
          id="path"
          d="M3 5.69009L10.7647 4.63587L10.7681 12.1025L3.00709 12.1465L3 5.69009ZM10.761 12.9628L10.767 20.4359L3.00603 19.3721L3.00559 12.9126L10.761 12.9628ZM11.7023 4.49796L21.9976 3V12.0075L11.7023 12.089V4.49796ZM22 13.033L21.9976 22L11.7022 20.5514L11.6878 13.0163L22 13.033Z"
        />
      </g>
    </>
  ),
  'windows-small': () => (
    <>
      <g id="windows-small">
        <path
          id="path"
          d="M6 7.699L10.904 7.03318L10.9062 11.7489L6.00448 11.7768L6 7.699ZM10.9017 12.2923L10.9055 17.0121L6.00381 16.3403L6.00353 12.2606L10.9017 12.2923ZM11.4962 6.94608L17.9985 6V11.689L11.4962 11.7404V6.94608ZM18 12.3367L17.9985 18L11.4962 17.0851L11.487 12.3261L18 12.3367Z"
        />
      </g>
    </>
  ),
  whatsapp: () => (
    <>
      <g id="whatsapp">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.0017 4.90805C17.1342 3.03112 14.6443 2 11.9929 2C6.53314 2 2.08553 6.44761 2.08078 11.9073C2.08078 13.656 2.53694 15.3571 3.40176 16.8634L2 22L7.2554 20.622C8.70468 21.4108 10.3345 21.8289 11.9929 21.8289H11.9976C17.4574 21.8289 21.905 17.3813 21.9097 11.9168C21.905 9.27013 20.8738 6.78023 19.0017 4.90805ZM15.0919 13.3893C15.3412 13.4828 16.671 14.1374 16.9411 14.2724C16.9944 14.299 17.0442 14.323 17.0903 14.3453C17.2785 14.4359 17.4064 14.4975 17.4606 14.5893C17.5281 14.7036 17.5281 15.2438 17.3047 15.8776C17.0762 16.5113 15.9957 17.0879 15.4763 17.1658C15.0087 17.2333 14.4217 17.2645 13.7724 17.0567C13.3776 16.9321 12.8738 16.7658 12.2296 16.4853C9.68464 15.3856 7.96928 12.9183 7.65152 12.4612C7.63007 12.4304 7.61499 12.4087 7.60645 12.3972C7.60426 12.3942 7.60185 12.391 7.59924 12.3875C7.44019 12.1738 6.5 10.9107 6.5 9.5973C6.5 8.34184 7.11559 7.68819 7.39632 7.3901C7.41411 7.37121 7.43056 7.35375 7.44542 7.33765C7.69476 7.06753 7.98565 7 8.16746 7C8.34927 7 8.53109 7 8.68692 7.01039C8.7057 7.01098 8.72521 7.01057 8.74535 7.01015C8.90355 7.00684 9.10116 7.00271 9.29469 7.47271C9.39118 7.70078 9.54322 8.0705 9.69179 8.43178C9.89514 8.92628 10.092 9.40497 10.131 9.48301C10.1985 9.61807 10.2401 9.77391 10.1518 9.95572C10.1414 9.9772 10.1315 9.99774 10.122 10.0175C10.0512 10.1651 10.0008 10.2702 9.88168 10.4077C9.83293 10.4639 9.78215 10.5256 9.73154 10.587C9.64193 10.6958 9.55285 10.804 9.4765 10.8804C9.34144 11.0154 9.20119 11.1609 9.35702 11.431C9.51806 11.7011 10.0583 12.5894 10.8635 13.3062C11.7291 14.0805 12.4817 14.4067 12.8623 14.5717C12.9362 14.6037 12.9961 14.6297 13.04 14.6516C13.3101 14.7867 13.4711 14.7659 13.627 14.5841C13.7828 14.4075 14.3023 13.7945 14.4841 13.5244C14.6607 13.2543 14.8425 13.301 15.0919 13.3893Z"
        />
      </g>
    </>
  ),
  amazon: () => (
    <>
      <g id="amazon">
        <path
          id="path"
          d="M2.02723 17.0232C2.08823 16.9252 2.18323 16.9182 2.31623 17.0032C5.35123 18.7632 8.65423 19.6482 12.2222 19.6482C14.6032 19.6482 16.9522 19.2012 19.2732 18.3162L19.5352 18.1992C19.6502 18.1482 19.7302 18.1152 19.7792 18.0902C19.9682 18.0162 20.1052 18.0532 20.2172 18.1992C20.3192 18.3422 20.2932 18.4782 20.1172 18.5992C19.9042 18.7572 19.6172 18.9412 19.2772 19.1442C18.2402 19.7632 17.0742 20.2422 15.7852 20.5852C14.5556 20.9159 13.2885 21.0866 12.0152 21.0932C10.1262 21.0932 8.33523 20.7632 6.64623 20.1032C4.97996 19.451 3.44504 18.5035 2.11523 17.3062C2.03123 17.2452 1.99023 17.1832 1.99023 17.1222C1.99023 17.0832 2.00623 17.0482 2.03123 17.0132L2.02723 17.0232V17.0232ZM7.50623 11.8342C7.50623 10.9942 7.71323 10.2792 8.12523 9.68223C8.53923 9.09023 9.10223 8.64123 9.82823 8.33623C10.4942 8.05523 11.2932 7.85623 12.2582 7.73423C12.5842 7.69723 13.1192 7.64823 13.8582 7.58923V7.27923C13.8582 6.50623 13.7742 5.98023 13.6102 5.71523C13.3582 5.35623 12.9602 5.17423 12.4072 5.17423H12.2572C11.8572 5.21323 11.5112 5.33623 11.2182 5.55723C10.9242 5.78297 10.7234 6.10901 10.6542 6.47323C10.6052 6.72323 10.4822 6.86023 10.2932 6.89923L8.18823 6.63523C7.97923 6.58423 7.87723 6.48523 7.87723 6.30923C7.87723 6.27223 7.88323 6.23523 7.89523 6.18623C8.10423 5.10823 8.61023 4.30523 9.41523 3.78223C10.2292 3.26823 11.1672 2.96823 12.2432 2.90723H12.6942C14.0732 2.90723 15.1632 3.26823 15.9382 3.98323C16.0532 4.10623 16.1652 4.23323 16.2782 4.38123C16.3782 4.52023 16.4662 4.64523 16.5122 4.75823C16.5752 4.86923 16.6392 5.03323 16.6762 5.23323C16.7272 5.44623 16.7642 5.58523 16.7892 5.65923C16.8122 5.74523 16.8402 5.90923 16.8532 6.17323C16.8592 6.43523 16.8692 6.58323 16.8692 6.63423V11.0402C16.8692 11.3542 16.9182 11.6422 17.0062 11.9052C17.0942 12.1652 17.1802 12.3562 17.2682 12.4682L17.6962 13.0292C17.7603 13.1181 17.7987 13.223 17.8072 13.3322C17.8072 13.4342 17.7582 13.5202 17.6592 13.5922C16.6572 14.4692 16.1062 14.9442 16.0202 15.0202C15.8832 15.1332 15.7072 15.1452 15.4952 15.0592C15.3413 14.9295 15.1947 14.7913 15.0562 14.6452L14.7982 14.3542C14.7472 14.2912 14.6572 14.1802 14.5322 14.0022L14.2822 13.6392C13.6062 14.3792 12.9442 14.8442 12.2802 15.0322C11.8662 15.1572 11.3662 15.2202 10.7512 15.2202C9.82524 15.2202 9.05023 14.9352 8.44823 14.3572C7.85023 13.7812 7.54823 12.9682 7.54823 11.9042L7.50523 11.8412L7.50623 11.8342V11.8342ZM10.6372 11.4672C10.6372 11.9422 10.7542 12.3192 10.9922 12.6062C11.2282 12.8912 11.5552 13.0342 11.9572 13.0342C11.9922 13.0342 12.0452 13.0262 12.1172 13.0162C12.1952 13.0042 12.2282 12.9962 12.2582 12.9962C12.7702 12.8632 13.1602 12.5352 13.4472 12.0142C13.5858 11.7787 13.6867 11.5229 13.7462 11.2562C13.8222 10.9882 13.8462 10.7622 13.8572 10.5902C13.8732 10.4242 13.8732 10.1372 13.8732 9.75023V9.29923C13.1702 9.29923 12.6332 9.34823 12.2692 9.44723C11.2062 9.75023 10.6652 10.4242 10.6652 11.4762L10.6362 11.4602V11.4672H10.6372ZM18.2832 17.3322C18.3082 17.2812 18.3462 17.2402 18.3922 17.1892C18.6932 16.9882 18.9882 16.8472 19.2692 16.7732C19.7091 16.6601 20.1595 16.5928 20.6132 16.5722C20.7302 16.5622 20.8472 16.5722 20.9592 16.5972C21.4982 16.6482 21.8322 16.7382 21.9362 16.8702C21.9892 16.9482 22.0102 17.0612 22.0102 17.1982V17.3232C22.0102 17.7492 21.8932 18.2492 21.6622 18.8252C21.4312 19.4012 21.1092 19.8662 20.6992 20.2272C20.6382 20.2762 20.5842 20.3012 20.5352 20.3012C20.5102 20.3012 20.4842 20.3012 20.4612 20.2912C20.3852 20.2542 20.3712 20.1912 20.4062 20.0902C20.8572 19.0392 21.0782 18.3032 21.0782 17.8892C21.0782 17.7622 21.0532 17.6622 21.0042 17.6002C20.8852 17.4632 20.5472 17.3832 19.9842 17.3832C19.7415 17.3869 19.499 17.3999 19.2572 17.4222C18.9542 17.4632 18.6752 17.5002 18.4232 17.5372C18.3492 17.5372 18.3002 17.5232 18.2732 17.5002C18.2482 17.4752 18.2422 17.4612 18.2552 17.4362C18.2552 17.4222 18.2612 17.4112 18.2732 17.3832V17.3342L18.2832 17.3322V17.3322Z"
        />
      </g>
    </>
  ),
  dolby: () => (
    <>
      <g id="dolby">
        <path
          id="path"
          d="M2 19.0598H4.07381C5.93825 19.0598 7.72633 18.3191 9.04469 17.0008C10.363 15.6824 11.1037 13.8943 11.1037 12.0299C11.1037 10.1654 10.363 8.37736 9.04469 7.059C7.72633 5.74065 5.93825 5 4.07381 5H2V19.0598ZM22 5H19.9242C18.0598 5 16.2717 5.74065 14.9534 7.059C13.635 8.37736 12.8944 10.1654 12.8944 12.0299C12.8944 13.8943 13.635 15.6824 14.9534 17.0008C16.2717 18.3191 18.0598 19.0598 19.9242 19.0598H22V5Z"
        />
      </g>
    </>
  ),
  algorand: () => (
    <>
      <g id="algorand">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21 21.0251H18.1776L16.3451 14.206L12.4054 21.0251H9.25461L15.3451 10.4707L14.3652 6.8057L6.15243 21.0285H3L13.407 3H16.1675L17.3752 7.47906H20.2228L18.2781 10.8593L21 21.0251Z"
        />
      </g>
    </>
  ),
  instagram: () => (
    <>
      <g id="instagram">
        <path
          id="path"
          d="M12 3.80184C14.6701 3.80184 14.9864 3.812 16.0408 3.86011C17.0158 3.90461 17.5453 4.06752 17.8977 4.20443C18.3644 4.38583 18.6976 4.60257 19.0475 4.95248C19.3974 5.30239 19.6142 5.63555 19.7955 6.10229C19.9325 6.4547 20.0954 6.98419 20.1399 7.95914C20.188 9.01364 20.1982 9.32989 20.1982 12C20.1982 14.6701 20.188 14.9864 20.1399 16.0409C20.0954 17.0158 19.9325 17.5453 19.7955 17.8978C19.6142 18.3645 19.3974 18.6976 19.0475 19.0476C18.6976 19.3975 18.3644 19.6142 17.8977 19.7956C17.5453 19.9325 17.0158 20.0954 16.0408 20.1399C14.9865 20.188 14.6703 20.1982 12 20.1982C9.32969 20.1982 9.01344 20.188 7.95914 20.1399C6.98415 20.0954 6.45466 19.9325 6.10229 19.7956C5.63551 19.6142 5.30235 19.3975 4.95244 19.0476C4.60253 18.6976 4.38579 18.3645 4.20443 17.8978C4.06748 17.5453 3.90457 17.0158 3.86007 16.0409C3.81196 14.9864 3.8018 14.6701 3.8018 12C3.8018 9.32989 3.81196 9.01364 3.86007 7.95918C3.90457 6.98419 4.06748 6.4547 4.20443 6.10229C4.38579 5.63555 4.60253 5.30239 4.95244 4.95248C5.30235 4.60257 5.63551 4.38583 6.10229 4.20443C6.45466 4.06752 6.98415 3.90461 7.9591 3.86011C9.0136 3.812 9.32985 3.80184 12 3.80184ZM12 2C9.28412 2 8.94362 2.01151 7.87701 2.06018C6.81259 2.10876 6.08569 2.27779 5.44958 2.52501C4.79199 2.78056 4.23432 3.1225 3.67839 3.67843C3.12246 4.23436 2.78052 4.79203 2.52497 5.44962C2.27775 6.08573 2.10872 6.81263 2.06014 7.87705C2.01147 8.94362 2 9.28416 2 12C2 14.7159 2.01147 15.0564 2.06014 16.123C2.10872 17.1874 2.27775 17.9143 2.52497 18.5504C2.78052 19.208 3.12246 19.7657 3.67839 20.3216C4.23432 20.8775 4.79199 21.2195 5.44958 21.475C6.08569 21.7223 6.81259 21.8913 7.87701 21.9399C8.94362 21.9885 9.28412 22 12 22C14.7158 22 15.0564 21.9885 16.1229 21.9399C17.1874 21.8913 17.9143 21.7223 18.5504 21.475C19.208 21.2195 19.7656 20.8775 20.3216 20.3216C20.8775 19.7657 21.2194 19.208 21.475 18.5504C21.7222 17.9143 21.8912 17.1874 21.9398 16.123C21.9885 15.0564 22 14.7159 22 12C22 9.28416 21.9885 8.94362 21.9398 7.87705C21.8912 6.81263 21.7222 6.08573 21.475 5.44962C21.2194 4.79203 20.8775 4.23436 20.3216 3.67843C19.7656 3.1225 19.208 2.78056 18.5504 2.52501C17.9143 2.27779 17.1874 2.10876 16.1229 2.06018C15.0564 2.01151 14.7158 2 12 2ZM12 6.86487C9.16393 6.86487 6.86483 9.16397 6.86483 12C6.86483 14.8361 9.16393 17.1352 12 17.1352C14.836 17.1352 17.1351 14.8361 17.1351 12C17.1351 9.16397 14.836 6.86487 12 6.86487ZM12 15.3334C10.159 15.3334 8.66663 13.841 8.66663 12C8.66663 10.1591 10.159 8.66667 12 8.66667C13.8409 8.66667 15.3333 10.1591 15.3333 12C15.3333 13.841 13.8409 15.3334 12 15.3334ZM18.538 6.66199C18.538 7.32474 18.0008 7.86201 17.338 7.86201C16.6753 7.86201 16.138 7.32474 16.138 6.66199C16.138 5.99924 16.6753 5.462 17.338 5.462C18.0008 5.462 18.538 5.99924 18.538 6.66199Z"
        />
      </g>
    </>
  ),
  tiktok: () => (
    <>
      <g id="tiktok">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.5479 6.90893C19.2934 6.87095 18.1566 6.27132 17.2995 5.46663C16.8323 5.01982 16.4626 4.48088 16.2134 3.88446C15.9641 3.28774 15.8409 2.6462 15.8512 2H12.3582V15.0184C12.3582 17.2147 11.0484 18.5114 9.42281 18.5114C9.0316 18.52 8.64272 18.4506 8.27887 18.3068C7.91501 18.1633 7.58362 17.9485 7.30389 17.6749C7.02416 17.4014 6.80207 17.0748 6.65027 16.7141C6.49861 16.3536 6.42046 15.9662 6.42046 15.5751C6.42046 15.1838 6.49861 14.7966 6.65027 14.4361C6.80207 14.0755 7.02416 13.7488 7.30389 13.4753C7.58362 13.2018 7.91501 12.987 8.27887 12.8432C8.64272 12.6996 9.0316 12.6303 9.42281 12.6387C9.7462 12.6415 10.0668 12.698 10.3717 12.8064V9.24908C10.0598 9.18126 9.74184 9.14764 9.42281 9.1488C8.15195 9.14953 6.91006 9.52663 5.85372 10.2331C4.79739 10.9394 3.97422 11.9432 3.4884 13.1174C3.00244 14.2916 2.87553 15.5837 3.12382 16.8297C3.37211 18.0761 3.98426 19.2206 4.88312 20.1191C5.78183 21.0173 6.92679 21.629 8.1732 21.8768C9.41947 22.1245 10.7114 21.997 11.8852 21.5106C13.0593 21.024 14.0626 20.2006 14.7685 19.1438C15.4745 18.0873 15.8512 16.8451 15.8512 15.5743V8.77025C17.2047 9.71365 18.8218 10.1503 20.5479 10.1792V6.90893Z"
        />
      </g>
    </>
  ),
  reddit: () => (
    <>
      <g id="reddit">
        <path
          id="path"
          d="M23.4096 12.1606C23.4096 10.7952 22.3052 9.71084 20.9598 9.71084C20.2972 9.71084 19.6948 9.97189 19.253 10.3936C17.5663 9.18876 15.257 8.40562 12.6867 8.30522L13.8112 3.04418L17.4659 3.82731C17.506 4.75101 18.2691 5.49398 19.2129 5.49398C20.1767 5.49398 20.9598 4.71084 20.9598 3.74699C20.9598 2.78313 20.1767 2 19.2129 2C18.5301 2 17.9277 2.40161 17.6466 2.98394L13.5703 2.12048C13.4498 2.1004 13.3293 2.12048 13.249 2.18072C13.1486 2.24096 13.0884 2.34137 13.0683 2.46185L11.8233 8.3253C9.21285 8.40562 6.86345 9.18876 5.15663 10.4137C4.71486 9.99197 4.11245 9.73092 3.4498 9.73092C2.08434 9.73092 1 10.8353 1 12.1807C1 13.1847 1.60241 14.0281 2.44578 14.4096C2.40562 14.6506 2.38554 14.8916 2.38554 15.1526C2.38554 18.9277 6.78313 22 12.2048 22C17.6265 22 22.0241 18.9478 22.0241 15.1526C22.0241 14.9116 22.004 14.6506 21.9639 14.4096C22.8072 14.0281 23.4096 13.1647 23.4096 12.1606V12.1606ZM6.58233 13.9076C6.58233 12.9438 7.36546 12.1606 8.32932 12.1606C9.29317 12.1606 10.0763 12.9438 10.0763 13.9076C10.0763 14.8715 9.29317 15.6546 8.32932 15.6546C7.36546 15.6747 6.58233 14.8715 6.58233 13.9076V13.9076ZM16.3614 18.5462C15.1566 19.751 12.8675 19.8313 12.2048 19.8313C11.5221 19.8313 9.23293 19.7309 8.04819 18.5462C7.86747 18.3655 7.86747 18.0843 8.04819 17.9036C8.22892 17.7229 8.51004 17.7229 8.69076 17.9036C9.45382 18.6667 11.0602 18.9277 12.2048 18.9277C13.3494 18.9277 14.9759 18.6667 15.7189 17.9036C15.8996 17.7229 16.1807 17.7229 16.3614 17.9036C16.5221 18.0843 16.5221 18.3655 16.3614 18.5462ZM16.0402 15.6747C15.0763 15.6747 14.2932 14.8916 14.2932 13.9277C14.2932 12.9639 15.0763 12.1807 16.0402 12.1807C17.004 12.1807 17.7871 12.9639 17.7871 13.9277C17.7871 14.8715 17.004 15.6747 16.0402 15.6747Z"
        />
      </g>
    </>
  ),
  discord: () => (
    <>
      <g id="discord">
        <path
          id="path"
          d="M19.6239 5.40921C18.2217 4.75695 16.7181 4.27639 15.1459 4.00115C15.1173 3.99584 15.0887 4.00912 15.0739 4.03567C14.8805 4.38436 14.6663 4.83925 14.5163 5.19679C12.8254 4.94015 11.1431 4.94015 9.48679 5.19679C9.33676 4.8313 9.11478 4.38436 8.92053 4.03567C8.90578 4.01 8.87718 3.99673 8.84855 4.00115C7.27725 4.27551 5.7736 4.75607 4.37052 5.40921C4.35838 5.41452 4.34797 5.42337 4.34106 5.43487C1.48894 9.75461 0.707629 13.9682 1.09092 18.1295C1.09265 18.1498 1.10392 18.1693 1.11953 18.1817C3.00127 19.5827 4.82407 20.4332 6.61301 20.9969C6.64164 21.0058 6.67197 20.9951 6.69019 20.9712C7.11337 20.3854 7.49059 19.7676 7.81402 19.118C7.83311 19.08 7.81489 19.0348 7.77588 19.0198C7.17754 18.7897 6.6078 18.5091 6.05975 18.1906C6.0164 18.1649 6.01293 18.102 6.05281 18.0719C6.16814 17.9843 6.2835 17.8932 6.39363 17.8011C6.41355 17.7843 6.44131 17.7808 6.46474 17.7914C10.0652 19.4579 13.9631 19.4579 17.521 17.7914C17.5445 17.7799 17.5722 17.7834 17.593 17.8002C17.7032 17.8923 17.8185 17.9843 17.9347 18.0719C17.9746 18.102 17.972 18.1649 17.9286 18.1906C17.3806 18.5153 16.8108 18.7897 16.2116 19.0189C16.1726 19.034 16.1553 19.08 16.1744 19.118C16.5047 19.7667 16.882 20.3845 17.2973 20.9704C17.3147 20.9951 17.3459 21.0058 17.3745 20.9969C19.1721 20.4332 20.9949 19.5827 22.8766 18.1817C22.8931 18.1693 22.9035 18.1507 22.9053 18.1304C23.364 13.3194 22.137 9.14042 19.6525 5.43575C19.6465 5.42337 19.6361 5.41452 19.6239 5.40921ZM8.35169 15.5957C7.26771 15.5957 6.37454 14.5868 6.37454 13.3478C6.37454 12.1087 7.25039 11.0998 8.35169 11.0998C9.46163 11.0998 10.3462 12.1176 10.3288 13.3478C10.3288 14.5868 9.45296 15.5957 8.35169 15.5957ZM15.6619 15.5957C14.5779 15.5957 13.6847 14.5868 13.6847 13.3478C13.6847 12.1087 14.5606 11.0998 15.6619 11.0998C16.7718 11.0998 17.6563 12.1176 17.639 13.3478C17.639 14.5868 16.7718 15.5957 15.6619 15.5957Z"
        />
      </g>
    </>
  ),
  polygon: () => (
    <>
      <g id="polygon">
        <path
          id="path"
          d="M17.1436 8.37859C16.7781 8.16971 16.3081 8.16971 15.8903 8.37859L12.9661 10.1018L10.9817 11.1984L8.10966 12.9217C7.74413 13.1305 7.27415 13.1305 6.8564 12.9217L4.61097 11.564C4.24543 11.3551 3.98433 10.9373 3.98433 10.4674V7.8564C3.98433 7.43864 4.19321 7.02089 4.61097 6.75979L6.8564 5.45431C7.22193 5.24543 7.69191 5.24543 8.10966 5.45431L10.3551 6.81201C10.7206 7.02089 10.9817 7.43864 10.9817 7.90862V9.63185L12.9661 8.48303V6.70757C12.9661 6.28982 12.7572 5.87206 12.3394 5.61097L8.16188 3.15666C7.79634 2.94778 7.32637 2.94778 6.90862 3.15666L2.62663 5.66319C2.20888 5.87206 2 6.28982 2 6.70757V11.6162C2 12.0339 2.20888 12.4517 2.62663 12.7128L6.8564 15.1671C7.22193 15.376 7.69191 15.376 8.10966 15.1671L10.9817 13.4961L12.9661 12.3473L15.8381 10.6762C16.2037 10.4674 16.6736 10.4674 17.0914 10.6762L19.3368 11.9817C19.7023 12.1906 19.9634 12.6084 19.9634 13.0783V15.6893C19.9634 16.107 19.7546 16.5248 19.3368 16.7859L17.1436 18.0914C16.7781 18.3003 16.3081 18.3003 15.8903 18.0914L13.6449 16.7859C13.2794 16.577 13.0183 16.1593 13.0183 15.6893V14.0183L11.0339 15.1671V16.8903C11.0339 17.3081 11.2428 17.7258 11.6606 17.9869L15.8903 20.4413C16.2559 20.6501 16.7258 20.6501 17.1436 20.4413L21.3734 17.9869C21.7389 17.7781 22 17.3603 22 16.8903V11.9295C22 11.5117 21.7911 11.094 21.3734 10.8329L17.1436 8.37859Z"
        />
      </g>
    </>
  ),
  youtube: () => (
    <>
      <g id="youtube">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.3136 5.41818C21.1746 5.64867 21.8513 6.32532 22.0818 7.18637C22.4983 8.74547 22.5 12.0003 22.5 12.0003C22.5 12.0003 22.5 15.2552 22.0818 16.8143C21.8513 17.6754 21.1746 18.352 20.3136 18.5825C18.7545 19.0007 12.5 19.0007 12.5 19.0007C12.5 19.0007 6.24547 19.0007 4.68636 18.5825C3.82532 18.352 3.14867 17.6754 2.91818 16.8143C2.5 15.2552 2.5 12.0003 2.5 12.0003C2.5 12.0003 2.5 8.74547 2.91818 7.18637C3.14867 6.32532 3.82532 5.64867 4.68636 5.41818C6.24547 5 12.5 5 12.5 5C12.5 5 18.7545 5 20.3136 5.41818ZM15.694 12.0006L10.4981 15.0002V9.00089L15.694 12.0006Z"
        />
      </g>
    </>
  ),
  tidal: () => (
    <>
      <g id="tidal">
        <g id="path">
          <path d="M15.3336 9.3328L12.0005 12.6666L8.66675 9.3328L12.0005 6.00042L15.3336 9.3328Z" />
          <path d="M15.3336 15.9999L12.0005 19.3337L8.66675 15.9999L12.0005 12.6666L15.3336 15.9999Z" />
          <path d="M8.66675 9.3328L5.33308 12.6669L2 9.33308L5.33308 6L8.66675 9.3328Z" />
          <path d="M22 9.33308L18.6669 12.6669L15.3331 9.33308L18.6669 6L22 9.33308Z" />
        </g>
      </g>
    </>
  ),
  spotify: () => (
    <>
      <g id="spotify">
        <path
          id="path"
          d="M12.4999 2C6.97724 2 2.5 6.47712 2.5 11.9998C2.5 17.5228 6.97724 21.9995 12.4999 21.9995C18.0232 21.9995 22.5 17.5228 22.5 11.9998C22.5 6.47748 18.0232 2.00048 12.4998 2.00048L12.4999 2ZM17.0858 16.4226C16.9067 16.7164 16.5222 16.8095 16.2285 16.6292C13.8806 15.1951 10.9249 14.8703 7.44403 15.6655C7.1086 15.742 6.77424 15.5318 6.69782 15.1962C6.62104 14.8607 6.83037 14.5263 7.16663 14.4499C10.9759 13.5796 14.2434 13.9544 16.8793 15.5652C17.173 15.7455 17.2662 16.1289 17.0858 16.4226ZM18.3098 13.6998C18.0841 14.0666 17.6041 14.1824 17.2375 13.9567C14.5495 12.3046 10.4521 11.8261 7.27279 12.7912C6.86046 12.9157 6.42496 12.6833 6.29982 12.2717C6.17563 11.8594 6.40812 11.4247 6.81974 11.2993C10.4514 10.1974 14.9663 10.7312 18.0531 12.628C18.4197 12.8537 18.5355 13.3337 18.3098 13.6998ZM18.4149 10.8644C15.192 8.95015 9.87454 8.77414 6.79741 9.70806C6.30328 9.85792 5.78073 9.57898 5.63099 9.08485C5.48125 8.59048 5.75995 8.06829 6.25444 7.91807C9.78677 6.84575 15.6589 7.05293 19.3695 9.25573C19.8149 9.51951 19.9606 10.0935 19.6967 10.5374C19.434 10.9818 18.8584 11.1284 18.4154 10.8644H18.4149Z"
        />
      </g>
    </>
  ),
  deezer: () => (
    <>
      <g id="deezer">
        <g id="path">
          <path d="M17.6754 5.5H22V8.01969H17.6754V5.5Z" />
          <path d="M17.6754 8.99343H22V11.5131H17.6754V8.99343Z" />
          <path d="M22 12.4869H17.6754V15.0066H22V12.4869Z" />
          <path d="M2 15.9803H6.3246V18.5H2V15.9803Z" />
          <path d="M11.5464 15.9803H7.22177V18.5H11.5464V15.9803Z" />
          <path d="M12.4536 15.9803H16.7782V18.5H12.4536V15.9803Z" />
          <path d="M22 15.9803H17.6754V18.5H22V15.9803Z" />
          <path d="M12.4536 12.4869H16.7782V15.0066H12.4536V12.4869Z" />
          <path d="M11.5464 12.4869H7.22177V15.0066H11.5464V12.4869Z" />
          <path d="M7.22177 8.99343H11.5464V11.5131H7.22177V8.99343Z" />
        </g>
      </g>
    </>
  ),
  soundcloud: () => (
    <>
      <g id="soundcloud">
        <path
          id="path"
          d="M2 15.0251C2 15.2712 2.08998 15.4573 2.26989 15.5834C2.44983 15.7096 2.64216 15.7541 2.84691 15.7172C3.03924 15.6803 3.17418 15.6127 3.25176 15.5142C3.32931 15.4158 3.3681 15.2528 3.3681 15.0251V12.349C3.3681 12.1582 3.30141 11.9968 3.168 11.8645C3.03462 11.7322 2.87176 11.6661 2.6794 11.6661C2.49327 11.6661 2.33351 11.7322 2.20011 11.8645C2.06671 11.9968 2 12.1582 2 12.349V15.0251ZM4.14053 16.1694C4.14053 16.3479 4.20413 16.4817 4.33132 16.5709C4.45852 16.6601 4.62139 16.7047 4.81992 16.7047C5.02466 16.7047 5.19062 16.6601 5.31782 16.5709C5.44501 16.4817 5.50861 16.3479 5.50861 16.1694V9.93119C5.50861 9.74663 5.4419 9.5882 5.30852 9.45594C5.17511 9.32369 5.01225 9.25754 4.81992 9.25754C4.63378 9.25754 4.47401 9.32369 4.34062 9.45594C4.20722 9.58822 4.14053 9.74663 4.14053 9.93119V16.1694ZM6.27175 16.4647C6.27175 16.6431 6.3369 16.777 6.46719 16.8662C6.59749 16.9554 6.76501 17 6.96977 17C7.1683 17 7.33117 16.9554 7.45835 16.8662C7.58556 16.777 7.64916 16.6431 7.64916 16.4647V10.771C7.64916 10.5802 7.58245 10.4172 7.44907 10.2819C7.31566 10.1465 7.15591 10.0789 6.96977 10.0789C6.77742 10.0789 6.61301 10.1465 6.47652 10.2819C6.34003 10.4172 6.27177 10.5802 6.27177 10.771L6.27175 16.4647ZM8.41228 16.4924C8.41228 16.8308 8.64184 17 9.10098 17C9.56009 17 9.78965 16.8308 9.78965 16.4924V7.26426C9.78965 6.74748 9.63144 6.45526 9.31501 6.38758C9.11026 6.33836 8.90861 6.39681 8.71008 6.56292C8.51153 6.72902 8.41227 6.96279 8.41227 7.26426V16.4924H8.41228ZM10.5901 16.76V6.7198C10.5901 6.39989 10.6862 6.20918 10.8786 6.14765C11.2943 6.04922 11.7069 6 12.1164 6C13.0656 6 13.9498 6.22148 14.7687 6.66443C15.5877 7.10738 16.2501 7.71182 16.7557 8.47776C17.2614 9.24372 17.5545 10.0881 17.6352 11.0109C18.0136 10.8509 18.4169 10.771 18.845 10.771C19.7137 10.771 20.4566 11.0755 21.074 11.6846C21.6913 12.2936 22 13.0257 22 13.8809C22 14.7422 21.6913 15.4774 21.074 16.0864C20.4566 16.6955 19.7168 17 18.8543 17L10.7575 16.9908C10.7017 16.9723 10.6598 16.9385 10.6319 16.8893C10.604 16.8401 10.5901 16.7969 10.5901 16.76Z"
        />
      </g>
    </>
  ),
  pandora: () => (
    <>
      <g id="pandora">
        <path
          id="path"
          d="M11.9839 17.2621H10.2721V21.1133C10.2721 21.6117 9.85396 22 9.37048 22H4V2H13.1337C17.5699 2 21 4.27185 21 9.44984C21 14.356 17.191 17.2557 12.0035 17.2557L11.9839 17.2621Z"
        />
      </g>
    </>
  ),
  shazam: () => (
    <>
      <g id="shazam">
        <path
          id="path"
          d="M9.51729 17.6794C8.02185 17.6794 6.52642 17.1675 5.37482 16.1436C3.96125 14.889 3.12075 13.1732 3.01159 11.3167C2.90789 9.52208 3.50279 7.78372 4.68714 6.43354C6.01338 4.92021 8.39844 2.56302 8.49668 2.46176C9.1407 1.82605 10.1722 1.84855 10.789 2.51801C11.4002 3.18185 11.3839 4.24512 10.7344 4.88083C10.7126 4.90333 8.33841 7.2549 7.08311 8.67822C6.49367 9.35893 6.19349 10.2197 6.24807 11.1142C6.3081 12.0593 6.75019 12.9482 7.49245 13.6176C8.47485 14.4952 10.4178 14.6865 11.6295 13.567C12.3499 12.8975 13.2286 11.9186 13.2341 11.9018C13.8399 11.2211 14.8605 11.1817 15.5209 11.8061C16.1813 12.4306 16.2195 13.4826 15.6137 14.169C15.57 14.214 14.6203 15.2772 13.7853 16.0536C12.6119 17.1393 11.0673 17.6794 9.51729 17.6794ZM19.3086 17.5613C17.9823 19.0746 15.5973 21.4318 15.499 21.5331C15.1825 21.8425 14.7786 22 14.3802 22C13.9545 22 13.5233 21.8256 13.2068 21.4824C12.59 20.813 12.6119 19.7497 13.2613 19.114C13.2832 19.0915 15.6628 16.7399 16.9126 15.3166C17.5021 14.6359 17.8022 13.7751 17.7477 12.8807C17.6876 11.9355 17.2455 11.041 16.5033 10.3772C15.5209 9.49958 13.5779 9.3083 12.3663 10.4278C11.6404 11.0973 10.7671 12.0818 10.7617 12.093C10.1559 12.7738 9.13525 12.8131 8.47485 12.1887C7.81446 11.5642 7.7708 10.5066 8.38207 9.82587C8.42573 9.78086 9.36993 8.7176 10.2104 7.93562C12.5191 5.80346 16.2904 5.75845 18.6264 7.83998C20.0399 9.10015 20.8804 10.816 20.9896 12.6725C21.0878 14.4784 20.4875 16.2167 19.3086 17.5613Z"
        />
      </g>
    </>
  ),
  wikipedia: () => (
    <>
      <g id="wikipedia">
        <path
          id="path"
          d="M21.9939 5.51439L18 5.50206C18 5.64804 17.998 5.82281 17.9959 5.93795C18.3347 5.94617 19.2041 6.10655 19.4755 6.82618L15.651 15.7249C15.4633 15.2829 13.6837 11.3002 13.4816 10.7883L15.3306 6.92076C15.7122 6.33272 16.4429 5.95234 17.149 5.92561L17.1469 5.52056L13.3041 5.51645C13.2959 5.61925 13.3041 5.83514 13.2898 5.94206C14.3735 5.97085 14.7612 6.21552 14.502 6.86936C14.0735 7.85011 13.1735 9.71088 12.998 10.0501C12.449 8.89255 12.098 8.00021 11.5 6.74805C11.2408 6.16823 11.8122 5.94206 12.4143 5.92561V5.51851L7.96327 5.50411C7.96735 5.69533 7.95918 5.80225 7.95918 5.94206C8.57959 5.95234 9.38367 6.01814 9.70612 6.563C10.1327 7.39777 11.551 10.7122 11.9796 11.6004C11.4327 12.6593 10.102 15.1636 9.62449 16.1033C8.94286 14.5776 6.41633 8.56563 5.70408 7.01328C5.43878 6.35122 6.46531 5.97085 7.05918 5.94206L7.06327 5.5H2C2 5.63365 2.00612 5.85159 2.00612 5.95028C2.82653 5.94206 4.02653 7.30114 4.36939 8.14619C5.84694 11.6004 7.37143 15.0362 8.84286 18.4924C8.84286 18.4986 9.30204 18.5048 9.30816 18.4945C10.2694 16.5104 11.3939 14.4255 12.4102 12.4208L14.9714 18.4966C14.9714 18.4966 15.3959 18.5007 15.398 18.4986C17.0224 14.7586 19.4551 9.02003 20.251 7.20861C20.5755 6.43552 21.1163 5.96262 21.9939 5.93589L22 5.5329L21.9939 5.51439Z"
        />
      </g>
    </>
  ),
  soundxyz: () => (
    <>
      <g id="soundxyz">
        <path
          id="path"
          d="M19.08 8.26482C18.88 8.26482 18.72 8.14625 18.72 8.02767V7.23715C18.72 7.11858 18.56 7 18.36 7H5.72C5.52 7 5.32 7.11858 5.32 7.23715V7.98814C5.32 8.10672 5.16 8.2253 4.96 8.2253H2.36C2.16 8.26482 2 8.3834 2 8.50198V11.7826C2 11.9012 2.16 12.0198 2.36 12.0198H8.28C8.48 12.0198 8.64 12.1383 8.64 12.2569V13.0079C8.64 13.1265 8.8 13.2451 9 13.2451H14.92C15.12 13.2451 15.28 13.3636 15.28 13.4822V15.498C15.28 15.6166 15.12 15.7352 14.92 15.7352H12.4C12.2 15.7352 12.04 15.6166 12.04 15.498V14.747C12.04 14.6285 11.88 14.5099 11.68 14.5099H9.12C8.92 14.5099 8.76 14.3913 8.76 14.2727V13.5217C8.76 13.4032 8.6 13.2846 8.4 13.2846H2.36C2.16 13.2846 2 13.4032 2 13.5217V15.5375C2 15.6561 2.16 15.7747 2.36 15.7747H4.92C5.12 15.7747 5.28 15.8933 5.28 16.0119V16.7628C5.28 16.8814 5.44 17 5.64 17H18.2C18.4 17 18.56 16.8814 18.56 16.7628V16.0119C18.56 15.8933 18.72 15.7747 18.92 15.7747H21.6C21.8 15.7747 22 15.6561 22 15.5375V12.2569C22 12.1383 21.8 12.0198 21.6 12.0198H15.72C15.52 12.0198 15.36 11.9012 15.36 11.7826V11.0316C15.36 10.913 15.2 10.7945 15 10.7945H9.04C8.84 10.7945 8.68 10.6759 8.68 10.5573V8.50198C8.68 8.3834 8.84 8.26482 9.04 8.26482H11.6C11.8 8.26482 11.96 8.3834 11.96 8.50198V9.25296C11.96 9.37154 12.12 9.49012 12.32 9.49012H14.88C15.08 9.49012 15.24 9.6087 15.24 9.72727V10.4783C15.24 10.5968 15.4 10.7154 15.6 10.7154H21.52C21.72 10.7154 21.88 10.5968 21.88 10.4783V8.50198C21.88 8.3834 21.72 8.26482 21.52 8.26482H19.08Z"
        />
      </g>
    </>
  ),
  opensea: () => (
    <>
      <g id="opensea">
        <g id="path">
          <path d="M21.9026 15.4875C21.9642 15.4615 21.9997 15.4049 21.9997 15.3386L22 15.3392V14.318C22 14.2141 21.8981 14.1362 21.7961 14.1645C21.7961 14.1645 16.926 15.2803 16.8692 15.2968C16.8121 15.3132 16.7908 15.3463 16.7908 15.3463C16.2976 16.0059 15.2599 17.1001 14.6815 17.1001H11.9987V15.3437H14.1364C14.4419 15.3437 14.7335 15.2208 14.9444 15.0033C16.0415 13.8689 16.6766 12.5191 16.6766 11.07C16.6766 8.59996 14.8257 6.41564 11.9984 5.09906V3.91955C11.9984 3.41119 11.5861 3 11.0765 3C10.5668 3 10.1546 3.41119 10.1546 3.91955V4.40892C9.36299 4.17726 8.52398 4.00223 7.64724 3.90056C9.09751 5.47229 9.98394 7.57392 9.98394 9.87858C9.98394 11.9445 9.27525 13.8425 8.08561 15.346H10.1546V17.1046H7.12596C6.71566 17.1046 6.38405 16.7736 6.38405 16.3646V15.5963C6.38405 15.4615 6.27502 15.3505 6.13761 15.3505H2.14451C2.06645 15.3505 2 15.4145 2 15.4924C1.99774 18.6384 4.49315 21 7.47692 21H15.9018C17.4361 21 18.3259 19.5097 19.1835 18.0731C19.4546 17.6191 19.7225 17.1704 20.0065 16.7758C20.4665 16.14 21.5684 15.6294 21.9026 15.4875Z" />
          <path d="M6.9702 5.67825L2.38683 13.5873H7.31603C8.0173 12.5214 8.42503 11.2447 8.42503 9.87375C8.42503 8.28997 7.88 6.83165 6.9702 5.67825Z" />
        </g>
      </g>
    </>
  ),
  limewire: () => (
    <>
      <g id="limewire">
        <g id="path">
          <path d="M4.24224 8.24957L4.29972 8.27257L4.83999 8.51408L5.43773 8.77859C6.10445 7.36404 7.24247 6.17949 8.74833 5.46646L8.48394 4.86844L8.1046 3.9944C7.67928 3.14337 6.90911 3.43088 6.63323 3.56888C5.41474 4.32791 4.40317 5.32846 3.64449 6.49C3.633 6.5015 3.633 6.513 3.633 6.536C3.1502 7.66305 4.00084 8.13457 4.24224 8.24957Z" />
          <path d="M5.44923 8.76709L6.41482 9.19261L7.25396 9.56062L7.92068 9.85964C8.32301 9.0431 8.98973 8.35308 9.85186 7.92756L9.55299 7.26053L9.18514 6.421L8.75982 5.45496C7.25396 6.16799 6.11595 7.36404 5.44923 8.76709Z" />
          <path d="M7.90919 9.85964L10.5875 11.0327C10.76 11.0212 10.9094 10.9062 10.9784 10.7452C11.0014 10.6877 11.0129 10.6417 11.0129 10.5842L10.4496 9.30761L9.84037 7.91606C8.97823 8.35308 8.31151 9.0431 7.90919 9.85964Z" />
          <path d="M21.7723 9.94014C21.324 8.8246 20.4044 9.07761 20.1515 9.18111L20.0825 9.20411L19.5193 9.42262L18.91 9.66413C19.4733 11.2282 19.4388 12.8843 18.91 14.3563L19.5193 14.5978L20.3009 14.8968C21.209 15.2764 21.5884 14.6323 21.7263 14.2873C22.0712 12.8843 22.0942 11.4007 21.7723 9.94014Z" />
          <path d="M18.9215 9.66413L17.9444 10.0436L17.0823 10.3772L16.4041 10.6417C16.7144 11.5617 16.703 12.5162 16.4041 13.3788L17.0708 13.6433L17.9329 13.9768L18.91 14.3563C19.4503 12.8843 19.4848 11.2397 18.9215 9.66413Z" />
          <path d="M16.4156 10.6417L15.0017 11.1937L13.6912 11.7112C13.5763 11.8377 13.5418 12.0217 13.6108 12.1942C13.6338 12.2402 13.6567 12.2862 13.6912 12.3207L15.0017 12.8268L16.4156 13.3788C16.703 12.5162 16.7259 11.5617 16.4156 10.6417Z" />
          <path d="M4.47214 14.5978L5.08139 14.3563C4.51812 12.7923 4.55261 11.1362 5.08139 9.66413L4.47214 9.42262L3.67898 9.11211C2.75937 8.74409 2.39153 9.42262 2.26508 9.75613C1.93172 11.1362 1.90873 12.5967 2.2191 14.0343V14.0458C2.66741 15.1959 3.59851 14.9313 3.85141 14.8393L4.47214 14.5978Z" />
          <path d="M5.08139 14.3563L6.05847 13.9768L6.90911 13.6433L7.58732 13.3788C7.27695 12.4587 7.28845 11.5042 7.58732 10.6417L6.90911 10.3772L6.05847 10.0551L5.08139 9.67563C4.55261 11.1477 4.51812 12.7923 5.08139 14.3563Z" />
          <path d="M7.59882 13.3788L10.3117 12.3207C10.4266 12.1942 10.4611 12.0102 10.3921 11.8377C10.3691 11.7802 10.3347 11.7342 10.3002 11.6997L7.58732 10.6417C7.29994 11.5157 7.28845 12.4702 7.59882 13.3788Z" />
          <path d="M5.46072 15.2534L4.86298 15.5179L4.24224 15.7939C4.24224 15.7939 3.1502 16.3804 3.65599 17.5074V17.5189C4.44915 18.7495 5.49521 19.75 6.6907 20.4861C7.00107 20.6356 7.78274 20.8886 8.17357 19.934L8.50693 19.175L8.77132 18.577C7.36891 17.8985 6.17342 16.7599 5.46072 15.2534Z" />
          <path d="M9.86336 16.1044C9.0472 15.7019 8.3575 15.0348 7.93218 14.1723L7.26546 14.4598L6.42631 14.8278L5.46072 15.2534C6.17342 16.7599 7.36891 17.8985 8.78281 18.5655L9.20813 17.5994L9.86336 16.1044Z" />
          <path d="M9.86336 16.0929L10.4726 14.7013L11.0359 13.4248C11.0244 13.2523 10.9209 13.0913 10.7485 13.0223C10.7025 12.9993 10.645 12.9878 10.5875 12.9878L9.31159 13.5513L7.92068 14.1608C8.3575 15.0348 9.0472 15.6904 9.86336 16.0929Z" />
          <path d="M18.5537 8.77859L19.1514 8.51408L19.8181 8.21507L19.7607 8.22657C20.0021 8.11157 20.8412 7.65155 20.3699 6.5475C19.5652 5.28245 18.4847 4.25891 17.2432 3.51138C16.3696 3.06286 15.8293 4.08641 15.8293 4.08641L15.496 4.85694L15.2316 5.45496C16.6455 6.12199 17.841 7.26053 18.5537 8.77859Z" />
          <path d="M14.4384 7.24903L14.151 7.91606C14.9672 8.31857 15.6569 8.9856 16.0937 9.85964L16.7604 9.57212L17.5996 9.20411L18.5537 8.77859C17.841 7.27203 16.6455 6.12199 15.2316 5.45496L14.8063 6.421L14.4384 7.24903Z" />
          <path d="M14.151 7.91606L13.5418 9.30761L12.9785 10.6072C12.99 10.7797 13.0935 10.9292 13.2659 10.9982C13.3119 11.0212 13.3694 11.0327 13.4268 11.0327L16.1052 9.85964C15.6569 8.9856 14.9672 8.33008 14.151 7.91606Z" />
          <path d="M14.5879 19.5315L14.3465 18.922C12.7716 19.4855 11.1278 19.451 9.65644 18.922L9.41505 19.5315L9.02421 20.5436C9.02421 20.5436 8.8288 21.3371 9.97831 21.7741C10.0013 21.7856 10.0243 21.7971 10.0473 21.7971C11.3692 22.0731 12.7601 22.0731 14.128 21.7626C14.3235 21.7051 15.2776 21.4061 14.9327 20.4056L14.5879 19.5315Z" />
          <path d="M14.3579 18.922L13.9786 17.9445L13.6453 17.0819L13.3809 16.4149C12.4613 16.7254 11.5072 16.7139 10.645 16.4149L10.3806 17.0819L10.0473 17.9445L9.66794 18.922C11.1393 19.451 12.7831 19.4855 14.3579 18.922Z" />
          <path d="M13.3694 16.4149L12.3118 13.7008C12.1854 13.5858 11.99 13.5513 11.8175 13.6203C11.7715 13.6433 11.7256 13.6663 11.6911 13.7008L10.6335 16.4149C11.5072 16.7024 12.4498 16.7254 13.3694 16.4149Z" />
          <path d="M9.40355 4.47742L9.64495 5.08695C11.2198 4.52342 12.8636 4.55792 14.335 5.07544L14.5764 4.46592L14.8178 3.8449C14.9097 3.59189 15.1741 2.64885 14.0246 2.21183C14.0131 2.21183 14.0131 2.20033 14.0016 2.20033C12.6337 1.92432 11.1968 1.92432 9.78289 2.25783C9.46103 2.36134 8.70235 2.72935 9.10468 3.70689L9.40355 4.47742Z" />
          <path d="M9.64495 5.08695L10.0243 6.06448L10.3576 6.91552L10.622 7.59405C11.5416 7.28353 12.4957 7.29503 13.3579 7.59405L13.6223 6.91552L13.9556 6.06448L14.335 5.08695C12.8636 4.55792 11.2198 4.52342 9.64495 5.08695Z" />
          <path d="M10.622 7.59405L11.6911 10.3312C11.8175 10.4347 12.0014 10.4692 12.1624 10.4002C12.2199 10.3772 12.2658 10.3427 12.3003 10.3082L12.8061 8.9971L13.3579 7.58255C12.4957 7.30653 11.5416 7.28353 10.622 7.59405Z" />
          <path d="M19.7607 15.7709L19.6917 15.7479L19.1514 15.5064L18.5537 15.2419C17.887 16.6564 16.7489 17.841 15.2316 18.5655L15.496 19.1635L15.8293 19.9225C16.2661 20.9806 17.1628 20.5666 17.3927 20.4286C18.5727 19.6883 19.577 18.6993 20.3354 17.5304C20.3469 17.5189 20.3469 17.5074 20.3584 17.4844C20.8527 16.3574 20.0021 15.8859 19.7607 15.7709Z" />
          <path d="M18.5537 15.2419L17.5881 14.8163L16.7374 14.4483L16.0822 14.1608C15.6799 14.9773 15.0132 15.6559 14.151 16.0814L14.4384 16.7369L14.8063 17.5879L15.2316 18.554C16.7374 17.8525 17.887 16.6564 18.5537 15.2419Z" />
          <path d="M16.0822 14.1723L14.6913 13.5628L13.4268 13.0108C13.3809 13.0108 13.3234 13.0223 13.2774 13.0453C13.1625 13.0913 13.0705 13.1833 13.0245 13.2983C13.0015 13.3443 12.99 13.3903 12.99 13.4478L13.5418 14.7128L14.151 16.1044C15.0132 15.6674 15.6799 14.9888 16.0822 14.1723Z" />
        </g>
      </g>
    </>
  ),
  leather: () => (
    <>
      <g id="leather">
        <path
          id="path"
          d="M13.577 9.18261C15.0812 8.56526 16.945 6.37165 16.6364 5.08393C16.5432 4.69519 16.1667 4.50282 15.71 4.61226C14.8446 4.81962 13.6927 6.48297 13.577 9.18261ZM7.87267 17.3064C5.82942 17.796 6.1502 19.8772 8.19344 19.3876C9.10687 19.1687 10.1253 18.5393 10.545 17.7451C9.52903 17.2178 8.76206 17.0932 7.87267 17.3064ZM20.6677 13.3156C21.6088 16.7126 20.338 19.0468 17.4053 19.7495C15.6746 20.1642 14.652 19.7155 12.51 18.9442C11.8046 20.2437 10.1698 21.4832 8.65543 21.846C3.43915 23.096 2.0545 16.3625 7.36693 15.0896C8.47267 14.8247 9.48001 14.8916 10.8624 15.3568L10.9861 12.3726C7.50156 12.257 5.26149 10.1218 6.00462 6.11567L8.60071 5.4936C7.73479 8.24455 9.19773 10.0007 11.077 9.78166C11.2184 6.02248 12.6759 2.7701 15.4884 2.09619C17.0749 1.71604 18.5752 2.46128 19.0293 4.35641C19.757 7.39348 16.4086 10.8164 13.4861 11.7736L13.3023 16.4164C15.0866 17.7102 19.3351 18.3622 18.2639 13.8916L20.6677 13.3156Z"
        />
      </g>
    </>
  ),
  xverse: () => (
    <>
      <g id="xverse">
        <g id="path">
          <path d="M5.95886 20.9076C6.82579 20.9076 7.69202 20.9091 8.55896 20.9076C8.93231 20.9069 9.03497 20.8043 9.03708 20.4281C9.04059 19.8776 9.04481 19.3271 9.03497 18.7765C9.03145 18.5867 9.09262 18.4524 9.22762 18.3195C10.0285 17.5306 10.8209 16.7333 11.6161 15.9388C11.9283 15.6266 12.0773 15.6266 12.3923 15.9409C13.9912 17.5383 15.5901 19.1358 17.1903 20.7326C17.2853 20.8275 17.3598 20.9301 17.5335 20.9273C18.4932 20.9119 19.4537 20.9161 20.4141 20.9112C20.8177 20.9091 20.9098 20.8191 20.9105 20.4162C20.9126 19.4677 20.9063 18.5185 20.9147 17.57C20.9168 17.3197 20.8416 17.1291 20.6574 16.9548C19.4677 15.8305 18.387 14.5986 17.1896 13.4814C16.476 12.8155 15.8045 12.1054 15.1141 11.4149C13.3148 9.61498 11.5162 7.81502 9.71769 6.01506C8.82403 5.1207 7.92897 4.22845 7.03813 3.33058C6.81314 3.10488 6.56072 2.9959 6.23658 3.00012C5.31129 3.01207 4.386 3.00363 3.4607 3.00434C3.03954 3.00504 3.00649 3.03738 3.00579 3.4712C3.00438 4.37329 3.01423 5.27538 3.00017 6.17677C2.99595 6.44114 3.07188 6.62817 3.26172 6.8166C4.76849 8.3079 6.26541 9.80834 7.76234 11.3095C8.28967 11.8382 8.38881 11.7806 7.76163 12.4021C7.12461 13.0328 6.50025 13.6754 5.84495 14.2886C4.97239 15.1056 4.14202 15.969 3.3025 16.8205C3.15907 16.9667 2.99876 17.1073 3.00228 17.3612C3.01423 18.4271 3.00931 19.493 3.00649 20.5589C3.00649 20.8261 3.12602 20.9175 3.39461 20.9133C4.24959 20.8992 5.10387 20.9084 5.95886 20.9076Z" />
          <path d="M20.9951 4.94371C20.9951 4.46348 20.9979 3.98326 20.9944 3.50303C20.9909 3.09382 20.915 3.01789 20.4987 3.01648C19.5151 3.01226 18.5314 3.0214 17.5478 3.00383C17.2454 2.9982 17.0486 3.13882 16.8672 3.34202C16.7744 3.44608 16.69 3.55717 16.5915 3.65561C15.5748 4.67512 14.556 5.69252 13.5379 6.71133C13.4247 6.82453 13.2743 6.92296 13.3692 7.12405C13.4557 7.30897 13.6195 7.31038 13.7875 7.31038C14.5722 7.31038 15.3569 7.30827 16.1408 7.31038C16.5859 7.31178 16.6492 7.37647 16.6506 7.81732C16.6527 8.61395 16.6506 9.40987 16.652 10.2065C16.652 10.3717 16.6429 10.551 16.8172 10.6396C17.012 10.738 17.1125 10.5721 17.2257 10.4603C18.3873 9.3037 19.5453 8.14427 20.7118 6.99257C20.9079 6.79851 21.0092 6.59461 20.9993 6.31337C20.9832 5.85705 20.9951 5.40003 20.9951 4.94371Z" />
        </g>
      </g>
    </>
  ),
  heart: () => (
    <>
      <g id="heart">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.00049 11.5328C4.64184 11.1334 4.36915 10.6644 4.19971 10.155C4.03027 9.64564 3.9677 9.10681 4.01563 8.57213C4.06357 8.03746 4.22093 7.51841 4.47828 7.04729C4.73562 6.57617 5.08725 6.16311 5.51124 5.83385C5.93522 5.50459 6.42247 5.26616 6.94263 5.13347C7.4628 5.00078 8.00478 4.97667 8.53467 5.06261C9.06457 5.14855 9.57115 5.3427 10.0227 5.63298C10.292 5.8061 10.5383 6.0112 10.7566 6.24324C10.9042 6.4003 11.0391 6.56969 11.1594 6.74987L11.9915 7.99486L12.8235 6.74987C12.9433 6.56904 13.0777 6.39897 13.225 6.24122C13.4432 6.0076 13.6897 5.80102 13.9595 5.62657C14.4114 5.33434 14.9188 5.13857 15.45 5.0515C15.9811 4.96443 16.5243 4.98796 17.0459 5.12059C17.5675 5.25322 18.0562 5.49207 18.4812 5.82225C18.9062 6.15244 19.2586 6.56685 19.5161 7.03948C19.7736 7.5121 19.9306 8.0328 19.9775 8.56896C20.0245 9.10511 19.9602 9.64514 19.7888 10.1553C19.6174 10.6655 19.3426 11.1348 18.9815 11.5339L11.9915 19.2928L5.00049 11.5328ZM20.4664 12.8737C21.0114 12.2708 21.426 11.5622 21.6847 10.7923C21.9438 10.0212 22.0409 9.20491 21.9699 8.3945C21.899 7.58441 21.6617 6.79734 21.2724 6.08269C20.8831 5.36813 20.3505 4.74181 19.7082 4.24286C19.0656 3.74367 18.327 3.3827 17.5388 3.18227C16.7504 2.98182 15.9292 2.94623 15.1264 3.07785C14.3236 3.20945 13.5567 3.50535 12.8735 3.94709C12.5562 4.15225 12.2602 4.38681 11.9892 4.64709C11.7177 4.38796 11.4215 4.1546 11.1042 3.95061C10.4215 3.51177 9.65579 3.2183 8.85485 3.0884C8.05388 2.9585 7.23463 2.99494 6.44829 3.19553C5.66192 3.39612 4.92538 3.75656 4.28453 4.25423C3.64362 4.75195 3.11209 5.37635 2.72307 6.08852C2.33385 6.80105 2.09604 7.58573 2.02362 8.39354C1.95119 9.20145 2.04572 10.016 2.30195 10.7863C2.55819 11.5566 2.97045 12.2655 3.51237 12.869L11.9915 22.2809L20.4643 12.876L20.4664 12.8737Z"
        />
      </g>
    </>
  ),
  'heart-active': () => (
    <>
      <g id="heart-active">
        <path
          id="path"
          d="M3.38202 12.021L11.9946 21.5811L20.6035 12.0251L20.6043 12.0242C21.1029 11.4731 21.4821 10.8252 21.7187 10.121C21.9555 9.41628 22.0443 8.67033 21.9794 7.92975C21.9146 7.18932 21.6977 6.47007 21.342 5.8171C20.9863 5.16418 20.4995 4.59179 19.9125 4.13577C19.3254 3.67964 18.6504 3.34975 17.93 3.16657C17.2095 2.98338 16.4592 2.95086 15.7255 3.07114C14.9919 3.19141 14.291 3.46181 13.6667 3.86549C13.0429 4.26886 12.5091 4.79659 12.0986 5.4155L12.0976 5.41706L11.9946 5.57108L11.8896 5.41389C11.4777 4.79736 10.9432 4.27221 10.3195 3.87125C9.69569 3.47025 8.99594 3.20207 8.264 3.08337C7.53205 2.96466 6.7834 2.99796 6.06485 3.18125C5.34629 3.36455 4.67323 3.69391 4.08759 4.14872C3.50192 4.60354 3.0162 5.17412 2.66071 5.8249C2.30513 6.47587 2.08779 7.19289 2.02159 7.93125C1.95539 8.66966 2.0418 9.41398 2.2759 10.1178C2.51001 10.8216 2.88671 11.4694 3.38202 12.021Z"
        />
      </g>
    </>
  ),
  star: () => (
    <>
      <g id="star">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.844 9.44202L12 1.5L9.15405 9.44202H1L7.31006 14.924L5.12988 22.4719L12 18.2959L18.8699 22.4719L16.689 14.924L23 9.44202H14.844ZM17.6477 11.442H13.4358L11.9994 7.43061L10.5619 11.442H6.35169L9.58596 14.2518L8.47499 18.0981L12 15.9554L15.5242 18.0976L14.4129 14.2518L17.6477 11.442Z"
        />
      </g>
    </>
  ),
  'star-active': () => (
    <>
      <g id="star-active">
        <path
          id="path"
          d="M23 9.44202H14.844L12 1.5L9.15405 9.44202H1L7.31006 14.924L5.12988 22.4719L12 18.2959L18.8699 22.4719L16.689 14.924L23 9.44202Z"
        />
      </g>
    </>
  ),
  'thumb-up': () => (
    <>
      <g id="thumb-up">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.3981 4C16.4 1.88473 14.6922 0 12.3942 0H12.0229L5.70716 8H2V19H16.6645C18.5916 19 20.2447 17.626 20.5971 15.7315L21.7471 9.54859C22.0903 7.70359 20.6743 6 18.7977 6H15.902L16.1074 5.48742C16.3054 4.99296 16.3977 4.49029 16.3981 4ZM4 17H16.6645C17.628 17 18.4546 16.313 18.6308 15.3657L19.7808 9.18287C19.8952 8.56786 19.4232 8 18.7977 8H12.9464L14.2508 4.74371C14.7068 3.60527 14.0413 2.37976 12.9347 2.07279L6.67636 10H4V17Z"
        />
      </g>
    </>
  ),
  'thumb-up-active': () => (
    <>
      <g id="thumb-up-active">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.91769 9L12.0229 0C13.699 0 14.8447 1.69318 14.2215 3.24902L13.1195 6H19.3992C20.9631 6 22.1431 7.41966 21.8571 8.95716L20.4451 16.5486C20.1808 17.9695 18.941 19 17.4957 19H2V9H4.91769Z"
        />
      </g>
    </>
  ),
  'thumb-down': () => (
    <>
      <g id="thumb-down">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.6016 20C7.59973 22.1153 9.3075 24 11.6056 24H11.9768L18.2926 16H21.9997L21.9997 5L7.33522 5C5.40818 5 3.75506 6.37399 3.40267 8.26855L2.25266 14.4514C1.90949 16.2964 3.32542 18 5.20207 18L8.09772 18L7.89238 18.5126C7.69432 19.007 7.60203 19.5097 7.6016 20ZM19.9997 7L7.33522 7C6.3717 7 5.54514 7.687 5.36895 8.63427L4.21893 14.8171C4.10454 15.4321 4.57652 16 5.20207 16L11.0534 16L9.74897 19.2563C9.29293 20.3947 9.95846 21.6202 11.0651 21.9272L17.3234 14H19.9997V7Z"
        />
      </g>
    </>
  ),
  'thumb-down-active': () => (
    <>
      <g id="thumb-down-active">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.0819 15L11.9767 24C10.3006 24 9.15491 22.3068 9.77814 20.751L10.8801 18L4.60036 18C3.03649 18 1.85654 16.5803 2.14251 15.0428L3.55452 7.45141C3.81881 6.0305 5.05865 5 6.50394 5L21.9996 5V15H19.0819Z"
        />
      </g>
    </>
  ),
  bookmark: () => (
    <>
      <g id="bookmark">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 13.0716L18 16.5358V5H6V16.5358L12 13.0716ZM4 20V3H20V20L12 15.381L4 20Z"
        />
      </g>
    </>
  ),
  'bookmark-active': () => (
    <>
      <g id="bookmark-active">
        <path id="path" d="M4 3V20L12 15.381L20 20V3H4Z" />
      </g>
    </>
  ),
  download: () => (
    <>
      <g id="download">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.74468 10.6572L7.15889 9.24296L11 13.0841V2L13 2V13.0841L16.8411 9.24296L18.2553 10.6572L12 16.9125L5.74468 10.6572Z"
          />
          <path d="M3 19H21V21H3V19Z" />
        </g>
      </g>
    </>
  ),
  'download-small': () => (
    <>
      <g id="download-small">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.58579 10.4142L9 9L11.0004 11.0841V5L13.0004 5V11.0841L15 9L16.4142 10.4142L12.0004 14.9125L7.58579 10.4142Z"
          />
          <path d="M6 17H18V19H6V17Z" />
        </g>
      </g>
    </>
  ),
  'download-active': () => (
    <>
      <g id="download-active">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9883 21C16.9588 21 20.9883 16.9706 20.9883 12C20.9883 7.02944 16.9588 3 11.9883 3C7.01772 3 2.98828 7.02944 2.98828 12C2.98828 16.9706 7.01772 21 11.9883 21ZM8.20657 12.1477L6.79236 13.5619L11.9995 18.769L17.2066 13.5619L15.7924 12.1477L12.9995 14.9406V5.99985H10.9995V14.9406L8.20657 12.1477Z"
        />
      </g>
    </>
  ),
  'download-stop': () => (
    <>
      <g id="download-stop">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          />
          <path d="M9 9H15V15H9V9Z" />
        </g>
      </g>
    </>
  ),
  upload: () => (
    <>
      <g id="upload">
        <g id="path">
          <path d="M3 19H21V21H3V19Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.2558 8.25533L16.8416 9.66955L13.0005 5.82843V16.9125H11.0005V5.82843L7.15933 9.66955L5.74512 8.25533L12.0005 2L18.2558 8.25533Z"
          />
        </g>
      </g>
    </>
  ),
  follow: () => (
    <>
      <g id="follow">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.0002 10.7129C12.4855 10.7129 14.5002 8.69817 14.5002 6.21289C14.5002 3.72761 12.4855 1.71289 10.0002 1.71289C7.51496 1.71289 5.50024 3.72761 5.50024 6.21289C5.50024 8.69817 7.51496 10.7129 10.0002 10.7129ZM10.0002 8.71289C11.381 8.71289 12.5002 7.5936 12.5002 6.21289C12.5002 4.83218 11.381 3.71289 10.0002 3.71289C8.61953 3.71289 7.50024 4.83218 7.50024 6.21289C7.50024 7.5936 8.61953 8.71289 10.0002 8.71289Z"
          />
          <path d="M16.9654 21C16.6128 17.4642 13.629 14.7031 10.0003 14.7031C6.37161 14.7031 3.38781 17.4642 3.03516 21H1.02734C1.38605 16.3581 5.26634 12.7031 10.0003 12.7031C14.7342 12.7031 18.6145 16.3581 18.9732 21H16.9654Z" />
          <path d="M19.0002 8V10H17.0002V12H19.0002V14H21.0002V12H23.0002V10H21.0002V8H19.0002Z" />
        </g>
      </g>
    </>
  ),
  'follow-active': () => (
    <>
      <g id="follow-active">
        <g id="path">
          <path d="M10.0002 10.4629C12.3475 10.4629 14.2502 8.5601 14.2502 6.21289C14.2502 3.86568 12.3475 1.96289 10.0002 1.96289C7.65303 1.96289 5.75024 3.86568 5.75024 6.21289C5.75024 8.5601 7.65303 10.4629 10.0002 10.4629Z" />
          <path d="M18.3002 13.4143L24.0074 7.70718L22.5931 6.29297L18.3002 10.5859L16.5074 8.79297L15.0931 10.2072L18.3002 13.4143Z" />
          <path d="M10.0003 12.7031C5.26634 12.7031 1.38605 16.3581 1.02734 21H18.9732C18.6145 16.3581 14.7342 12.7031 10.0003 12.7031Z" />
        </g>
      </g>
    </>
  ),
  'queue-add': () => (
    <>
      <g id="queue-add">
        <g id="path">
          <path d="M4 4H20V6H4V4Z" />
          <path d="M4 18H20V20H4V18Z" />
          <path d="M11 11H20V13H11V11Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 11V9H6V11H8V13H6V15H4V13H2V11H4Z"
          />
        </g>
      </g>
    </>
  ),
  'queue-addnext': () => (
    <>
      <g id="queue-addnext">
        <path
          id="path"
          d="M10 20H20V18H10V20ZM10 11V13H20V11H10ZM14.2935 7.54199L15.707 8.95605L19.6641 4.99902L15.707 1.04199L14.2935 2.45605L15.8364 3.99902H4V19.999H6V5.99902H15.8364L14.2935 7.54199Z"
        />
      </g>
    </>
  ),
  'mymusic-add': () => (
    <>
      <g id="mymusic-add">
        <g id="path">
          <path d="M9 9V11H7V13H9V15H11V13H13V11H11V9H9Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 20C14.4183 20 18 16.4183 18 12C18 7.58172 14.4183 4 10 4C5.58172 4 2 7.58172 2 12C2 16.4183 5.58172 20 10 20ZM10 18C13.3137 18 16 15.3137 16 12C16 8.68629 13.3137 6 10 6C6.68629 6 4 8.68629 4 12C4 15.3137 6.68629 18 10 18Z"
          />
          <path d="M20 4H22V20H20V4Z" />
        </g>
      </g>
    </>
  ),
  'playlist-add': () => (
    <>
      <g id="playlist-add">
        <g id="path">
          <path d="M5 4H21V20H9.77668C9.90042 19.499 9.96606 18.9752 9.96606 18.436C9.96606 18.2895 9.96122 18.1441 9.95167 18H19V6H7V17.499H6.99692C6.94319 18.4602 6.20438 19.4849 5.03776 20.0676C3.48271 20.8442 1.75639 20.5414 1.18192 19.3912C0.607451 18.241 1.40237 16.6789 2.95742 15.9022C3.64277 15.56 4.36138 15.4273 5 15.4845V4Z" />
          <path d="M12.0112 9V11H10.0112V13H12.0112V15H14.0112V13H16.0112V11H14.0112V9H12.0112Z" />
        </g>
      </g>
    </>
  ),
  'track-add': () => (
    <>
      <g id="track-add">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11 2.99951V15.0604C10.1788 14.9071 9.20743 15.0424 8.28747 15.5019C6.47474 16.4072 5.5481 18.2281 6.21776 19.5689C6.88742 20.9098 8.8998 21.2628 10.7125 20.3574C12.1096 19.6597 12.9807 18.418 13 17.2715V6.46359L18 9.35034V7.04094L11 2.99951Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 5.99998V3.99998H6V5.99998H8V7.99998H6V9.99998H4V7.99998H2V5.99998H4Z"
          />
        </g>
      </g>
    </>
  ),
  'playlist-radio': () => (
    <>
      <g id="playlist-radio">
        <path
          id="path"
          d="M10.9677 18.132V15.8226L17.5885 12L8.00064 6.46439V17.2573C8.06953 18.284 7.30756 19.4354 6.04264 20.0672C4.48759 20.8438 2.76127 20.541 2.1868 19.3908C1.61233 18.2405 2.40725 16.6785 3.9623 15.9018C4.64613 15.5603 5.36308 15.4275 6.00064 15.4838L6.00015 3L21.5885 12L10.9677 18.132Z"
        />
      </g>
    </>
  ),
  'calendar-add': () => (
    <>
      <g id="calendar-add">
        <path
          id="path"
          d="M16.499 9.99707C16.499 9.7004 16.4109 9.41049 16.2461 9.16382C16.0813 8.91714 15.8473 8.72486 15.5732 8.61133C15.2992 8.4978 14.9975 8.468 14.7065 8.52588C14.4156 8.58376 14.1483 8.72674 13.9385 8.93652C13.7287 9.1463 13.5857 9.41337 13.5278 9.70435C13.47 9.99532 13.4997 10.297 13.6133 10.571C13.7268 10.8451 13.9189 11.0796 14.1655 11.2444C14.4122 11.4092 14.7024 11.4971 14.999 11.4971C15.3968 11.4971 15.7783 11.3389 16.0596 11.0576C16.3409 10.7763 16.499 10.3949 16.499 9.99707ZM18.999 3.99707V1.99707H16.999V3.99707H6.99902V1.99707H4.99902V3.99707H2.99902V13.5811C3.66088 13.4678 4.33717 13.4678 4.99902 13.5811V5.99707H18.999V18.9971H10.415C10.5269 19.659 10.5269 20.3351 10.415 20.9971H20.999V3.99707H18.999ZM4.99902 16.9971H2.99902V18.9971H0.999023V20.9971H2.99902V22.9971H4.99902V20.9971H6.99902V18.9971H4.99902V16.9971Z"
        />
      </g>
    </>
  ),
  move: () => (
    <>
      <g id="move">
        <g id="path">
          <path d="M20 8H4V10H20V8Z" />
          <path d="M20 14H4V16H20V14Z" />
        </g>
      </g>
    </>
  ),
  copy: () => (
    <>
      <g id="copy">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 6H16L16 22H4V6ZM14 8L14 20H6L6 8L14 8Z"
          />
          <path d="M8 2V4C9 4 9 4 10 4H18V16C18 17 18 17 18 18H20V2H8Z" />
        </g>
      </g>
    </>
  ),
  dice: () => (
    <>
      <g id="dice">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.47109 4H19.0309C19.7017 4 20.25 4.54832 20.25 5.22109V18.7809C20.25 19.4517 19.7017 20 19.0309 20H5.47109C4.79832 20 4.25 19.4517 4.25 18.7809V5.22109C4.25 4.54832 4.79832 4 5.47109 4V4ZM18.2378 15.0344C17.4523 14.2469 16.1767 14.2469 15.3912 15.0344C14.6057 15.8199 14.6057 17.0934 15.3912 17.8789C16.1767 18.6644 17.4523 18.6644 18.2378 17.8789C19.0232 17.0934 19.0232 15.8199 18.2378 15.0344V15.0344ZM13.6743 10.5778C12.8868 9.79227 11.6132 9.79227 10.8277 10.5778C10.0422 11.3633 10.0422 12.6368 10.8277 13.4243C11.6132 14.2098 12.8868 14.2098 13.6743 13.4243C14.4598 12.6368 14.4598 11.3633 13.6743 10.5778V10.5778ZM9.10883 6.12116C8.32334 5.33567 7.04979 5.33567 6.26427 6.12116C5.47678 6.90665 5.47678 8.18223 6.26427 8.96772C7.04976 9.75321 8.32331 9.75321 9.10883 8.96772C9.89633 8.18223 9.89633 6.90665 9.10883 6.12116V6.12116Z"
        />
      </g>
    </>
  ),
  magic: () => (
    <>
      <g id="magic">
        <g id="path">
          <path d="M21.7893 10.2919C19.2392 9.76501 17.2582 7.76291 16.7313 5.21285C16.7102 5.08641 16.6048 5.00211 16.4573 5.00211C16.3309 5.00211 16.2255 5.08641 16.1834 5.21285C15.6565 7.76291 13.6544 9.76501 11.1254 10.2919C10.999 10.313 10.9147 10.4183 10.9147 10.5659C10.9147 10.6923 10.999 10.7977 11.1254 10.8398C13.6755 11.3667 15.6565 13.3688 16.1834 15.8978C16.2044 16.0242 16.3098 16.1085 16.4573 16.1085C16.5838 16.1085 16.6891 16.0242 16.7313 15.8978C17.2582 13.3477 19.2603 11.3667 21.7893 10.8398C21.9157 10.8188 22 10.7134 22 10.5659C22 10.4183 21.9157 10.313 21.7893 10.2919Z" />
          <path d="M13.2961 16.235C11.2518 15.8135 9.65014 14.2118 9.22865 12.1465C9.20757 12.0411 9.12327 11.9779 9.0179 11.9779C8.91253 11.9779 8.82823 12.0411 8.80715 12.1465C8.38566 14.2118 6.78397 15.8135 4.73971 16.235C4.63434 16.256 4.57112 16.3403 4.57112 16.4457C4.57112 16.5511 4.63434 16.6354 4.73971 16.6565C6.78397 17.078 8.38566 18.6797 8.80715 20.7239C8.82823 20.8293 8.91253 20.8925 9.0179 20.8925C9.12327 20.8925 9.20757 20.8293 9.22865 20.7239C9.65014 18.6797 11.2518 17.078 13.2961 16.6565C13.4015 16.6354 13.4647 16.5511 13.4647 16.4457C13.4647 16.3403 13.4015 16.256 13.2961 16.235Z" />
          <path d="M6.02529 11.4088C6.06744 11.5353 6.17281 11.6196 6.29926 11.6196C6.42571 11.6196 6.55216 11.5353 6.57323 11.4088C7.0158 9.53319 8.53319 8.03688 10.3878 7.59431C10.5142 7.55216 10.5985 7.44678 10.5985 7.32034C10.5985 7.19389 10.5142 7.06744 10.3878 7.04636C8.49104 6.58272 7.0158 5.10748 6.57323 3.21075C6.55216 3.0843 6.42571 3 6.29926 3C6.17281 3 6.04636 3.0843 6.02529 3.21075C5.56164 5.10748 4.10748 6.58272 2.21075 7.04636C2.0843 7.08851 2 7.19389 2 7.32034C2 7.44678 2.0843 7.57323 2.21075 7.59431C4.06533 8.03688 5.56164 9.53319 6.02529 11.4088Z" />
        </g>
      </g>
    </>
  ),
  fire: () => (
    <>
      <g id="fire">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.47295 11.1448C5.88583 10.1831 6.49059 9.24995 7.325 8.51C7.15285 9.77692 7.32691 10.6687 7.65995 11.24C8.56506 12.7926 10.6444 11.9784 10.14 9.895C9.50514 7.29869 10.4286 5.16728 11.5238 3.73771C12.1624 2.90426 12.8594 2.30937 13.34 2C13.3489 2.82917 13.4959 3.56873 13.74 4.24458C14.3245 5.86346 15.4657 7.11677 16.598 8.36035C18.1827 10.1008 19.75 11.8222 19.75 14.5C19.75 15.4849 19.556 16.4602 19.1791 17.3701C18.8022 18.2801 18.2497 19.1069 17.5533 19.8033C16.8569 20.4997 16.0301 21.0522 15.1201 21.4291C14.2102 21.806 13.2349 22 12.25 22C11.2651 22 10.2898 21.806 9.37987 21.4291C8.46993 21.0522 7.64314 20.4997 6.9467 19.8033C6.25026 19.1069 5.69781 18.2801 5.3209 17.3701C4.94399 16.4602 4.75 15.4849 4.75 14.5C4.75 13.5399 4.96794 12.3211 5.47295 11.1448ZM6.87379 13.3368C6.79048 13.7506 6.75 14.1471 6.75 14.5C6.75 15.2223 6.89226 15.9375 7.16866 16.6048C7.44506 17.2721 7.85019 17.8784 8.36091 18.3891C8.87163 18.8998 9.47795 19.3049 10.1452 19.5813C10.8125 19.8577 11.5277 20 12.25 20C12.9723 20 13.6875 19.8577 14.3548 19.5813C15.0221 19.3049 15.6284 18.8998 16.1391 18.3891C16.6498 17.8784 17.0549 17.2721 17.3313 16.6048C17.6077 15.9375 17.75 15.2223 17.75 14.5C17.75 12.6865 16.7566 11.5053 15.0886 9.67332C15.0584 9.64014 15.028 9.60672 14.9973 9.57307C14.1509 8.64416 13.1412 7.53618 12.3974 6.13181C11.9734 7.05601 11.7736 8.15567 12.0828 9.41995L12.0838 9.42438L12.0838 9.42439C12.3684 10.5998 12.2084 11.8097 11.4955 12.7509C10.7913 13.6805 9.65734 14.173 8.49196 14.0206C7.88376 13.9411 7.33597 13.6984 6.87379 13.3368Z"
        />
      </g>
    </>
  ),
  play: () => (
    <>
      <g id="play">
        <path id="path" d="M5 22L22.32 12L5 2V22Z" />
      </g>
    </>
  ),
  'play-small': () => (
    <>
      <g id="play-small">
        <path id="path" d="M7 20L20 12L7 4V20Z" />
      </g>
    </>
  ),
  playback: () => (
    <>
      <g id="playback">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13 5H15V19H13V5ZM11 8H9V19H11V8ZM7 10H5V19H7V10ZM19 12H17V19H19V12Z"
        />
      </g>
    </>
  ),
  'playback-paused': () => (
    <>
      <g id="playback-paused">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 17H5V19H7V17ZM11 17H9V19H11V17ZM13 17H15V19H13V17ZM19 17H17V19H19V17Z"
        />
      </g>
    </>
  ),
  'play-circle': () => (
    <>
      <g id="play-circle">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
          />
          <path d="M9.5 16L16.5 12L9.5 8V16Z" />
        </g>
      </g>
    </>
  ),
  'play-circle-filled': () => (
    <>
      <g id="play-circle-filled">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM16.5 12L9.5 16V8L16.5 12Z"
        />
      </g>
    </>
  ),
  pause: () => (
    <>
      <g id="pause">
        <path
          id="path"
          d="M3 21.001H8V3.00098H3V21.001ZM16 3.00098V21.001H21V3.00098H16Z"
        />
      </g>
    </>
  ),
  'pause-small': () => (
    <>
      <g id="pause-small">
        <g id="path">
          <path d="M9 3H5V21H9V3Z" />
          <path d="M19 3H15V21H19V3Z" />
        </g>
      </g>
    </>
  ),
  'pause-circle': () => (
    <>
      <g id="pause-circle">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
          />
          <path d="M9 16H11V8H9V16Z" />
          <path d="M13 16H15V8H13V16Z" />
        </g>
      </g>
    </>
  ),
  'pause-circle-filled': () => (
    <>
      <g id="pause-circle-filled">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM11 16H9V8H11V16ZM15 16H13V8H15V16Z"
        />
      </g>
    </>
  ),
  stop: () => (
    <>
      <g id="stop">
        <path id="path" d="M21 3.00098H3V21.001H21V3.00098Z" />
      </g>
    </>
  ),
  'stop-circle': () => (
    <>
      <g id="stop-circle">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
          />
          <path d="M15 9H9V15H15V9Z" />
        </g>
      </g>
    </>
  ),
  'stop-circle-filled': () => (
    <>
      <g id="stop-circle-filled">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM9 9H15V15H9V9Z"
        />
      </g>
    </>
  ),
  'skip-left': () => (
    <>
      <g id="skip-left">
        <path id="path" d="M6 22H3V2H6V10.66L21 2V22L6 13.34V22Z" />
      </g>
    </>
  ),
  'skip-right': () => (
    <>
      <g id="skip-right">
        <path id="path" d="M18 22H21V2H18V10.66L3 2V22L18 13.34V22Z" />
      </g>
    </>
  ),
  'skip-left10': () => (
    <>
      <g id="skip-left10">
        <g id="path">
          <path d="M9.24714 3.16432L7.41862 4.99256H21.0041V19.9926H19.0041V6.99256H7.4185L9.24717 8.82107L7.83302 10.2353L3.58984 5.99254L7.83304 1.75L9.24714 3.16432Z" />
          <path d="M4.56478 15.5198L3.59978 14.2434L6.18286 12.4092H7.8808V20.0032H6.02987V14.4257L4.56478 15.5198Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.9022 13.3906C15.1564 13.7782 15.3363 14.207 15.4334 14.6563V14.6606C15.5466 15.1612 15.6023 15.6724 15.5997 16.1848C15.6024 16.7005 15.5467 17.2147 15.4334 17.7186C15.3357 18.1727 15.1559 18.6067 14.9022 19.0004C14.6544 19.3861 14.3049 19.701 13.8898 19.913C13.4747 20.1251 13.0088 20.2266 12.5398 20.2071C12.0684 20.2264 11.6001 20.1249 11.1822 19.913C10.7643 19.7012 10.4116 19.3864 10.1598 19.0004C9.90149 18.6084 9.71969 18.174 9.62316 17.7186C9.50934 17.2148 9.45304 16.7005 9.45556 16.1848C9.45284 15.6709 9.50914 15.1583 9.62316 14.6563C9.7191 14.2058 9.90101 13.7765 10.1598 13.3906C10.4047 13.035 10.7335 12.7409 11.1191 12.5326C11.5557 12.3077 12.0454 12.1967 12.5398 12.2107C13.0318 12.1961 13.5191 12.3072 13.9526 12.5326C14.3358 12.7406 14.6617 13.0349 14.9022 13.3906ZM13.4815 17.7884C13.5655 17.5264 13.6214 17.2569 13.6488 16.9839V16.9881C13.6777 16.6985 13.6933 16.4208 13.6933 16.1848C13.6933 15.9489 13.6777 15.6881 13.6488 15.4017C13.6211 15.1306 13.5651 14.8628 13.4815 14.6026C13.4107 14.3744 13.2922 14.1627 13.1333 13.9806C13.0601 13.8984 12.9687 13.8332 12.8661 13.7895C12.7634 13.7459 12.6519 13.7251 12.5398 13.7285C12.4269 13.7251 12.3147 13.7458 12.2111 13.7894C12.1075 13.833 12.0152 13.8983 11.9409 13.9806C11.7773 14.1616 11.6543 14.3734 11.5794 14.6026C11.4912 14.8619 11.4335 15.13 11.4075 15.4017C11.3786 15.6881 11.3631 15.9414 11.3631 16.1848C11.3631 16.4283 11.3786 16.6943 11.4075 16.9839C11.4332 17.2575 11.4909 17.5274 11.5794 17.7884C11.6543 18.0176 11.7773 18.2294 11.9409 18.4104C12.0152 18.4927 12.1075 18.558 12.2111 18.6016C12.3147 18.6452 12.4269 18.666 12.5398 18.6625C12.6519 18.6659 12.7634 18.6451 12.8661 18.6015C12.9687 18.5579 13.0601 18.4926 13.1333 18.4104C13.2922 18.2283 13.4107 18.0166 13.4815 17.7884Z"
          />
        </g>
      </g>
    </>
  ),
  'skip-right10': () => (
    <>
      <g id="skip-right10">
        <g id="path">
          <path d="M15.757 3.17165L17.5855 4.99989H4V19.9999H6V6.99989H17.5856L15.757 8.82839L17.1711 10.2427L21.4143 5.99986L17.1711 1.75732L15.757 3.17165Z" />
          <path d="M9.965 15.5272L9 14.2507L11.5831 12.4166H13.281V20.0106H11.4301V14.4331L9.965 15.5272Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.3024 13.3979C20.5566 13.7855 20.7366 14.2143 20.8337 14.6636V14.668C20.9469 15.1686 21.0025 15.6797 20.9999 16.1922C21.0026 16.7078 20.947 17.2221 20.8337 17.7259C20.7359 18.1801 20.5561 18.6141 20.3024 19.0078C20.0547 19.3934 19.7051 19.7083 19.29 19.9204C18.8749 20.1324 18.409 20.2339 17.94 20.2144C17.4686 20.2337 17.0003 20.1322 16.5824 19.9204C16.1645 19.7085 15.8118 19.3937 15.56 19.0078C15.3017 18.6158 15.1199 18.1813 15.0234 17.7259C14.9096 17.2221 14.8533 16.7078 14.8558 16.1922C14.8531 15.6783 14.9094 15.1656 15.0234 14.6636C15.1193 14.2131 15.3012 13.7838 15.56 13.3979C15.8049 13.0423 16.1337 12.7483 16.5193 12.5399C16.9559 12.315 17.4456 12.2041 17.94 12.2181C18.432 12.2035 18.9193 12.3145 19.3529 12.5399C19.736 12.748 20.0619 13.0422 20.3024 13.3979ZM18.8817 17.7957C18.9657 17.5338 19.0216 17.2642 19.0491 16.9912V16.9954C19.0779 16.7058 19.0935 16.4281 19.0935 16.1922C19.0935 15.9562 19.0779 15.6954 19.0491 15.409C19.0213 15.1379 18.9654 14.8702 18.8817 14.61C18.8109 14.3817 18.6924 14.17 18.5335 13.9879C18.4603 13.9058 18.369 13.8405 18.2663 13.7969C18.1636 13.7533 18.0521 13.7324 17.94 13.7359C17.8271 13.7324 17.7149 13.7531 17.6113 13.7967C17.5078 13.8403 17.4154 13.9056 17.3411 13.9879C17.1776 14.169 17.0545 14.3807 16.9796 14.61C16.8914 14.8692 16.8337 15.1373 16.8077 15.409C16.7789 15.6954 16.7633 15.9487 16.7633 16.1922C16.7633 16.4356 16.7789 16.7016 16.8077 16.9912C16.8334 17.2648 16.8911 17.5347 16.9796 17.7957C17.0545 18.025 17.1775 18.2367 17.3411 18.4178C17.4154 18.5 17.5078 18.5653 17.6113 18.6089C17.7149 18.6525 17.8271 18.6733 17.94 18.6698C18.0521 18.6732 18.1636 18.6524 18.2663 18.6088C18.369 18.5652 18.4603 18.4999 18.5335 18.4178C18.6924 18.2357 18.8109 18.024 18.8817 17.7957Z"
          />
        </g>
      </g>
    </>
  ),
  shuffle: () => (
    <>
      <g id="shuffle">
        <g id="path">
          <path d="M3 16.5869V19.4152L14.4161 7.99991H17.8352L16.2913 9.54248L17.7048 10.9573L21.6658 6.99991L17.7048 3.04248L16.2913 4.45733L17.8352 5.99991H13.5878L3 16.5869Z" />
          <path d="M3 4.58496V7.41328L5.81844 10.2315L7.23265 8.8173L3 4.58496Z" />
          <path d="M10.7684 15.1811L13.5877 18.0002L17.8342 18.0009L16.2909 19.5442L17.7052 20.9584L21.6623 17.0013L17.7052 13.0442L16.2909 14.4584L17.8334 16.0009L14.4162 16.0003L12.1826 13.7669L10.7684 15.1811Z" />
        </g>
      </g>
    </>
  ),
  repeat: () => (
    <>
      <g id="repeat">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.99902 5H20.999V18.9999L13.413 19.0007L14.9561 20.5439L13.5419 21.9581L9.58481 18.001L13.5419 14.0439L14.9561 15.4581L13.4135 17.0007L18.999 17.0001V7H4.99902V17H8V19H2.99902V5Z"
        />
      </g>
    </>
  ),
  'repeat-one': () => (
    <>
      <g id="repeat-one">
        <g id="path">
          <path d="M2.95068 12H4.95068V5H3.62207L1 6.927L2.18604 8.53796L2.95068 7.97595V12Z" />
          <path d="M2.99902 15H4.99902V17H8V19H2.99902V15Z" />
          <path d="M18.999 7H8V5H20.999V18.9999L13.413 19.0007L14.9561 20.5439L13.5419 21.9581L9.58481 18.001L13.5419 14.0439L14.9561 15.4581L13.4135 17.0007L18.999 17.0001V7Z" />
        </g>
      </g>
    </>
  ),
  equalizer: () => (
    <>
      <g id="equalizer">
        <g id="path">
          <path d="M13.6667 4V20H15.6667V4H13.6667Z" />
          <path d="M19 8V20H21V8H19Z" />
          <path d="M8.33334 12H10.3333V20H8.33334V12Z" />
          <path d="M3 6H5V20H3V6Z" />
        </g>
      </g>
    </>
  ),
  controls: () => (
    <>
      <g id="controls">
        <g id="path">
          <path d="M7 6V4L3 4V6L7 6Z" />
          <path d="M6 8H4V20H6V8Z" />
          <path d="M18 8H20V20H18V8Z" />
          <path d="M21 6V4L17 4V6L21 6Z" />
          <path d="M11 16H13V4H11V16Z" />
          <path d="M14 18V20H10V18H14Z" />
        </g>
      </g>
    </>
  ),
  night: () => (
    <>
      <g id="night">
        <g id="path">
          <path d="M13.3525 3.92188C13.3525 4.61223 12.7929 5.17188 12.1025 5.17188C11.4122 5.17188 10.8525 4.61223 10.8525 3.92188C10.8525 3.23152 11.4122 2.67188 12.1025 2.67188C12.7929 2.67188 13.3525 3.23152 13.3525 3.92188Z" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.65901 4.39011C4.29886 6.08605 2.76172 8.85514 2.76172 11.9833C2.76172 17.1437 6.94511 21.3271 12.1056 21.3271C15.1772 21.3271 17.9026 19.8451 19.6057 17.557C20.0415 16.9715 20.4104 16.3333 20.701 15.6536C19.9945 15.6091 19.3033 15.508 18.632 15.3548C13.728 14.2356 9.88293 10.3351 8.84447 5.40081C8.70274 4.72736 8.61329 4.03466 8.58056 3.32715C7.89572 3.60632 7.25143 3.96441 6.65901 4.39011ZM7.08213 6.62575C5.65293 7.9666 4.76172 9.87198 4.76172 11.9833C4.76172 16.0392 8.04968 19.3271 12.1056 19.3271C14.1725 19.3271 16.042 18.4731 17.3778 17.0962C12.3705 15.6534 8.44251 11.6672 7.08213 6.62575Z"
          />
          <path d="M16.3121 5.82715C17.0025 5.82715 17.5621 5.2675 17.5621 4.57715C17.5621 3.88679 17.0025 3.32715 16.3121 3.32715C15.6218 3.32715 15.0621 3.88679 15.0621 4.57715C15.0621 5.2675 15.6218 5.82715 16.3121 5.82715Z" />
          <path d="M20.5828 7.59766C20.5828 8.28801 20.0231 8.84766 19.3328 8.84766C18.6424 8.84766 18.0828 8.28801 18.0828 7.59766C18.0828 6.9073 18.6424 6.34766 19.3328 6.34766C20.0231 6.34766 20.5828 6.9073 20.5828 7.59766Z" />
          <path d="M19.9888 13.0596C20.6791 13.0596 21.2388 12.4999 21.2388 11.8096C21.2388 11.1192 20.6791 10.5596 19.9888 10.5596C19.2984 10.5596 18.7388 11.1192 18.7388 11.8096C18.7388 12.4999 19.2984 13.0596 19.9888 13.0596Z" />
        </g>
      </g>
    </>
  ),
  'night-active': () => (
    <>
      <g id="night-active">
        <g id="path">
          <path d="M12.1025 5.17188C12.7929 5.17188 13.3525 4.61223 13.3525 3.92188C13.3525 3.23152 12.7929 2.67188 12.1025 2.67188C11.4122 2.67188 10.8525 3.23152 10.8525 3.92188C10.8525 4.61223 11.4122 5.17188 12.1025 5.17188Z" />
          <path d="M17.5621 4.57715C17.5621 5.2675 17.0025 5.82715 16.3121 5.82715C15.6218 5.82715 15.0621 5.2675 15.0621 4.57715C15.0621 3.88679 15.6218 3.32715 16.3121 3.32715C17.0025 3.32715 17.5621 3.88679 17.5621 4.57715Z" />
          <path d="M20.5828 7.59766C20.5828 8.28801 20.0231 8.84766 19.3328 8.84766C18.6424 8.84766 18.0828 8.28801 18.0828 7.59766C18.0828 6.9073 18.6424 6.34766 19.3328 6.34766C20.0231 6.34766 20.5828 6.9073 20.5828 7.59766Z" />
          <path d="M21.2388 11.8096C21.2388 12.4999 20.6791 13.0596 19.9888 13.0596C19.2984 13.0596 18.7388 12.4999 18.7388 11.8096C18.7388 11.1192 19.2984 10.5596 19.9888 10.5596C20.6791 10.5596 21.2388 11.1192 21.2388 11.8096Z" />
          <path d="M3.08105 12.3371C3.08105 9.46495 4.4979 6.92211 6.67855 5.36274C6.84309 5.24509 7.01193 5.13307 7.18478 5.02698C7.22421 5.27979 7.27028 5.53047 7.32281 5.77884C8.47927 11.2472 12.7588 15.5673 18.2198 16.8075C18.4685 16.864 18.7196 16.9141 18.9729 16.9576C18.8634 17.1278 18.7481 17.2939 18.627 17.4557C17.0534 19.5594 14.5387 20.9189 11.7046 20.9189C6.94194 20.9189 3.08105 17.0767 3.08105 12.3371Z" />
        </g>
      </g>
    </>
  ),
  queue: () => (
    <>
      <g id="queue">
        <g id="path">
          <path d="M4 4H20V6H4V4Z" />
          <path d="M4 18H20V20H4V18Z" />
          <path d="M11 11H20V13H11V11Z" />
          <path d="M4 9V15L9.2002 12L4 9Z" />
        </g>
      </g>
    </>
  ),
  maximise: () => (
    <>
      <g id="maximise">
        <g id="path">
          <path d="M22 20L2 20L2 4L13 4V6L4 6L4 18L20 18V13H22V20Z" />
          <path d="M20 7.41418V11H22V4L15 4V6L18.5858 6L12.7928 11.7929L14.207 13.2072L20 7.41418Z" />
        </g>
      </g>
    </>
  ),
  minimise: () => (
    <>
      <g id="minimise">
        <g id="path">
          <path d="M2 4L22 4L22 20L11 20L11 18L20 18L20 6L4 6L4 11L2 11L2 4Z" />
          <path d="M4 16.5858L4 13L2 13L2 20L9 20L9 18L5.41424 18L11.2072 12.2071L9.79297 10.7928L4 16.5858Z" />
        </g>
      </g>
    </>
  ),
  'volume-0': () => (
    <>
      <g id="volume-0">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.206 6.5H1V16.5H6.206L14 21V2L6.206 6.5ZM12 5.46415L6.74191 8.5H3V14.5H6.74191L12 17.5358V5.46415Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.0301 12.9142L22.573 15.4571L23.9872 14.0429L21.4443 11.5L23.9872 8.95711L22.573 7.54289L20.0301 10.0858L17.4872 7.54289L16.073 8.95711L18.6158 11.5L16.073 14.0429L17.4872 15.4571L20.0301 12.9142Z"
          />
        </g>
      </g>
    </>
  ),
  'volume-1': () => (
    <>
      <g id="volume-1">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.206 6.5H1V16.5H6.206L14 21V2L6.206 6.5ZM12 5.46415L6.74191 8.5H3V14.5H6.74191L12 17.5358V5.46415Z"
        />
      </g>
    </>
  ),
  'volume-2': () => (
    <>
      <g id="volume-2">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.206 6.5H1V16.5H6.206L14 21V2L6.206 6.5ZM12 5.46415L6.74191 8.5H3V14.5H6.74191L12 17.5358V5.46415Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 16.6973C18.7934 15.6599 20 13.7209 20 11.5C20 9.27919 18.7934 7.34016 17 6.30273V8.85422C17.6224 9.55935 18 10.4856 18 11.5C18 12.5145 17.6224 13.4407 17 14.1459V16.6973Z"
          />
        </g>
      </g>
    </>
  ),
  'volume-3': () => (
    <>
      <g id="volume-3">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.206 6.5H1V16.5H6.206L14 21V2L6.206 6.5ZM12 5.46415L6.74191 8.5H3V14.5H6.74191L12 17.5358V5.46415Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23 11.4999C23 15.3243 20.4743 18.5588 17 19.6263V17.5018C19.349 16.5222 21 14.2039 21 11.4999C21 8.79599 19.349 6.47766 17 5.4981V3.37354C20.4743 4.44111 23 7.67557 23 11.4999Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 15.2423C18.206 14.435 19 13.0602 19 11.5C19 9.93983 18.206 8.56507 17 7.75781V15.2423Z"
          />
        </g>
      </g>
    </>
  ),
  headphones: () => (
    <>
      <g id="headphones">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.51724 10.023C5.6761 10.0078 5.83714 10 6 10H8V20H6C3.23858 20 1 17.7614 1 15C1 13.1486 2.00623 11.5323 3.50163 10.668C3.50054 10.6121 3.5 10.5561 3.5 10.5C3.5 5.80558 7.30558 2 12 2C16.6944 2 20.5 5.80558 20.5 10.5C20.5 10.5561 20.4995 10.6121 20.4984 10.668C21.9938 11.5323 23 13.1486 23 15C23 17.7614 20.7614 20 18 20H16V10H18C18.1629 10 18.3239 10.0078 18.4828 10.023C18.2386 6.65587 15.4294 4 12 4C8.57057 4 5.76145 6.65587 5.51724 10.023ZM6 12C4.34315 12 3 13.3431 3 15C3 16.6569 4.34315 18 6 18V12ZM18 12C19.6569 12 21 13.3431 21 15C21 16.6569 19.6569 18 18 18V12Z"
        />
      </g>
    </>
  ),
  'hi-res': () => (
    <>
      <g id="hi-res">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 7C6 6.44772 6.44772 6 7 6H17C17.5523 6 18 6.44772 18 7V17C18 17.5523 17.5523 18 17 18H7C6.44772 18 6 17.5523 6 17V7ZM16.5 12C16.5 14.4853 14.4853 16.5 12 16.5C9.51472 16.5 7.5 14.4853 7.5 12C7.5 9.51472 9.51472 7.5 12 7.5C14.4853 7.5 16.5 9.51472 16.5 12ZM12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z"
        />
      </g>
    </>
  ),
  infinity: () => (
    <>
      <g id="infinity">
        <path
          id="path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 12.29C1 9.36772 3.36772 7 6.29 7C7.74695 7 9.06556 7.59365 10.0225 8.53835L10.0479 8.5634L10.4314 9.0002L8.92856 10.3198L8.59361 9.93833C7.99286 9.3568 7.18119 9 6.29 9C4.47228 9 3 10.4723 3 12.29C3 14.1077 4.47228 15.58 6.29 15.58C7.19842 15.58 8.01473 15.2182 8.59809 14.6281L13.9634 8.56213L13.9875 8.53835C14.9444 7.59365 16.263 7 17.72 7C20.6423 7 23.01 9.36771 23.01 12.29C23.01 15.2123 20.6423 17.58 17.72 17.58C16.2566 17.58 14.9195 16.9884 13.9639 16.008L13.9495 15.9932L13.5858 15.5879L15.0742 14.2521L15.4096 14.6257C15.9931 15.2172 16.8104 15.58 17.72 15.58C19.5377 15.58 21.01 14.1077 21.01 12.29C21.01 10.4723 19.5377 9 17.72 9C16.8282 9 16.016 9.35728 15.4152 9.93951L10.063 15.9907L10.0461 16.008C9.09048 16.9884 7.75335 17.58 6.29 17.58C3.36772 17.58 1 15.2123 1 12.29Z"
        />
      </g>
    </>
  ),
  keyboard: () => (
    <>
      <g id="keyboard">
        <path d="M4.57659 18.7023C2.87981 18.7023 2 17.8303 2 16.1493V8.55302C2 6.87196 2.87981 6 4.57659 6H19.4313C21.1202 6 22 6.87196 22 8.55302V16.1493C22 17.8303 21.1202 18.7023 19.4313 18.7023H4.57659ZM4.67086 17.1626H19.337C20.0597 17.1626 20.4682 16.7855 20.4682 16.0157V8.67871C20.4682 7.91673 20.0597 7.53967 19.337 7.53967H4.67086C3.9403 7.53967 3.53967 7.91673 3.53967 8.67871V16.0157C3.53967 16.7855 3.9403 17.1626 4.67086 17.1626ZM5.41713 10.5719C5.18932 10.5719 5.04792 10.4383 5.04792 10.2105V9.48782C5.04792 9.26002 5.18932 9.11862 5.41713 9.11862H6.13983C6.36764 9.11862 6.50903 9.26002 6.50903 9.48782V10.2105C6.50903 10.4383 6.36764 10.5719 6.13983 10.5719H5.41713ZM7.89945 10.5719C7.67164 10.5719 7.5381 10.4383 7.5381 10.2105V9.48782C7.5381 9.26002 7.67164 9.11862 7.89945 9.11862H8.62215C8.84996 9.11862 8.99136 9.26002 8.99136 9.48782V10.2105C8.99136 10.4383 8.84996 10.5719 8.62215 10.5719H7.89945ZM10.3896 10.5719C10.154 10.5719 10.0204 10.4383 10.0204 10.2105V9.48782C10.0204 9.26002 10.154 9.11862 10.3896 9.11862H11.1045C11.3323 9.11862 11.4737 9.26002 11.4737 9.48782V10.2105C11.4737 10.4383 11.3323 10.5719 11.1045 10.5719H10.3896ZM12.872 10.5719C12.6441 10.5719 12.5027 10.4383 12.5027 10.2105V9.48782C12.5027 9.26002 12.6441 9.11862 12.872 9.11862H13.5947C13.8225 9.11862 13.956 9.26002 13.956 9.48782V10.2105C13.956 10.4383 13.8225 10.5719 13.5947 10.5719H12.872ZM15.37 10.5719C15.1343 10.5719 14.9851 10.4383 14.9851 10.2105V9.48782C14.9851 9.26002 15.1343 9.11862 15.37 9.11862H16.077C16.3048 9.11862 16.4383 9.26002 16.4383 9.48782V10.2105C16.4383 10.4383 16.3048 10.5719 16.077 10.5719H15.37ZM17.8366 10.5719C17.6088 10.5719 17.4674 10.4383 17.4674 10.2105V9.48782C17.4674 9.26002 17.6088 9.11862 17.8366 9.11862H18.5593C18.7871 9.11862 18.9285 9.26002 18.9285 9.48782V10.2105C18.9285 10.4383 18.7871 10.5719 18.5593 10.5719H17.8366ZM5.41713 13.0778C5.18932 13.0778 5.04792 12.9364 5.04792 12.7086V11.9859C5.04792 11.7581 5.18932 11.6167 5.41713 11.6167H6.13983C6.36764 11.6167 6.50903 11.7581 6.50903 11.9859V12.7086C6.50903 12.9364 6.36764 13.0778 6.13983 13.0778H5.41713ZM7.89945 13.0778C7.67164 13.0778 7.5381 12.9364 7.5381 12.7086V11.9859C7.5381 11.7581 7.67164 11.6167 7.89945 11.6167H8.62215C8.84996 11.6167 8.99136 11.7581 8.99136 11.9859V12.7086C8.99136 12.9364 8.84996 13.0778 8.62215 13.0778H7.89945ZM10.3896 13.0778C10.154 13.0778 10.0204 12.9364 10.0204 12.7086V11.9859C10.0204 11.7581 10.154 11.6167 10.3896 11.6167H11.1045C11.3323 11.6167 11.4737 11.7581 11.4737 11.9859V12.7086C11.4737 12.9364 11.3323 13.0778 11.1045 13.0778H10.3896ZM12.872 13.0778C12.6441 13.0778 12.5027 12.9364 12.5027 12.7086V11.9859C12.5027 11.7581 12.6441 11.6167 12.872 11.6167H13.5947C13.8225 11.6167 13.956 11.7581 13.956 11.9859V12.7086C13.956 12.9364 13.8225 13.0778 13.5947 13.0778H12.872ZM15.37 13.0778C15.1343 13.0778 14.9851 12.9364 14.9851 12.7086V11.9859C14.9851 11.7581 15.1343 11.6167 15.37 11.6167H16.077C16.3048 11.6167 16.4383 11.7581 16.4383 11.9859V12.7086C16.4383 12.9364 16.3048 13.0778 16.077 13.0778H15.37ZM17.8366 13.0778C17.6088 13.0778 17.4674 12.9364 17.4674 12.7086V11.9859C17.4674 11.7581 17.6088 11.6167 17.8366 11.6167H18.5593C18.7871 11.6167 18.9285 11.7581 18.9285 11.9859V12.7086C18.9285 12.9364 18.7871 13.0778 18.5593 13.0778H17.8366ZM5.41713 15.5758C5.18932 15.5758 5.04792 15.4344 5.04792 15.2066V14.4839C5.04792 14.2561 5.18932 14.1147 5.41713 14.1147H6.13983C6.36764 14.1147 6.50903 14.2561 6.50903 14.4839V15.2066C6.50903 15.4344 6.36764 15.5758 6.13983 15.5758H5.41713ZM7.97015 15.5758C7.69521 15.5758 7.5381 15.4187 7.5381 15.1438V14.5546C7.5381 14.2797 7.69521 14.1147 7.97015 14.1147H16.0063C16.2812 14.1147 16.4383 14.2797 16.4383 14.5546V15.1438C16.4383 15.4187 16.2812 15.5758 16.0063 15.5758H7.97015ZM17.8366 15.5758C17.6088 15.5758 17.4674 15.4344 17.4674 15.2066V14.4839C17.4674 14.2561 17.6088 14.1147 17.8366 14.1147H18.5593C18.7871 14.1147 18.9285 14.2561 18.9285 14.4839V15.2066C18.9285 15.4344 18.7871 15.5758 18.5593 15.5758H17.8366Z" />
      </g>
    </>
  ),
  'keyboard-active': () => (
    <>
      <g id="keyboard-active">
        <path d="M4.57659 18.7023C2.87981 18.7023 2 17.8303 2 16.1493V8.55302C2 6.87196 2.87981 6 4.57659 6H19.4313C21.1202 6 22 6.87196 22 8.55302V16.1493C22 17.8303 21.1202 18.7023 19.4313 18.7023H4.57659ZM5.15789 10.509H5.91202C6.14768 10.509 6.29694 10.3598 6.29694 10.1241V9.36999C6.29694 9.13433 6.14768 8.99293 5.91202 8.99293H5.15789C4.92223 8.99293 4.78083 9.13433 4.78083 9.36999V10.1241C4.78083 10.3598 4.92223 10.509 5.15789 10.509ZM7.74234 10.509H8.48861C8.73213 10.509 8.87353 10.3598 8.87353 10.1241V9.36999C8.87353 9.13433 8.73213 8.99293 8.48861 8.99293H7.74234C7.49882 8.99293 7.35742 9.13433 7.35742 9.36999V10.1241C7.35742 10.3598 7.49882 10.509 7.74234 10.509ZM10.3189 10.509H11.0731C11.3087 10.509 11.458 10.3598 11.458 10.1241V9.36999C11.458 9.13433 11.3087 8.99293 11.0731 8.99293H10.3189C10.0911 8.99293 9.94187 9.13433 9.94187 9.36999V10.1241C9.94187 10.3598 10.0911 10.509 10.3189 10.509ZM12.9034 10.509H13.6575C13.8853 10.509 14.0346 10.3598 14.0346 10.1241V9.36999C14.0346 9.13433 13.8853 8.99293 13.6575 8.99293H12.9034C12.6677 8.99293 12.5185 9.13433 12.5185 9.36999V10.1241C12.5185 10.3598 12.6677 10.509 12.9034 10.509ZM15.5035 10.509H16.2419C16.4776 10.509 16.619 10.3598 16.619 10.1241V9.36999C16.619 9.13433 16.4776 8.99293 16.2419 8.99293H15.5035C15.2522 8.99293 15.1029 9.13433 15.1029 9.36999V10.1241C15.1029 10.3598 15.2522 10.509 15.5035 10.509ZM18.0644 10.509H18.8185C19.0542 10.509 19.1956 10.3598 19.1956 10.1241V9.36999C19.1956 9.13433 19.0542 8.99293 18.8185 8.99293H18.0644C17.8288 8.99293 17.6795 9.13433 17.6795 9.36999V10.1241C17.6795 10.3598 17.8288 10.509 18.0644 10.509ZM5.15789 13.1092H5.91202C6.14768 13.1092 6.29694 12.9599 6.29694 12.7243V11.9701C6.29694 11.7345 6.14768 11.5852 5.91202 11.5852H5.15789C4.92223 11.5852 4.78083 11.7345 4.78083 11.9701V12.7243C4.78083 12.9599 4.92223 13.1092 5.15789 13.1092ZM7.74234 13.1092H8.48861C8.73213 13.1092 8.87353 12.9599 8.87353 12.7243V11.9701C8.87353 11.7345 8.73213 11.5852 8.48861 11.5852H7.74234C7.49882 11.5852 7.35742 11.7345 7.35742 11.9701V12.7243C7.35742 12.9599 7.49882 13.1092 7.74234 13.1092ZM10.3189 13.1092H11.0731C11.3087 13.1092 11.458 12.9599 11.458 12.7243V11.9701C11.458 11.7345 11.3087 11.5852 11.0731 11.5852H10.3189C10.0911 11.5852 9.94187 11.7345 9.94187 11.9701V12.7243C9.94187 12.9599 10.0911 13.1092 10.3189 13.1092ZM12.9034 13.1092H13.6575C13.8853 13.1092 14.0346 12.9599 14.0346 12.7243V11.9701C14.0346 11.7345 13.8853 11.5852 13.6575 11.5852H12.9034C12.6677 11.5852 12.5185 11.7345 12.5185 11.9701V12.7243C12.5185 12.9599 12.6677 13.1092 12.9034 13.1092ZM15.5035 13.1092H16.2419C16.4776 13.1092 16.619 12.9599 16.619 12.7243V11.9701C16.619 11.7345 16.4776 11.5852 16.2419 11.5852H15.5035C15.2522 11.5852 15.1029 11.7345 15.1029 11.9701V12.7243C15.1029 12.9599 15.2522 13.1092 15.5035 13.1092ZM18.0644 13.1092H18.8185C19.0542 13.1092 19.1956 12.9599 19.1956 12.7243V11.9701C19.1956 11.7345 19.0542 11.5852 18.8185 11.5852H18.0644C17.8288 11.5852 17.6795 11.7345 17.6795 11.9701V12.7243C17.6795 12.9599 17.8288 13.1092 18.0644 13.1092ZM5.15789 15.7015H5.91202C6.14768 15.7015 6.29694 15.5601 6.29694 15.3244V14.5703C6.29694 14.3346 6.14768 14.1854 5.91202 14.1854H5.15789C4.92223 14.1854 4.78083 14.3346 4.78083 14.5703V15.3244C4.78083 15.5601 4.92223 15.7015 5.15789 15.7015ZM7.81304 15.7015H16.1634C16.454 15.7015 16.619 15.5365 16.619 15.2537V14.641C16.619 14.3504 16.454 14.1854 16.1634 14.1854H7.81304C7.53024 14.1854 7.35742 14.3504 7.35742 14.641V15.2537C7.35742 15.5365 7.53024 15.7015 7.81304 15.7015ZM18.0644 15.7015H18.8185C19.0542 15.7015 19.1956 15.5601 19.1956 15.3244V14.5703C19.1956 14.3346 19.0542 14.1854 18.8185 14.1854H18.0644C17.8288 14.1854 17.6795 14.3346 17.6795 14.5703V15.3244C17.6795 15.5601 17.8288 15.7015 18.0644 15.7015Z" />
      </g>
    </>
  ),
  'click-drag': () => (
    <>
      <g id="click-drag">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.1429 6.09375C15.1429 7.296 14.4462 8.33809 13.4286 8.85016V9.48249C13.6776 9.29709 13.9873 9.1875 14.3149 9.1875C15.1039 9.1875 15.7434 9.81704 15.7435 10.5936C15.9823 10.4171 16.279 10.3125 16.6006 10.3125C17.3896 10.3125 18.0292 10.942 18.0292 11.7186C18.268 11.5421 18.5648 11.4375 18.8864 11.4375C19.6753 11.4375 20.3149 12.0671 20.3149 12.8437C20.3149 13.9218 20.3215 15.0002 20.3215 16.0781C20.3215 18.7964 18.0829 21 15.3215 21C13.6105 21 12.1003 20.1538 11.1993 18.8646L7.63418 14.4819C7.14103 13.8757 7.24051 12.9907 7.85637 12.5052C8.47224 12.0198 9.37127 12.1177 9.86442 12.724L10.5714 13.5931L10.5714 8.85016C9.55381 8.33809 8.85715 7.296 8.85715 6.09375C8.85715 4.38512 10.2643 3 12 3C13.7358 3 15.1429 4.38512 15.1429 6.09375ZM12 5.25C11.5266 5.25 11.1429 5.62776 11.1429 6.09375V15.375H10.5714V14.493L9.41838 13.0756C9.12249 12.7118 8.58306 12.6531 8.21355 12.9443C7.84403 13.2356 7.78434 13.7666 8.08023 14.1303L11.6586 18.5293L11.6647 18.538C12.4629 19.6856 13.8031 20.4375 15.3215 20.4375C17.7673 20.4375 19.7501 18.4857 19.7501 16.0781C19.7501 15.0002 19.7436 13.9218 19.7435 12.8437C19.7435 12.3778 19.3597 12 18.8864 12C18.4134 12 18.0299 12.3771 18.0292 12.8426L18.0286 14.1094H17.4572L17.4578 11.7187C17.4578 11.2528 17.074 10.875 16.6006 10.875C16.1273 10.875 15.7435 11.2528 15.7435 11.7187L15.7429 14.1094H15.1714L15.1721 10.5937C15.1721 10.1278 14.7883 9.75 14.3149 9.75C13.8321 9.75 13.4286 10.1369 13.4286 10.5937V14.1092L12.8572 14.1094V6.09375C12.8572 5.62776 12.4734 5.25 12 5.25Z"
          />
          <path d="M4.05917 7.78125L4.46323 7.3835L3.09384 6.0355L5.14286 6.0355V5.473L3.09384 5.473L4.46323 4.125L4.05917 3.72725L2 5.75425L4.05917 7.78125Z" />
          <path d="M5.93519 5.473V6.0355H6.85714V5.473L5.93519 5.473Z" />
          <path d="M7.93519 6.0355L7.36376 6.0355V5.473H7.93519V6.0355Z" />
          <path d="M19.5368 7.3835L19.9408 7.78125L22 5.75425L19.9408 3.72725L19.5368 4.125L20.9062 5.473L18.8571 5.473V6.0355L20.9062 6.0355L19.5368 7.3835Z" />
          <path d="M18.0648 6.0355V5.473L17.1429 5.473V6.0355H18.0648Z" />
          <path d="M16.6362 6.0355L16.0648 6.0355V5.473H16.6362V6.0355Z" />
        </g>
      </g>
    </>
  ),
  'hand-wave': () => (
    <>
      <g id="hand-wave">
        <g id="path">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 4C5.79102 4 4 5.79102 4 8H2C2 4.68645 4.68645 2 8 2V4Z"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 20C18.209 20 20 18.209 20 16H22C22 19.3135 19.3135 22 16 22V20Z"
          />
          <path d="M14.7767 17.194C13.3965 19.3647 10.66 19.8716 8.40859 18.3725C7.42565 17.718 6.69459 16.4736 6.40674 14.9573L6.17341 13.7333L5.35109 10.0629C5.29612 9.37476 5.77756 9.18408 5.9198 9.14464L5.95929 9.13441C6.11573 9.08636 6.45962 9.11738 6.64694 9.58307L7.0743 10.9086C7.13025 11.08 7.25262 11.4355 7.65825 11.4923C8.05994 11.5499 8.27383 11.2326 8.34259 11.1292L11.5155 6.14327C11.6965 5.85863 12.0711 5.77938 12.3518 5.96633C12.6326 6.15328 12.7135 6.53583 12.5325 6.82047L10.2439 10.4198C10.0564 10.7147 10.1405 11.112 10.4314 11.3057C10.7222 11.4994 11.1113 11.4171 11.2988 11.1222L14.3519 6.32056C14.4456 6.17311 14.5902 6.07755 14.7607 6.05081C14.9309 6.02417 15.1002 6.06967 15.2374 6.17948C15.4766 6.37524 15.5237 6.75372 15.3404 7.04259L12.3162 11.7989C12.1286 12.0938 12.2127 12.4911 12.5036 12.6848C12.7945 12.8785 13.1835 12.7962 13.371 12.5013L15.9086 8.51033C16.0024 8.36287 16.1469 8.26731 16.3175 8.24058C16.4876 8.21393 16.6591 8.26086 16.7928 8.37141C17.0319 8.56716 17.0791 8.94565 16.8958 9.23452L14.3853 13.1828C14.1978 13.4777 14.2818 13.875 14.5727 14.0687C14.8636 14.2624 15.2526 14.1801 15.4402 13.8852L16.8887 11.6069C17.0697 11.3223 17.4443 11.2431 17.7251 11.43C18.0058 11.617 18.0868 11.9995 17.9058 12.2841L14.7819 17.1971L14.7781 17.1941L14.7767 17.194Z" />
        </g>
      </g>
    </>
  ),
  bauble: () => (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4245 3.1494L13.4245 3.15088H14.1091C14.3244 3.15088 14.499 3.32545 14.499 3.5408V5.64525C18.0386 6.60241 20.6428 9.83649 20.6428 13.6788C20.6428 18.2746 16.9172 22.0002 12.3214 22.0002C7.72561 22.0002 4 18.2746 4 13.6788C4 9.83692 6.60357 6.60313 10.1426 5.64557V3.5408C10.1426 3.32545 10.3172 3.15088 10.5325 3.15088H11.0693L11.0693 3.1494C11.0693 2.51519 11.5971 2 12.2469 2C12.8968 2 13.4245 2.51519 13.4245 3.1494ZM12.2469 2.47135C12.6368 2.47135 12.9547 2.77666 12.9547 3.15088H11.5391C11.5392 2.77666 11.857 2.47135 12.2469 2.47135ZM18.6428 13.6788C18.6428 17.17 15.8126 20.0002 12.3214 20.0002C8.83018 20.0002 6 17.17 6 13.6788C6 10.1876 8.83018 7.35742 12.3214 7.35742C15.8126 7.35742 18.6428 10.1876 18.6428 13.6788Z"
    />
  ),
};

export default svgs;
